function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    style: {
      enableBackground: "new 0 0 5200 4000"
    },
    viewBox: "0 0 5200 4000",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "4379.042,3055.002 4379.042,1487.804 4428.75,1487.804 4428.75,1187.333         771.198,1187.333 771.198,3383.785 4428.75,3383.785 4428.75,3055.002       ",
    style: {
      fill: "#FADAA3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 60.15,
    style: {
      fill: "#FACB9A"
    },
    width: 3657.552,
    x: 771.198,
    y: 3383.785
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4428.75,1187.333 771.198,1187.333 771.198,1948.582 4428.75,1308.8       ",
    style: {
      fill: "#FACB94"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 301.384,
    style: {
      fill: "#C1C1C1"
    },
    width: 2148.96,
    x: 878.052,
    y: 3082.401
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.052,3326.854c460.649-161.836,2148.96-244.453,2148.96-244.453H878.052V3326.854z",
    style: {
      fill: "#BAB8B8"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "2770.311,3082.401 2764.36,3082.401 2764.36,3383.785 2770.311,3383.785          2770.311,3082.401        ",
    style: {
      fill: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 5.951,
    style: {
      fill: "#ADADAD"
    },
    width: 2148.96,
    x: 878.052,
    y: 3230.117
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2537.51,3082.401 2531.559,3082.401 2531.559,3383.785 2537.51,3383.785          2537.51,3082.401        ",
    style: {
      fill: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2304.709,3082.401 2298.759,3082.401 2298.759,3383.785 2304.709,3383.785          2304.709,3082.401        ",
    style: {
      fill: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2071.909,3082.401 2065.958,3082.401 2065.958,3383.785 2071.909,3383.785          2071.909,3082.401        ",
    style: {
      fill: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1839.108,3082.401 1833.157,3082.401 1833.157,3383.785 1839.108,3383.785          1839.108,3082.401        ",
    style: {
      fill: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1606.307,3082.401 1600.356,3082.401 1600.356,3383.785 1606.307,3383.785          1606.307,3082.401        ",
    style: {
      fill: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1373.506,3082.401 1367.555,3082.401 1367.555,3383.785 1373.506,3383.785          1373.506,3082.401        ",
    style: {
      fill: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1140.706,3082.401 1134.755,3082.401 1134.755,3383.785 1140.706,3383.785          1140.706,3082.401        ",
    style: {
      fill: "#ADADAD"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "4379.042,3055.002 4379.042,1487.804 4428.75,1487.804 4428.75,1460.406         4047.336,1460.406 4047.336,3082.401 4428.75,3082.401 4428.75,3055.002       ",
    style: {
      fill: "#BA835A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 1555.99,
    style: {
      fill: "#D2E5FC"
    },
    width: 319.779,
    x: 4078.388,
    y: 1487.804
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "4078.387,2885.028 4398.167,2756.824 4398.167,2507.099 4078.387,2635.303                     ",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4078.387,2406.394 4398.167,2278.19 4398.167,1655.299 4078.387,1783.503                     ",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4078.387,1705.584 4398.167,1577.38 4398.167,1487.804 4078.387,1487.804                     ",
    style: {
      fill: "#FFFFFF"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 22.415,
    style: {
      fill: "#A36F48"
    },
    width: 319.78,
    x: 4078.387,
    y: 1487.602
  }), /*#__PURE__*/React.createElement("rect", {
    height: 22.415,
    style: {
      fill: "#A36F48"
    },
    width: 321.763,
    x: 4076.404,
    y: 3032.587
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1556.192,
    style: {
      fill: "#A36F48"
    },
    width: 26.382,
    x: 4076.404,
    y: 1487.602
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 1621.995,
    style: {
      fill: "#BA835A"
    },
    width: 2148.96,
    x: 878.052,
    y: 1460.406
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 1567.198,
    style: {
      fill: "#D2E5FC"
    },
    width: 2086.857,
    x: 909.104,
    y: 1487.804
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "909.104,1987.739 909.104,2396.191 2995.961,1559.54 2995.961,1487.804            2156.091,1487.804          ",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "909.104,2976.195 2995.961,2139.544 2995.961,1889.819 909.104,2726.47                     ",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2995.961,2840.354 2995.961,2217.463 909.104,3054.114 909.104,3055.002            2460.565,3055.002          ",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 31.053,
    style: {
      fill: "#A9CEFC"
    },
    width: 1108.483,
    x: 1000.133,
    y: 1816.477
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2108.616,1847.53 2108.616,1816.477 1336.282,1816.477 1258.827,1847.53                         ",
    style: {
      fill: "#D2E5FC"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 160.043,
    style: {
      fill: "#9AC6FC"
    },
    width: 108.686,
    x: 1049.402,
    y: 1656.434
  }), /*#__PURE__*/React.createElement("rect", {
    height: 93.159,
    style: {
      fill: "#A9CEFC"
    },
    width: 82.41,
    x: 1222.583,
    y: 1723.318
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 93.159,
    style: {
      fill: "#9AC6FC"
    },
    width: 82.41,
    x: 1326.491,
    y: 1723.318
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1408.901,1816.477 1408.901,1787.363 1336.282,1816.477             ",
    style: {
      fill: "#D2E5FC"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    height: 93.159,
    style: {
      fill: "#D2E5FC"
    },
    width: 82.41,
    x: 1745.708,
    y: 1723.318
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1676.492,1816.477h-87.302c-5.484,0-9.554-5.083-8.356-10.434l33.495-149.609h37.025              l33.495,149.609C1686.047,1811.395,1681.976,1816.477,1676.492,1816.477z",
    style: {
      fill: "#A9CEFC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1589.191,1816.477h87.302c5.484,0,9.554-5.083,8.356-10.434l-26.566-118.661              l-55.9,22.411l-21.548,96.25C1579.636,1811.395,1583.707,1816.477,1589.191,1816.477z",
    style: {
      fill: "#D2E5FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1654.207,1662.804h-42.731c-2.235,0-4.048-1.812-4.048-4.047v-4.645              c0-2.235,1.812-4.047,4.048-4.047h42.731c2.235,0,4.047,1.812,4.047,4.047v4.645              C1658.255,1660.992,1656.443,1662.804,1654.207,1662.804z",
    style: {
      fill: "#9AC6FC"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 31.053,
    style: {
      fill: "#A9CEFC"
    },
    width: 1108.483,
    x: 1000.133,
    y: 2052.958
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1000.133,2052.958 1000.133,2084.011 1687.773,2084.011 1765.229,2052.958                         ",
    style: {
      fill: "#D2E5FC"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 160.043,
    style: {
      fill: "#D2E5FC"
    },
    width: 108.686,
    x: 1283.494,
    y: 1892.916
  }), /*#__PURE__*/React.createElement("rect", {
    height: 160.043,
    style: {
      fill: "#D2E5FC"
    },
    width: 108.686,
    x: 1630.716,
    y: 1892.916
  }), /*#__PURE__*/React.createElement("rect", {
    height: 93.159,
    style: {
      fill: "#D2E5FC"
    },
    width: 82.41,
    x: 1420.446,
    y: 1959.799
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1199.613,2052.958h-87.302c-5.484,0-9.554-5.082-8.356-10.434l33.495-149.609h37.025              l33.495,149.609C1209.167,2047.876,1205.097,2052.958,1199.613,2052.958z",
    style: {
      fill: "#D2E5FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.328,1899.286h-42.731c-2.235,0-4.047-1.812-4.047-4.048v-4.645              c0-2.235,1.812-4.047,4.047-4.047h42.731c2.235,0,4.047,1.812,4.047,4.047v4.645              C1181.375,1897.473,1179.563,1899.286,1177.328,1899.286z",
    style: {
      fill: "#9AC6FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.596,1899.285h42.731c2.235,0,4.047-1.812,4.047-4.047v-4.645              c0-2.235-1.812-4.048-4.047-4.048h-15.818l-29.463,11.812C1132.745,1898.929,1133.625,1899.285,1134.596,1899.285z",
    style: {
      fill: "#D2E5FC"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1858.824,2052.958h-53.885c-3.385,0-5.897-3.137-5.158-6.44l20.674-92.342h22.853               l20.674,92.342C1864.722,2049.821,1862.209,2052.958,1858.824,2052.958z",
    style: {
      fill: "#A9CEFC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1857.171,2016.097 1843.308,1954.176 1820.456,1954.176 1801.605,2038.375                             ",
    style: {
      fill: "#D2E5FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845.069,1958.108h-26.375c-1.38,0-2.498-1.118-2.498-2.498v-2.867               c0-1.38,1.119-2.498,2.498-2.498h26.375c1.38,0,2.498,1.119,2.498,2.498v2.867               C1847.568,1956.989,1846.449,1958.108,1845.069,1958.108z",
    style: {
      fill: "#D2E5FC"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1974.818,2052.958h-87.302c-5.484,0-9.554-5.082-8.356-10.434l33.495-149.609h37.025               l33.495,149.609C1984.372,2047.876,1980.302,2052.958,1974.818,2052.958z",
    style: {
      fill: "#9AC6FC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1967.367,1971.919 1949.679,1892.916 1912.655,1892.916 1887.828,2003.807                             ",
    style: {
      fill: "#D2E5FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1952.532,1899.286h-42.731c-2.235,0-4.047-1.812-4.047-4.048v-4.645               c0-2.235,1.812-4.047,4.047-4.047h42.731c2.235,0,4.048,1.812,4.048,4.047v4.645               C1956.58,1897.473,1954.768,1899.286,1952.532,1899.286z",
    style: {
      fill: "#D2E5FC"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 403.277,
    style: {
      fill: "#A9CEFC"
    },
    width: 1336.239,
    x: 909.104,
    y: 2651.726
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2245.344,2651.726 1912.781,2651.726 909.104,3054.114 909.104,3055.002              2245.344,3055.002            ",
    style: {
      fill: "#D2E5FC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1095.539,2651.726 909.104,2726.47 909.104,2976.195 1718.428,2651.726                         ",
    style: {
      fill: "#D2E5FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2245.344,2651.726c0,0-870.992,88.72-974.327,135.698             c-103.335,46.978-248.002,267.579-248.002,267.579H909.104v-403.276H2245.344z",
    style: {
      fill: "#9AC6FC"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1068.738,2990.115l-159.634,64v0.888h113.911              C1023.019,3054.996,1040.969,3027.625,1068.738,2990.115z",
    style: {
      fill: "#B5D5FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2245.344,2651.726h-332.562l-129.425,51.888              C2018.978,2674.783,2245.344,2651.726,2245.344,2651.726z",
    style: {
      fill: "#B5D5FC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1271.017,2787.423c28.022-12.74,112.5-28.549,220.749-44.826l226.662-90.872h-622.89             l-186.434,74.744v249.726l255.244-102.331C1200.043,2835.805,1237.681,2802.579,1271.017,2787.423z",
    style: {
      fill: "#B5D5FC"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 54.144,
    style: {
      fill: "#A9CEFC"
    },
    width: 1407.9,
    x: 909.104,
    y: 2597.582
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2317.005,2651.726 2317.005,2597.582 2047.832,2597.582 1912.781,2651.726                         ",
    style: {
      fill: "#D2E5FC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1853.479,2597.582 1230.59,2597.582 1095.539,2651.726 1718.428,2651.726                         ",
    style: {
      fill: "#D2E5FC"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1207.118,2482.569v-42.287c0-7.468,3.607-14.476,9.684-18.817             c9.663-6.902,15.398-18.046,15.398-29.921v-26.861c0-33.641-27.271-60.912-60.912-60.912h-70.467             c-33.641,0-60.912,27.271-60.912,60.912v26.861c0,11.875,5.735,23.019,15.398,29.921             c6.077,4.341,9.684,11.349,9.684,18.817v42.287c0,7.468-3.607,14.476-9.684,18.817             c-9.663,6.902-15.398,18.046-15.398,29.921v57.45c0,4.874,3.951,8.825,8.825,8.825h174.64             c4.874,0,8.825-3.951,8.825-8.825v-57.45c0-11.875-5.735-23.019-15.398-29.921             C1210.725,2497.046,1207.118,2490.037,1207.118,2482.569z",
    style: {
      fill: "#A9CEFC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.295,2341.991l95.33-38.219h-38.804             C1075.204,2303.772,1053.296,2319.593,1044.295,2341.991z",
    style: {
      fill: "#D2E5FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207.716,2597.582h-143.322v-26.508c0-5.295,4.293-9.588,9.588-9.588h124.146             c5.295,0,9.588,4.293,9.588,9.588V2597.582z",
    style: {
      fill: "#9AC6FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183.762,2561.486h-95.415v-141.729c0-6.743,5.466-12.209,12.209-12.209h70.997             c6.743,0,12.209,5.466,12.209,12.209V2561.486z",
    style: {
      fill: "#81B8FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.411,2430.904h-46.712c-4.654,0-8.427-3.773-8.427-8.427v-130.92             c0-6.833,5.54-12.373,12.373-12.373h38.821c6.833,0,12.373,5.539,12.373,12.373v130.92             C1167.838,2427.131,1164.065,2430.904,1159.411,2430.904z",
    style: {
      fill: "#9AC6FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.838,2292.461v-0.904c0-6.833-5.54-12.372-12.373-12.372h-38.821             c-6.833,0-12.373,5.539-12.373,12.372v26.389L1167.838,2292.461z",
    style: {
      fill: "#B5D5FC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1143.552,2470.981 1128.557,2470.981 1124.974,2430.904 1147.135,2430.904                         ",
    style: {
      fill: "#9AC6FC"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 16.455,
    style: {
      fill: "#A9CEFC"
    },
    width: 27.072,
    x: 1012.838,
    y: 2368.665
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.505,2464.08h9.024c2.932,0,5.308-2.376,5.308-5.308v-97.34             c0-2.748-2.228-4.976-4.976-4.976h-9.688c-2.748,0-4.976,2.228-4.976,4.976v97.34             C993.197,2461.703,995.574,2464.08,998.505,2464.08z",
    style: {
      fill: "#A9CEFC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.144,2356.484c-0.096-0.005-0.186-0.029-0.283-0.029h-9.688             c-2.748,0-4.976,2.228-4.976,4.976v1.045L1008.144,2356.484z",
    style: {
      fill: "#D2E5FC"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1828.118,2280.283v36.394c0,5.515,4.471,9.986,9.986,9.986h142.149             c3.805,0,6.889,3.084,6.889,6.889v210.428c0,3.805-3.084,6.889-6.889,6.889h-143.376c-4.837,0-8.759,3.921-8.759,8.759             v22.427c0,8.575,6.951,15.526,15.526,15.526h310.531c8.575,0,15.527-6.951,15.527-15.526v-313.318             c0-22.867-18.537-41.404-41.404-41.404h-247.23C1851.824,2227.333,1828.118,2251.04,1828.118,2280.283z",
    style: {
      fill: "#A9CEFC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2047.833,2597.582h106.342c8.575,0,15.527-6.952,15.527-15.527v-33.333             L2047.833,2597.582z",
    style: {
      fill: "#D2E5FC"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1980.252,2326.663c3.805,0,6.889,3.084,6.889,6.889v210.428              c-0.001,0.015,182.56-73.176,182.56-73.176v-202.066c0-16.863-10.086-31.36-24.55-37.817l-238.81,95.742H1980.252z",
    style: {
      fill: "#D2E5FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.876,2550.869c-4.837,0-8.758,3.921-8.758,8.759v22.427              c0,8.575,6.951,15.527,15.526,15.527h9.835l116.515-46.712H1836.876z",
    style: {
      fill: "#D2E5FC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2128.297,2227.333h-247.23c-29.243,0-52.949,23.706-52.949,52.949v36.394             c0,5.515,4.471,9.986,9.986,9.986h331.598v-57.926C2169.701,2245.871,2151.164,2227.333,2128.297,2227.333z",
    style: {
      fill: "#A9CEFC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2169.701,2326.663v-57.926c0-16.863-10.086-31.36-24.55-37.817l-238.81,95.742H2169.701z             ",
    style: {
      fill: "#D2E5FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2137.454,2544.234h-25.479c-6.816,0-12.342-5.526-12.342-12.342v-168.801             c0-6.816,5.526-12.342,12.342-12.342h25.479c6.816,0,12.342,5.525,12.342,12.342v168.801             C2149.796,2538.708,2144.27,2544.234,2137.454,2544.234z",
    style: {
      fill: "#9AC6FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2137.454,2350.75h-25.479c-6.816,0-12.342,5.525-12.342,12.342v135.804l50.163-20.111             v-115.693C2149.796,2356.275,2144.27,2350.75,2137.454,2350.75z",
    style: {
      fill: "#B5D5FC"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2132.979,2853.364h-264.556c-18.302,0-33.139-14.837-33.139-33.139v-11.044               c0-8.685,7.041-15.726,15.726-15.726h299.384c8.685,0,15.726,7.041,15.726,15.726v11.044               C2166.118,2838.527,2151.281,2853.364,2132.979,2853.364z",
    style: {
      fill: "#BBD8FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1839.043,2835.552c5.533,10.584,16.609,17.812,29.38,17.812h264.556               c12.77,0,23.846-7.228,29.379-17.812H1839.043z",
    style: {
      fill: "#ACD0FC"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    height: 77.648,
    style: {
      fill: "#ACD0FC"
    },
    width: 31.451,
    x: 1984.975,
    y: 2853.364
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2061.377,2947.998h-121.351c-3.978,0-7.203-3.225-7.203-7.203v-5.706               c0-2.251,1.825-4.077,4.077-4.077h127.604c2.251,0,4.077,1.825,4.077,4.077v5.706               C2068.58,2944.773,2065.355,2947.998,2061.377,2947.998z",
    style: {
      fill: "#BBD8FC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2060.801,2947.998 2034.828,2947.998 2059.789,3055.002 2082.068,3055.002                             ",
    style: {
      fill: "#ACD0FC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1989.607,3055.002 2011.795,3055.002 2013.039,2947.998 1988.363,2947.998                             ",
    style: {
      fill: "#ACD0FC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1919.334,3055.002 1941.613,3055.002 1966.574,2947.998 1940.601,2947.998                             ",
    style: {
      fill: "#ACD0FC"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1706.198,2853.364h-264.556c-18.302,0-33.139-14.837-33.139-33.139v-11.044               c0-8.685,7.041-15.726,15.725-15.726h299.384c8.685,0,15.725,7.041,15.725,15.726v11.044               C1739.338,2838.527,1724.501,2853.364,1706.198,2853.364z",
    style: {
      fill: "#BBD8FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.263,2835.552c5.533,10.584,16.609,17.812,29.38,17.812h264.556               c12.77,0,23.846-7.228,29.38-17.812H1412.263z",
    style: {
      fill: "#ACD0FC"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    height: 77.648,
    style: {
      fill: "#ACD0FC"
    },
    width: 31.451,
    x: 1558.195,
    y: 2853.364
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1634.596,2947.998h-121.351c-3.978,0-7.203-3.225-7.203-7.203v-5.706               c0-2.251,1.825-4.077,4.077-4.077h127.604c2.252,0,4.077,1.825,4.077,4.077v5.706               C1641.799,2944.773,1638.574,2947.998,1634.596,2947.998z",
    style: {
      fill: "#BBD8FC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1634.02,2947.998 1608.047,2947.998 1633.008,3055.002 1655.287,3055.002                             ",
    style: {
      fill: "#ACD0FC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1562.826,3055.002 1585.015,3055.002 1586.258,2947.998 1561.583,2947.998                             ",
    style: {
      fill: "#ACD0FC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1492.554,3055.002 1514.832,3055.002 1539.794,2947.998 1513.82,2947.998                             ",
    style: {
      fill: "#ACD0FC"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1279.417,2853.364h-264.556c-18.302,0-33.139-14.837-33.139-33.139v-11.044               c0-8.685,7.041-15.726,15.726-15.726h299.383c8.685,0,15.726,7.041,15.726,15.726v11.044               C1312.557,2838.527,1297.72,2853.364,1279.417,2853.364z",
    style: {
      fill: "#BBD8FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.482,2835.552c5.533,10.584,16.609,17.812,29.38,17.812h264.556               c12.77,0,23.846-7.228,29.38-17.812H985.482z",
    style: {
      fill: "#ACD0FC"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    height: 77.648,
    style: {
      fill: "#8DBFFC"
    },
    width: 31.451,
    x: 1131.414,
    y: 2853.364
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1207.815,2947.998h-121.351c-3.978,0-7.203-3.225-7.203-7.203v-5.706               c0-2.251,1.825-4.077,4.077-4.077h127.604c2.251,0,4.077,1.825,4.077,4.077v5.706               C1215.018,2944.773,1211.793,2947.998,1207.815,2947.998z",
    style: {
      fill: "#BBD8FC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1207.239,2947.998 1181.266,2947.998 1206.227,3055.002 1228.506,3055.002                             ",
    style: {
      fill: "#ACD0FC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1136.045,3055.002 1158.234,3055.002 1159.477,2947.998 1134.802,2947.998                             ",
    style: {
      fill: "#ACD0FC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1065.773,3055.002 1088.052,3055.002 1113.013,2947.998 1087.04,2947.998                             ",
    style: {
      fill: "#ACD0FC"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 481.721,
    style: {
      fill: "#A9CEFC"
    },
    width: 343.077,
    x: 2317.005,
    y: 1950.244
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2660.082,2352.122 2460.929,2431.965 2660.082,2431.965           ",
    style: {
      fill: "#D2E5FC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2317.005,2411.748 2660.082,2274.203 2660.082,2024.478 2317.005,2162.022                       ",
    style: {
      fill: "#D2E5FC"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 324.067,
    style: {
      fill: "#9AC6FC"
    },
    width: 90.074,
    x: 2350.695,
    y: 2072.068
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2440.769,2112.404 2350.695,2148.515 2350.695,2396.135 2355.948,2396.135              2440.769,2362.129            ",
    style: {
      fill: "#B5D5FC"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 78.031,
    style: {
      fill: "#9AC6FC"
    },
    width: 275.696,
    x: 2350.695,
    y: 1974.928
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2626.391,2037.985 2589.043,2052.958 2626.391,2052.958            ",
    style: {
      fill: "#B5D5FC"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 324.067,
    style: {
      fill: "#9AC6FC"
    },
    width: 164.223,
    x: 2462.168,
    y: 2072.068
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2626.391,2365.629 2550.301,2396.135 2626.391,2396.135            ",
    style: {
      fill: "#B5D5FC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2462.168,2353.55 2626.391,2287.71 2626.391,2072.068 2541.378,2072.068              2462.168,2103.824            ",
    style: {
      fill: "#B5D5FC"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 24.399,
    style: {
      fill: "#A36F48"
    },
    width: 2090.824,
    x: 907.121,
    y: 1485.619
  }), /*#__PURE__*/React.createElement("rect", {
    height: 24.399,
    style: {
      fill: "#A36F48"
    },
    width: 2090.824,
    x: 907.121,
    y: 3032.587
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1559.168,
    style: {
      fill: "#A36F48"
    },
    width: 24.399,
    x: 907.121,
    y: 1485.619
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1559.168,
    style: {
      fill: "#A36F48"
    },
    width: 24.399,
    x: 2973.546,
    y: 1485.619
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 1923.379,
    style: {
      fill: "#BA835A"
    },
    width: 823.783,
    x: 3125.648,
    y: 1460.406
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 1895.98,
    style: {
      fill: "#D2E5FC"
    },
    width: 757.114,
    x: 3158.983,
    y: 1487.804
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "3158.983,2074.187 3916.096,1770.649 3916.096,1520.924 3158.983,1824.461                   ",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3158.983,2774.997 3916.096,2471.459 3916.096,1848.568 3158.983,2152.106                   ",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3158.983,3253.63 3916.096,2950.093 3916.096,2700.368 3158.983,3003.905                   ",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 22.415,
    style: {
      fill: "#A36F48"
    },
    width: 757.114,
    x: 3158.983,
    y: 1487.602
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1896.182,
    style: {
      fill: "#A36F48"
    },
    width: 24.399,
    x: 3156.999,
    y: 1487.602
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1896.182,
    style: {
      fill: "#A36F48"
    },
    width: 24.399,
    x: 3893.681,
    y: 1487.602
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3274.161,2645.488v-47.005c0-22.682,1.564-45.338,4.683-67.805l4.688-33.774         c0.177-1.274,0.265-2.558,0.265-3.844v-123.237c0-15.442-12.518-27.96-27.96-27.96s-27.96,12.518-27.96,27.96v123.237         c0,1.286,0.089,2.57,0.265,3.844l4.688,33.775c3.118,22.467,4.683,45.121,4.683,67.803v47.007         c0,22.682-1.565,45.337-4.683,67.803l-4.688,33.775c-0.177,1.273-0.265,2.558-0.265,3.844v123.237         c0,15.442,12.518,27.96,27.96,27.96s27.96-12.518,27.96-27.96V2750.91c0-1.286-0.089-2.57-0.265-3.844l-4.688-33.774         C3275.726,2690.825,3274.161,2668.17,3274.161,2645.488z",
    style: {
      fill: "#BA835A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3255.837,2341.863c-15.442,0-27.96,12.518-27.96,27.96v123.237         c0,1.286,0.089,2.57,0.265,3.844l4.688,33.775c3.118,22.467,4.683,45.121,4.683,67.803v47.007         c0,22.682-1.564,45.337-4.683,67.803l-3.341,24.072c26.348-14.032,26.348-145.394,26.348-145.394s0-141.941,0-185.141         c0-26.841,15.898-35.301,27.939-37.861C3283.322,2353.922,3270.992,2341.863,3255.837,2341.863z",
    style: {
      fill: "#CC9063"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    height: 27.602,
    style: {
      fill: "#BA835A"
    },
    width: 777.907,
    x: 3148.586,
    y: 1650.065
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "4499.073,1108.791 700.875,1108.791 746.539,1187.333 4453.409,1187.333      ",
    style: {
      fill: "#733636"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 53.884,
    style: {
      fill: "#8B4949"
    },
    width: 3798.198,
    x: 700.875,
    y: 1054.907
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "596.761,991.89 700.875,1054.907 4499.073,1054.907 4603.188,991.89      ",
    style: {
      fill: "#DEB3B1"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 63.017,
    style: {
      fill: "#BA7B56"
    },
    width: 3706.869,
    x: 746.539,
    y: 991.89
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 131.489,
    style: {
      fill: "#D1A07B"
    },
    width: 3706.869,
    x: 746.539,
    y: 492.859
  }), /*#__PURE__*/React.createElement("rect", {
    height: 31.303,
    style: {
      fill: "#FAE9E8"
    },
    width: 3706.869,
    x: 746.539,
    y: 486.215
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 414.395,
    style: {
      fill: "#F6E1E0"
    },
    width: 4006.427,
    x: 596.761,
    y: 577.495
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.761,577.495v309.85c38.231-16.967,91.544-33.976,153.994-35.697         c127.978-3.526,488.848,59.95,636.377-91.689s634.183,59.95,912.776-31.738c249.884-82.24,477.067-4.182,582.311-150.726         H596.761z",
    style: {
      fill: "#FAE9E8"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1610.032,873.422c-28.037,22.046-62.88,29.924-97.452,20.747         c-29.754-8.681-39.032-39.124-38.828-68.33c3.26-38.97-13.829-115.119,29.311-136.279c22.513-11.697,56.963-9.834,78.8,2.896         c2.744,53.826-13.177,46.352,33.119,46.59c0-9.641,0-19.795,0-30.453c-1.11-10.475,2.487-27.704-1.902-34.642         c-19.459-18.836-47.545-25.278-76.136-25.124c-59.723-1.734-101.911,40.384-99.734,100.118         c2.573,45.389-11.208,120.667,25.884,154.739c32.392,32.526,92.317,33.386,132.854,15.039         c27.748-13.314,18.846-19.37,20.175-45.301H1610.032z",
    style: {
      fill: "#BA835A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1761.157,648.826c35.757,0.029,67.391,14.313,84.89,45.871         c19.292,28.414,11.44,100.138,12.944,134.949c5.429,134.547-201.822,134.674-196.427-0.002         c1.651-35.056-6.462-106.334,13.133-134.946C1693.413,663.181,1725.358,648.86,1761.157,648.826z M1697.204,828.883         c-2.879,56.758,48.78,85.664,96.502,61.479c44.354-23.937,27.632-99.158,30.644-140.659         c1.638-40.016-21.39-70.42-63.194-68.9C1676.55,680.102,1700.659,773.612,1697.204,828.883z",
    style: {
      fill: "#BA835A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2070.45,658.533c-0.903-1.422-1.728-2.113-3.616-2.093h-165.592         c1.956,33.43-9.2,32.648,22.84,31.976c0,56.183,0,112.052,0,168.257c0.528,21.16-1.034,42.946,0.57,64.143         c4.257,4.77,27.73,0.914,35.594,2.094c0-36.695,0-72.382,0-110.014h94.787c-0.867-10.003,1.796-20.969-1.14-30.454         c-0.763-0.761-1.78-1.142-3.047-1.142h-90.6c0-31,0-61.841,0-92.884h110.775         C2070.544,677.997,2071.982,668.676,2070.45,658.533z",
    style: {
      fill: "#BA835A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2279.815,658.533c-0.903-1.422-1.728-2.113-3.616-2.093h-165.592         c1.956,33.43-9.201,32.648,22.84,31.976c0,56.183,0,112.052,0,168.257c0.528,21.16-1.033,42.946,0.57,64.143         c4.257,4.77,27.73,0.914,35.594,2.094c0-36.695,0-72.382,0-110.014h94.787c-0.867-10.003,1.796-20.969-1.14-30.454         c-0.763-0.761-1.78-1.142-3.047-1.142h-90.6c0-31,0-61.841,0-92.884h110.775         C2279.908,677.997,2281.347,668.676,2279.815,658.533z",
    style: {
      fill: "#BA835A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2490.701,658.533c-0.904-1.422-1.727-2.113-3.616-2.093h-174.728         c1.969,33.343-9.235,32.671,22.84,31.976c0,62.106,0,127.627,0,189.194c0,15.226,0,28.93,0,41.112         c-0.013,1.033,0.607,2.135,1.333,2.854c1.744,3.821,151.994,0.047,154.742,1.333c-0.873-10.397,1.807-21.025-1.14-30.835         c-0.763-0.761-1.78-1.142-3.047-1.142h-115.724c0-27.947,0-58.591,0-87.173h99.355c-1.062-6.778,2.498-27.446-2.092-30.645         c-1.615-1.627-95.254-0.026-97.263-0.57c0-28.544,0-56.453,0-84.129h119.911         C2490.789,677.223,2492.242,669.415,2490.701,658.533z",
    style: {
      fill: "#BA835A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2700.066,658.533c-0.903-1.422-1.727-2.113-3.616-2.093h-174.728         c1.969,33.343-9.235,32.671,22.84,31.976c0,62.106,0,127.627,0,189.194c0,15.226,0,28.93,0,41.112         c-0.013,1.033,0.608,2.135,1.333,2.854c1.744,3.821,151.994,0.047,154.742,1.333c-0.873-10.397,1.807-21.025-1.14-30.835         c-0.763-0.761-1.78-1.142-3.047-1.142h-115.724c0-27.947,0-58.591,0-87.173h99.355c-1.062-6.778,2.498-27.446-2.092-30.645         c-1.615-1.627-95.254-0.026-97.263-0.57c0-28.544,0-56.453,0-84.129h119.911         C2700.154,677.223,2701.607,669.415,2700.066,658.533z",
    style: {
      fill: "#BA835A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3036.189,821.46c-12.988-36.141-63.368-40.954-96.119-52.343         c-22.622-6.358-39.644-15.513-38.828-39.589c-6.444-52.634,64.493-55.478,98.594-40.087         c2.129,42.914-11.764,37.48,33.879,37.423c-1.321-10.083,3.281-52.791-3.043-55.959         c-17.41-16.582-45.808-21.157-73.091-21.319c-51.819-0.441-97.178,28.251-90.979,84.13         c-3.055,65.732,80.268,65.703,123.147,87.172c15.25,7.638,15.591,22.156,15.035,37.308         c-1.935,58.822-105.985,43.15-136.28,14.845h-5.71c1.159,9.22-2.718,28.051,2.282,34.642         c21.132,17.904,53.198,21.594,81.846,22.079C3018.855,929.792,3052.036,890.124,3036.189,821.46z",
    style: {
      fill: "#BA835A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3280.386,659.104c-2.628-5.598-28.528-1.469-35.783-2.665c0,38.735,0,77.344,0,116.104         c-8.96,0-101.403,0-112.678,0c0-37.354,0-74.583,0-111.917c0.031-2.507-1.68-4.218-4.187-4.187c-10.658,0-21.317,0-31.977,0         c0,62.696,0,125.359,0,188.052c0.535,25.509-1.045,51.274,0.57,76.324c4.088,4.773,27.83,0.91,35.594,2.094         c0-39.491,0-78.857,0-118.388h112.678c0,38.123,0,76.111,0,114.201c-1.592,7.814,29.896,2.901,36.164,4.187         C3280.39,835.142,3281.492,746.795,3280.386,659.104z",
    style: {
      fill: "#BA835A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3436.079,648.826c35.757,0.029,67.391,14.313,84.89,45.871         c19.292,28.414,11.44,100.138,12.944,134.949c5.428,134.547-201.822,134.674-196.427-0.002         c1.651-35.056-6.462-106.334,13.133-134.946C3368.335,663.181,3400.28,648.86,3436.079,648.826z M3372.126,828.883         c-2.879,56.759,48.78,85.664,96.501,61.479c44.354-23.938,27.632-99.158,30.644-140.659         c1.638-40.016-21.391-70.42-63.194-68.9C3351.473,680.102,3375.581,773.612,3372.126,828.883z",
    style: {
      fill: "#BA835A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3760.598,701.93c-10.393-35.529-48.789-45.583-82.416-45.49         c-33.955,0-72.926-0.001-107.348,0c2.184,31.87-9.818,32.6,22.84,31.595c0,56.521,0,112.544,0,169.018         c1.018,21.035-2.015,43.798,1.139,64.715c10.824,2.985,23.599,0.242,35.024,1.142c0-30.243,0-61.997,0-92.122         c27.872-0.867,61.166,3.052,86.983-5.139c32.101-9.184,48.583-37.231,47.773-69.854         C3764.451,740.313,3765.741,715.361,3760.598,701.93z M3727.67,755.795c1.308,55.647-60.055,41.677-97.832,43.396         c0-37.06,0-73.966,0-111.156c29.196,2.757,83.642-10.937,95.549,23.6C3729.048,721.252,3727.272,745.028,3727.67,755.795z",
    style: {
      fill: "#BA835A"
    }
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4778.16,3309.967c0,0,9.296-21.421,18.592-27.079s13.144,17.652,12.125,32.334       C4807.858,3329.903,4785.031,3323.305,4778.16,3309.967z",
    style: {
      fill: "#A8B876"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4477.996,3204.074c0,0,25.732,4.85,33.816,27.079l4.446-7.275c0,0,17.379,6.871,28.292,30.717        c0,0,6.063-15.762,10.508-18.996s26.061,25.059,26.061,25.059s5.061-14.55,9.506-17.783        c4.446-3.233,35.567,21.421,39.205,29.908c0,0,4.222-9.7,7.163-10.913c2.941-1.212,29.212,13.742,36.892,30.313        c0,0,9.227-22.634,10.878-23.846c1.651-1.213,20.105,16.159,24.216,27.479l15.427,12.533c0,0,8.463-5.467,10.699-5.563        c2.234-0.096,8.701,18.9,10.318,34.663s0,42.555,0,42.555H4428.75l0.053-193.493c0,0,12.4,4.925,23.064,15.991        c10.664,11.066,16.562,25.128,16.562,25.128L4477.996,3204.074z",
    style: {
      fill: "#7F8F4F"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4503.801,3334.444c0,0,19.202,16.371,20.814,42.764h-23.176L4503.801,3334.444z",
    style: {
      fill: "#A8B876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4661.49,3330.886c0,0,14.99-22.67,29.185-30.215c0,0,6.729,13.063,1.263,41.091         l-4.893,28.336h-28.519L4661.49,3330.886z",
    style: {
      fill: "#A8B876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4548.258,3355.369c0,0-0.745-32.333,7.069-40.147s14.55,26.136,16.437,40.147         C4573.65,3369.38,4548.258,3355.369,4548.258,3355.369z",
    style: {
      fill: "#A8B876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4491.738,3305.761c-0.486-3.251-0.652-6.51-0.694-9.769         c-0.028-3.259,0.113-6.519,0.423-9.779c0.312-3.262,0.823-6.522,1.598-9.789l0.654-2.453c0.259-0.824,0.565-1.64,0.849-2.46         c0.3-0.82,0.725-1.656,1.09-2.48c0.41-0.825,1.024-1.674,1.548-2.493c0.54-0.843,1.491-1.264,2.424-1.166l0.159,0.018         c0.592,0.063,0.923,0.129,1.346,0.21c0.41,0.074,0.783,0.17,1.17,0.268c0.756,0.211,1.504,0.425,2.22,0.694         c1.456,0.491,2.824,1.138,4.16,1.823c2.665,1.385,5.09,3.114,7.318,5.015l1.622,1.477c0.537,0.493,1.014,1.048,1.521,1.567         c1.025,1.027,1.909,2.182,2.809,3.303c0.459,0.552,0.854,1.158,1.26,1.751c0.407,0.592,0.803,1.188,1.187,1.791         c0.735,1.231,1.417,2.489,2.055,3.759c-1.125-0.898-2.174-1.834-3.226-2.75c-1.123-0.852-2.141-1.782-3.243-2.612         c-1.107-0.823-2.161-1.687-3.293-2.441c-1.096-0.799-2.23-1.524-3.362-2.238c-2.278-1.397-4.609-2.646-6.998-3.654         c-1.195-0.495-2.403-0.948-3.61-1.306c-0.602-0.198-1.209-0.335-1.804-0.473c-0.295-0.054-0.598-0.14-0.877-0.18         c-0.263-0.052-0.621-0.101-0.724-0.111l2.582-1.148c-0.301,0.558-0.658,1.005-0.952,1.622         c-0.284,0.644-0.615,1.233-0.876,1.918l-0.771,2.079l-0.689,2.176c-0.866,2.946-1.634,5.99-2.369,9.069l-2.154,9.324         C4493.354,3299.454,4492.62,3302.598,4491.738,3305.761z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4513.026,3316.569c0.473-3.43,1.214-6.821,2.116-10.175c0.921-3.349,1.982-6.677,3.333-9.927         c1.355-3.246,2.919-6.451,5.024-9.463c1.061-1.498,2.231-2.969,3.668-4.296c1.438-1.313,3.15-2.524,5.238-3.262         c0.101-0.036,0.187-0.057,0.265-0.071c0.341-0.057,0.689-0.1,1.036-0.128c0.326-0.017,0.578,0.009,0.872,0.02         c0.299,0.009,0.54,0.049,0.781,0.089c0.241,0.04,0.497,0.076,0.725,0.126c0.898,0.205,1.731,0.455,2.511,0.736         c1.567,0.558,3.011,1.217,4.413,1.914c2.805,1.385,5.452,2.928,8.046,4.534c2.603,1.591,5.115,3.295,7.615,5.007         c2.488,1.741,4.928,3.495,7.359,5.36l-4.453,1.815c0.753-3.889,1.613-7.619,3-11.469c0.367-0.964,0.758-1.926,1.342-2.961         c0.309-0.523,0.609-1.051,1.245-1.69c0.16-0.159,0.387-0.338,0.589-0.49c0.27-0.169,0.596-0.355,0.891-0.44         c0.658-0.201,1.08-0.188,1.462-0.184c1.444,0.088,2.391,0.435,3.405,0.772c0.987,0.349,1.918,0.751,2.82,1.192         c3.604,1.747,6.881,3.956,9.837,6.542c1.487,1.277,2.858,2.691,4.086,4.212c1.242,1.503,2.289,3.177,3.066,4.93         c-2.374-3.026-5.381-5.315-8.522-7.304c-3.163-1.955-6.543-3.572-9.96-4.786c-0.855-0.296-1.714-0.555-2.549-0.763         c-0.808-0.202-1.723-0.354-2.189-0.305c-0.092,0.003-0.151,0.052,0.053-0.002c0.066-0.023,0.196-0.059,0.257-0.119         c0.023,0.007,0.057-0.031,0.052-0.019c-0.032,0.046-0.216,0.352-0.354,0.667c-0.301,0.654-0.577,1.484-0.816,2.326         c-0.961,3.405-1.614,7.169-2.159,10.785c-0.229,1.527-1.654,2.578-3.181,2.349c-0.438-0.066-0.836-0.23-1.177-0.466         l-0.095-0.067c-2.402-1.681-4.867-3.376-7.329-5.016c-2.453-1.665-4.947-3.26-7.431-4.842         c-2.495-1.561-5.012-3.072-7.539-4.429c-1.264-0.673-2.539-1.287-3.771-1.801c-0.618-0.258-1.216-0.459-1.771-0.619         c-0.243-0.047-0.542-0.136-0.71-0.142c-0.08-0.004-0.202-0.031-0.25-0.03c-0.026,0.01-0.051,0.005-0.082-0.013l0.264-0.07         c-2.406,0.655-4.815,2.808-6.839,5.242c-2.058,2.456-3.846,5.286-5.499,8.204c-1.647,2.928-3.177,5.968-4.606,9.069         C4515.688,3310.213,4514.326,3313.365,4513.026,3316.569z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4520.18,3279.91c1.794-5.141,4.188-9.942,7.039-14.564c0.729-1.148,1.477-2.295,2.323-3.413         c0.856-1.135,1.693-2.222,3.05-3.386c0.187-0.151,0.405-0.307,0.611-0.455c0.257-0.165,0.527-0.321,0.882-0.485         c1.011-0.417,2.017-0.355,2.705-0.196c1.389,0.351,2.128,0.905,2.856,1.408c1.375,1.037,2.353,2.14,3.3,3.247         c3.625,4.472,6.08,9.366,8.056,14.452c1.914,5.092,3.262,10.424,3.467,15.878c-2.613-4.769-5.082-9.373-7.712-13.857         c-2.624-4.448-5.349-8.901-8.393-12.687c-0.745-0.929-1.568-1.796-2.283-2.393c-0.325-0.289-0.718-0.487-0.623-0.46         c0.046,0.005,0.36,0.059,0.75-0.114c0.058-0.021,0.032-0.023,0.006-0.019l-0.202,0.117c-0.716,0.496-1.639,1.413-2.494,2.296         c-0.858,0.912-1.734,1.861-2.592,2.836C4527.462,3272.01,4524.025,3276.075,4520.18,3279.91z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4473.426,3268.338c0.676-2.844,1.515-5.611,2.395-8.359c0.895-2.742,1.843-5.458,2.856-8.144         c2.013-5.379,4.245-10.655,6.612-15.868c0.673-1.481,2.389-2.125,3.844-1.464c0.011,0.005,0.036,0.016,0.046,0.022         c0.625,0.297,0.974,0.504,1.411,0.765c0.429,0.244,0.803,0.512,1.2,0.772c0.763,0.539,1.505,1.097,2.186,1.704         c1.412,1.17,2.644,2.496,3.805,3.865c2.307,2.752,4.121,5.827,5.561,9.013l1.007,2.416c0.297,0.817,0.544,1.651,0.816,2.472         c0.567,1.636,0.873,3.343,1.249,5.011c0.328,1.681,0.487,3.392,0.681,5.074c0.077,1.706,0.121,3.404,0.084,5.092         c-0.667-1.576-1.224-3.149-1.801-4.702c-0.679-1.525-1.239-3.067-1.912-4.555c-0.72-1.469-1.304-2.978-2.106-4.377         c-0.375-0.71-0.723-1.431-1.115-2.125l-1.215-2.049c-1.669-2.683-3.501-5.22-5.58-7.473         c-0.537-0.542-1.033-1.132-1.607-1.625c-0.546-0.526-1.096-1.044-1.679-1.51c-0.562-0.498-1.173-0.914-1.758-1.344         c-0.296-0.199-0.594-0.424-0.887-0.592c-0.271-0.176-0.644-0.381-0.767-0.447l3.89-1.442         c-2.479,5.161-5.094,10.258-7.927,15.254c-1.41,2.501-2.885,4.971-4.414,7.416         C4476.758,3263.575,4475.173,3265.994,4473.426,3268.338z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4511.812,3231.154c0.628,2.527,0.681,4.908,0.561,7.244         c-0.143,2.331-0.512,4.604-1.075,6.827c-0.562,2.224-1.326,4.397-2.314,6.512c-1.01,2.11-2.198,4.174-3.966,6.091         c-0.636-2.529-0.691-4.91-0.569-7.246c0.144-2.33,0.513-4.604,1.083-6.825c0.569-2.222,1.333-4.395,2.322-6.51         C4508.866,3235.138,4510.052,3233.073,4511.812,3231.154z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4558.292,3270.708c0.198-1.218,0.471-2.4,0.753-3.578c0.276-1.181,0.603-2.339,0.93-3.495         c0.339-1.152,0.692-2.296,1.065-3.432c0.38-1.132,0.755-2.267,1.17-3.382c0.402-1.08,1.577-1.647,2.664-1.307l0.334,0.105         c3.527,1.111,6.669,2.561,9.777,4.275c3.075,1.724,6.015,3.686,8.749,5.908c2.739,2.212,5.3,4.65,7.555,7.358         c2.296,2.66,4.249,5.631,5.803,8.795c-2.968-1.957-5.651-4.025-8.437-5.941c-2.737-1.962-5.494-3.838-8.253-5.683         c-2.752-1.856-5.547-3.634-8.377-5.352c-2.798-1.722-5.73-3.443-8.524-4.939l2.999-1.201         c-0.595,1.031-1.231,2.042-1.861,3.057c-0.637,1.011-1.295,2.012-1.966,3.008c-0.683,0.99-1.368,1.978-2.101,2.944         C4559.841,3268.815,4559.104,3269.779,4558.292,3270.708z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4591.099,3296.192c0.17-2.003,0.536-3.974,0.994-5.926c0.47-1.948,1.059-3.875,1.789-5.772         c0.711-1.905,1.61-3.767,2.734-5.588c0.54-0.92,1.233-1.797,1.961-2.672c0.415-0.424,0.833-0.852,1.267-1.266         c0.509-0.392,1.05-0.771,1.59-1.139c0.567-0.388,1.253-0.473,1.864-0.291l0.297,0.09c1.007,0.305,1.833,0.585,2.702,0.939         c0.859,0.335,1.697,0.703,2.53,1.08c1.651,0.785,3.264,1.641,4.821,2.594c3.119,1.894,5.99,4.202,8.566,6.79         c0.625,0.669,1.303,1.277,1.869,2.002l1.732,2.118c0.537,0.738,1.033,1.509,1.545,2.258c0.249,0.381,0.501,0.757,0.738,1.144         l0.649,1.201c1.805,3.144,2.89,6.661,3.508,10.135c-2.129-2.881-4.033-5.679-6.379-8.117l-0.822-0.943l-0.896-0.881         c-0.593-0.587-1.162-1.188-1.763-1.756c-1.247-1.1-2.438-2.23-3.749-3.236c-2.554-2.075-5.263-3.942-8.074-5.646         c-0.72-0.397-1.427-0.816-2.137-1.23c-0.728-0.379-1.443-0.788-2.179-1.147c-0.729-0.376-1.46-0.745-2.202-1.079         c-0.724-0.331-1.516-0.682-2.148-0.939l2.161-0.201c-0.271,0.177-0.55,0.331-0.844,0.495c-0.289,0.245-0.593,0.475-0.9,0.71         c-0.593,0.566-1.191,1.159-1.768,1.847c-1.149,1.357-2.257,2.868-3.301,4.457         C4595.154,3289.397,4593.174,3292.77,4591.099,3296.192z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4620.53,3287.049c0.304-1.535,0.769-2.94,1.258-4.32c0.501-1.372,1.066-2.689,1.657-3.978         c0.583-1.293,1.235-2.531,1.857-3.76c0.641-1.209,1.301-2.415,1.866-3.524l0.051-0.098c0.728-1.431,2.478-2,3.908-1.272         c0.189,0.097,0.376,0.222,0.535,0.351c0.412,0.341,0.614,0.544,0.896,0.812c0.258,0.251,0.51,0.504,0.736,0.77         c0.465,0.525,0.909,1.047,1.306,1.604c0.817,1.092,1.496,2.263,2.099,3.46c0.583,1.21,1.068,2.461,1.428,3.756         c0.35,1.3,0.6,2.632,0.634,4.036c-0.586-0.405-1.098-0.839-1.603-1.268c-0.53-0.414-0.991-0.86-1.477-1.282         c-0.951-0.857-1.847-1.717-2.731-2.557l-2.571-2.485c-0.432-0.391-0.832-0.806-1.253-1.178l-0.611-0.556         c-0.179-0.161-0.44-0.385-0.519-0.441l4.493-1.02c-0.703,1.434-1.503,2.669-2.348,3.879c-0.868,1.19-1.767,2.333-2.762,3.401         c-0.985,1.074-2.027,2.099-3.157,3.054C4623.083,3285.38,4621.902,3286.291,4620.53,3287.049z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4634.276,3292.395c0.142-1.687,0.533-3.281,1.018-4.85c0.506-1.565,1.13-3.08,2.003-4.588         c0.454-0.752,0.938-1.507,1.718-2.292c0.432-0.39,0.868-0.848,1.866-1.222c0.131-0.045,0.264-0.086,0.398-0.123         c0.14-0.037,0.341-0.062,0.513-0.079c0.184-0.015,0.348-0.031,0.549-0.018c0.21,0.018,0.423,0.05,0.632,0.097l0.309,0.081         l0.131,0.049l0.248,0.099l0.493,0.212c1.029,0.524,1.734,1.05,2.436,1.58c0.698,0.54,1.316,1.109,1.939,1.681         c2.42,2.325,4.403,5.007,5.925,7.97c1.485,2.95,2.518,6.307,2.259,9.679c-2.118-2.608-4.061-4.836-6.118-7.031         c-2.04-2.178-4.1-4.309-6.186-6.324c-0.51-0.505-1.039-1.001-1.554-1.448c-0.493-0.478-1.051-0.886-1.372-1.149         c-0.014-0.01-0.025-0.024-0.037-0.041c0.036-0.021,0.091-0.003,0.147,0.011c0.113,0.028,0.23,0.042,0.345,0.04         c0.105,0.001,0.17,0.007,0.257-0.004c0.075-0.006,0.177-0.036,0.222-0.048c0.04-0.008,0.08-0.02,0.117-0.037         c0.255-0.124,0.05-0.108-0.119-0.002c-0.395,0.249-0.928,0.693-1.434,1.173         C4638.901,3287.799,4636.798,3290.209,4634.276,3292.395z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4428.787,3246.914c0.616-1.876,1.379-3.683,2.202-5.462c0.831-1.775,1.743-3.512,2.745-5.208         c1-1.697,2.083-3.359,3.31-4.962c0.612-0.806,1.261-1.596,1.976-2.363c0.712-0.771,1.472-1.532,2.398-2.24         c1.063-0.812,2.544-0.695,3.469,0.22l0.091,0.091c0.428,0.423,0.718,0.734,1.047,1.096c0.329,0.352,0.623,0.7,0.924,1.06         c0.582,0.721,1.161,1.44,1.694,2.182c1.086,1.477,2.063,3.009,2.98,4.571c1.83,3.127,3.323,6.416,4.587,9.769l0.877,2.539         c0.29,0.846,0.502,1.718,0.756,2.573c0.5,1.714,0.863,3.464,1.214,5.208c0.347,1.745,0.549,3.521,0.759,5.281         c0.146,1.777,0.227,3.557,0.225,5.338c-0.821-1.601-1.506-3.217-2.223-4.812c-0.767-1.58-1.395-3.188-2.144-4.748         c-1.414-3.146-2.872-6.23-4.369-9.268c-1.519-3.026-3.102-5.995-4.799-8.871c-0.856-1.431-1.722-2.857-2.651-4.219         c-0.446-0.698-0.927-1.36-1.403-2.02c-0.247-0.316-0.475-0.665-0.719-0.969c-0.229-0.305-0.509-0.652-0.68-0.861l3.56,0.311         c-1.297,0.825-2.656,2.061-3.977,3.309c-1.314,1.279-2.619,2.631-3.919,4.01         C4434.124,3241.244,4431.535,3244.098,4428.787,3246.914z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4455.332,3250.605c0.044-1.478,0.31-2.892,0.651-4.281c0.356-1.384,0.805-2.744,1.39-4.057         c0.575-1.321,1.25-2.605,2.094-3.85c0.859-1.235,1.83-2.446,3.179-3.544c0.76-0.619,1.749-0.769,2.617-0.485l0.076,0.026         c1.07,0.359,1.937,0.671,2.852,1.096c0.899,0.406,1.783,0.836,2.634,1.33c1.716,0.958,3.333,2.101,4.824,3.399         c1.492,1.295,2.836,2.784,3.945,4.43c1.104,1.644,1.978,3.464,2.368,5.4c-1.587-1.176-3.057-2.23-4.577-3.174         c-1.505-0.953-3.029-1.802-4.56-2.616c-1.527-0.818-3.089-1.557-4.649-2.289c-0.787-0.35-1.569-0.711-2.358-1.044         c-0.774-0.312-1.619-0.69-2.293-0.925l2.693-0.459c-0.802,0.573-1.671,1.388-2.527,2.258c-0.875,0.862-1.728,1.834-2.62,2.8         l-2.73,2.98C4457.391,3248.602,4456.419,3249.611,4455.332,3250.605z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4492.587,3295.953c-1.613-1.563-3.12-3.149-4.618-4.719         c-1.486-1.576-2.955-3.136-4.429-4.648c-1.453-1.529-2.938-2.998-4.433-4.342c-1.495-1.324-3.036-2.589-4.5-3.358l3.102-0.2         c-0.75,0.585-1.682,1.324-2.5,2.047c-0.833,0.74-1.676,1.48-2.485,2.258c-1.633,1.542-3.179,3.176-4.678,4.865         c-1.511,1.687-2.889,3.486-4.229,5.366c-1.384,1.872-2.498,3.906-3.775,6.04c0.016-1.213-0.004-2.486,0.229-3.697         c0.089-0.616,0.205-1.229,0.32-1.846l0.497-1.804c0.734-2.39,1.76-4.715,3.064-6.858c1.279-2.164,2.79-4.184,4.466-6.053         c0.858-0.916,1.716-1.836,2.659-2.675c0.949-0.865,1.848-1.645,3.007-2.474l0.151-0.108c0.9-0.644,2.066-0.643,2.951-0.092         l1.659,1.037c0.508,0.369,0.971,0.77,1.454,1.155c0.91,0.796,1.779,1.616,2.532,2.493c1.571,1.715,2.889,3.56,4.091,5.451         c1.193,1.899,2.254,3.858,3.175,5.882C4491.206,3291.702,4492.027,3293.771,4492.587,3295.953z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4428.775,3291.352c0.717-1.969,1.62-3.857,2.579-5.723c0.994-1.843,2.05-3.667,3.233-5.424         c1.183-1.757,2.479-3.456,3.93-5.068c1.452-1.611,3.067-3.128,4.955-4.454c0.923-0.649,2.157-0.528,2.938,0.23l0.153,0.149         c0.601,0.582,1.022,1.058,1.498,1.593c0.461,0.522,0.902,1.05,1.334,1.583c0.867,1.063,1.664,2.17,2.444,3.282         c1.549,2.233,2.945,4.555,4.218,6.933c2.557,4.753,4.605,9.745,6.225,14.845c1.626,5.101,2.799,10.323,3.54,15.589         c0.736,5.265,1.066,10.575,0.819,15.878c-1.53-5.082-2.967-10.098-4.534-15.041c-1.555-4.943-3.214-9.812-5.072-14.579         c-1.841-4.773-3.91-9.431-6.205-13.95c-1.158-2.253-2.379-4.469-3.681-6.623c-0.646-1.08-1.339-2.125-2.026-3.165         c-0.347-0.518-0.701-1.029-1.063-1.523c-0.347-0.481-0.764-1.01-1.056-1.385l3.091,0.38c-1.597,0.879-3.161,2.013-4.67,3.263         c-1.511,1.253-2.969,2.626-4.396,4.056c-1.426,1.432-2.833,2.914-4.185,4.457         C4431.462,3288.184,4430.124,3289.757,4428.775,3291.352z",
    style: {
      fill: "#90A05D"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "4908.761,3388.495 4786.321,3334.622 4786.321,3438.269 4908.761,3501.14      ",
    style: {
      fill: "#9B9B9B"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 112.645,
    style: {
      fill: "#C1C1C1"
    },
    width: 655.284,
    x: 4253.477,
    y: 3388.495
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4815.344,3414.905c-1.644,0-2.976,1.332-2.976,2.976v83.259h5.951v-83.259         C4818.319,3416.237,4816.987,3414.905,4815.344,3414.905z",
    style: {
      fill: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4702.984,3414.905c-1.644,0-2.975,1.332-2.975,2.976v83.259h5.951v-83.259         C4705.96,3416.237,4704.628,3414.905,4702.984,3414.905z",
    style: {
      fill: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4590.625,3414.905c-1.644,0-2.975,1.332-2.975,2.976v83.259h5.951v-83.259         C4593.601,3416.237,4592.27,3414.905,4590.625,3414.905z",
    style: {
      fill: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4478.266,3414.905c-1.644,0-2.976,1.332-2.976,2.976v83.259h5.951v-83.259         C4481.241,3416.237,4479.909,3414.905,4478.266,3414.905z",
    style: {
      fill: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4365.907,3414.905c-1.644,0-2.976,1.332-2.976,2.976v83.259h5.951v-83.259         C4368.882,3416.237,4367.55,3414.905,4365.907,3414.905z",
    style: {
      fill: "#ADADAD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    height: 35.852,
    style: {
      fill: "#ADADAD"
    },
    width: 655.284,
    x: 4253.477,
    y: 3388.495
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4272.802,3381.551c0,0-3.896-17.021-15.213-20.659s-24.654-2.829-27.483-6.063       s10.913-7.679,17.783-6.871c6.871,0.808,30.313-0.404,38.8,5.254c0,0-17.783-22.229-25.462-27.484       c0,0,20.612-4.446,32.333,6.063c0,0-4.446-14.954-2.829-20.208c1.617-5.254,7.275-4.85,9.7-2.425       c2.425,2.425,7.275,11.721,13.742,14.954s12.529,7.275,12.529,7.275s19.4-28.292,25.462-27.484       c6.063,0.808,3.638,27.08,4.85,32.334c1.213,5.254,6.467,10.537,11.317,6.481s11.317-13.756,17.379-13.352       c6.063,0.404,11.721,14.175,16.167,13.352c4.446-0.823,6.063-30.327,13.337-29.923c7.275,0.404,6.467,25.059,7.679,27.888       s6.467-14.954,13.337-14.146c6.871,0.808,5.203,33.207,1.591,44.694v6.561l-44.433,5.734L4272.802,3381.551z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4304.479,3373.516c0,0-5.665-25.556-3.24-40.511s8.083-25.093,11.317-29.117       c3.233-4.025,13.337,10.526,18.592,25.48c5.254,14.954,4.752,33.207,4.195,40.854       C4335.343,3370.221,4318.631,3380.076,4304.479,3373.516z",
    style: {
      fill: "#9EAD6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4357.482,3374.396c0,0-3.985-17.915,0.805-34.907s11.257-18.205,13.278-16.992       c2.021,1.213,6.467,14.146,5.658,28.292c-0.808,14.146-2.864,26.621-2.864,26.621S4362.618,3375.774,4357.482,3374.396z",
    style: {
      fill: "#9EAD6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4395.501,3375.769c0,0-7.365-9.218-9.386-22.151c-2.021-12.933-4.446-21.017-6.063-25.867       c-1.617-4.85-1.617-9.296,2.425-8.488c4.042,0.808,16.975,8.926,27.08,20.226c10.104,11.3,12.926,32.215,12.926,32.215       S4405.695,3378.116,4395.501,3375.769z",
    style: {
      fill: "#9EAD6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4456.419,3372.993c0,0-2.447-12.909,0-27.459s8.914-23.38,8.914-23.38s9.7,12.909,12.933,25.42       c0,0,7.275-41.278,12.53-43.686c5.254-2.408,21.017,35.248,10.912,72.398       C4501.708,3376.285,4464.077,3379.839,4456.419,3372.993z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4523.129,3376.601c0,0-13.338-30.259,6.063-61.38c0,0,30.718,19.687,30.718,60.163       C4559.909,3375.384,4531.617,3380.993,4523.129,3376.601z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4431,3371.233c0,0,11.294-49.141,19.378-56.011c0,0,11.782,26.949,9.327,57.933       C4459.705,3373.154,4437.893,3380.765,4431,3371.233z",
    style: {
      fill: "#9EAD6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4548.258,3375.609c0,0,18.117-63.874,66.617-71.831c0,0,2.533,37.838-22.377,69.504       C4592.498,3373.282,4557.625,3382.645,4548.258,3375.609z",
    style: {
      fill: "#9EAD6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4620.534,3319.167c0,0,19.004,21.356,16.171,49.122l-25.073,1.809       C4611.632,3370.098,4604.367,3340.897,4620.534,3319.167z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4761.404,3309.275c0,0-8.02-21.117-28.639-27.255c0,0,6.167,11.915,2.34,33.201v14.281h26.299       V3309.275z",
    style: {
      fill: "#A8B876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4629.83,3362.509c0,0,6.467-49.309,30.717-64.667c0,0,16.571,27.484,0,67.901l-30.717,1.347       V3362.509z",
    style: {
      fill: "#9EAD6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4751.485,3369.38c0,0,3.233-54.159,14.55-69.517c1.617-4.046,38.396,1.482,57.796,67.227       C4823.832,3367.09,4772.098,3376.655,4751.485,3369.38z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4777.768,3371.296c0,0-7.691-37.483-2.437-50.012c4.85-2.116,17.379,8.488,17.379,8.488       s21.825-33.546,26.271-33.95c4.446-0.404,6.871,30.313,6.871,30.313s12.529-13.338,14.954-13.338s0,18.188,0,18.188       s23.846-1.321,27.08,2.573c3.233,3.894-29.909,30.973-48.096,36.632C4819.79,3370.188,4789.904,3374.425,4777.768,3371.296z",
    style: {
      fill: "#9EAD6C"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4815.552,3370.728c2.618-0.311,4.237-0.539,4.237-0.539        c18.188-5.659,51.33-32.738,48.097-36.632c-3.233-3.894-27.08-2.573-27.08-2.573s2.425-18.188,0-18.188        s-14.954,13.338-14.954,13.338s-8.488,23.666-10.509,43.964L4815.552,3370.728z",
    style: {
      fill: "#A8B876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4867.886,3333.557c-3.234-3.894-27.08-2.573-27.08-2.573s-15.763,32.334-21.017,39.205        C4837.978,3364.53,4871.12,3337.451,4867.886,3333.557z",
    style: {
      fill: "#9EAD6C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4701.368,3324.504c0,0,3.233-27.066,12.125-33.533c8.892-6.467,25.867,31.121,16.571,65.476       c-2.829,9.296-5.658,19.585-5.658,19.585l-33.731-1.434L4701.368,3324.504z",
    style: {
      fill: "#A8B876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4709.516,3370.427c0,0,19.335-48.74,41.161-55.206c4.85,3.946,18.009,25.686,3.144,54.877       C4753.821,3370.098,4717.26,3373.092,4709.516,3370.427z",
    style: {
      fill: "#9EAD6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4660.547,3365.743c0,0,21.421-46.075,47.692-40.821c3.233,3.638-4.411,26.78-17.564,45.177       C4690.675,3370.098,4666.205,3372.209,4660.547,3365.743z",
    style: {
      fill: "#90A05D"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4265.672,3388.495c0,0,9.7-12.244,21.825-13.861c12.125-1.617,18.592,0,28.292-3.233       c9.7-3.233,28.292-0.808,39.608,2.425c11.317,3.233,27.888,5.658,38.396,2.425c10.508-3.233,38.396-6.467,50.521-4.446       c12.125,2.021,30.313,1.213,42.438,2.829c12.125,1.616,42.438,2.829,58.604,1.212c16.167-1.617,33.951,1.617,45.267-2.021       c11.317-3.638,37.973-9.336,51.311-9.336c13.337,0,15.719,0.175,31.077,2.6s35.63,4.311,48.563,2.29       c12.934-2.021,40.417,2.021,51.734,2.021c11.317,0,35.971-2.829,46.48-1.213c10.508,1.617,43.246,18.307,43.246,18.307       H4265.672z",
    style: {
      fill: "#996E5D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4783.142,3383.526c-11.754-1.315-48.195-3.975-60.538-2.212       c-12.342,1.763-35.852,0.588-48.783-1.763c-12.931-2.351-28.8-4.114-39.545-1.271c-10.746,2.844-17.467,6.56-24.272,5.245       c-6.805-1.315-36.688-1.624-45.65,0s-19.25,1.903-29.241,0c-9.992-1.903-50.547-1.624-59.823,0       c-9.275,1.624-24.226-1.624-37.467-5.734c-13.242-4.11-40.244,3.522-51.411,5.873c-11.167,2.351-36.44,0.588-50.737-3.659       c-14.296-4.247-37.425,3.072-41.54,0c-2.374-1.772,0.156-4.32,2.721-6.159c-2.79,0.122-5.831,0.316-9.359,0.787       c-12.125,1.616-21.825,13.861-21.825,13.861h597.364c0,0-32.738-16.69-43.246-18.307       C4828.814,3388.45,4794.897,3384.841,4783.142,3383.526z",
    style: {
      fill: "#916553"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M421.84,3309.967c0,0-9.296-21.421-18.592-27.079c-9.296-5.658-13.144,17.652-12.125,32.334       C392.142,3329.903,414.969,3323.305,421.84,3309.967z",
    style: {
      fill: "#A8B876"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M722.004,3204.074c0,0-25.733,4.85-33.816,27.079l-4.446-7.275c0,0-17.379,6.871-28.292,30.717        c0,0-6.063-15.762-10.508-18.996c-4.446-3.233-26.06,25.059-26.06,25.059s-5.061-14.55-9.506-17.783        c-4.446-3.233-35.567,21.421-39.205,29.908c0,0-4.222-9.7-7.163-10.913c-2.941-1.212-29.212,13.742-36.892,30.313        c0,0-9.227-22.634-10.878-23.846c-1.651-1.213-20.105,16.159-24.216,27.479l-15.427,12.533c0,0-8.464-5.467-10.699-5.563        c-2.235-0.096-8.701,18.9-10.318,34.663c-1.617,15.763,0,42.555,0,42.555H771.25l-0.053-193.493c0,0-12.4,4.925-23.064,15.991        c-10.664,11.066-16.562,25.128-16.562,25.128L722.004,3204.074z",
    style: {
      fill: "#7F8F4F"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M696.199,3334.444c0,0-19.202,16.371-20.814,42.764h23.177L696.199,3334.444z",
    style: {
      fill: "#A8B876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.51,3330.886c0,0-14.99-22.67-29.185-30.215c0,0-6.729,13.063-1.262,41.091l4.892,28.336         h28.519L538.51,3330.886z",
    style: {
      fill: "#A8B876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.742,3355.369c0,0,0.745-32.333-7.069-40.147c-7.814-7.814-14.55,26.136-16.436,40.147         C626.35,3369.38,651.742,3355.369,651.742,3355.369z",
    style: {
      fill: "#A8B876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.262,3305.761c0.486-3.251,0.652-6.51,0.694-9.769c0.028-3.259-0.113-6.519-0.423-9.779         c-0.311-3.262-0.823-6.522-1.598-9.789l-0.654-2.453c-0.259-0.824-0.565-1.64-0.849-2.46c-0.3-0.82-0.725-1.656-1.09-2.48         c-0.41-0.825-1.025-1.674-1.548-2.493c-0.54-0.843-1.491-1.264-2.423-1.166l-0.159,0.018         c-0.592,0.063-0.924,0.129-1.346,0.21c-0.41,0.074-0.783,0.17-1.17,0.268c-0.756,0.211-1.504,0.425-2.22,0.694         c-1.456,0.491-2.824,1.138-4.159,1.823c-2.665,1.385-5.09,3.114-7.319,5.015l-1.622,1.477         c-0.537,0.493-1.014,1.048-1.521,1.567c-1.025,1.027-1.909,2.182-2.808,3.303c-0.46,0.552-0.855,1.158-1.26,1.751         c-0.407,0.592-0.803,1.188-1.187,1.791c-0.735,1.231-1.417,2.489-2.055,3.759c1.125-0.898,2.173-1.834,3.226-2.75         c1.123-0.852,2.141-1.782,3.243-2.612c1.108-0.823,2.161-1.687,3.293-2.441c1.096-0.799,2.231-1.524,3.362-2.238         c2.279-1.397,4.609-2.646,6.998-3.654c1.195-0.495,2.403-0.948,3.61-1.306c0.602-0.198,1.209-0.335,1.804-0.473         c0.295-0.054,0.598-0.14,0.877-0.18c0.263-0.052,0.621-0.101,0.724-0.111l-2.582-1.148c0.301,0.558,0.658,1.005,0.952,1.622         c0.284,0.644,0.615,1.233,0.876,1.918l0.771,2.079l0.69,2.176c0.865,2.946,1.634,5.99,2.369,9.069l2.154,9.324         C706.646,3299.454,707.38,3302.598,708.262,3305.761z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.973,3316.569c-0.473-3.43-1.214-6.821-2.115-10.175         c-0.922-3.349-1.983-6.677-3.333-9.927c-1.355-3.246-2.919-6.451-5.024-9.463c-1.061-1.498-2.232-2.969-3.668-4.296         c-1.438-1.313-3.15-2.524-5.238-3.262c-0.101-0.036-0.187-0.057-0.264-0.071c-0.341-0.057-0.689-0.1-1.036-0.128         c-0.325-0.017-0.578,0.009-0.872,0.02c-0.299,0.009-0.54,0.049-0.781,0.089c-0.241,0.04-0.497,0.076-0.725,0.126         c-0.898,0.205-1.731,0.455-2.511,0.736c-1.568,0.558-3.011,1.217-4.413,1.914c-2.805,1.385-5.452,2.928-8.047,4.534         c-2.602,1.591-5.115,3.295-7.615,5.007c-2.488,1.741-4.928,3.495-7.359,5.36l4.453,1.815c-0.754-3.889-1.613-7.619-3-11.469         c-0.367-0.964-0.758-1.926-1.342-2.961c-0.309-0.523-0.609-1.051-1.246-1.69c-0.16-0.159-0.387-0.338-0.588-0.49         c-0.27-0.169-0.596-0.355-0.892-0.44c-0.658-0.201-1.08-0.188-1.462-0.184c-1.444,0.088-2.391,0.435-3.406,0.772         c-0.987,0.349-1.918,0.751-2.82,1.192c-3.604,1.747-6.881,3.956-9.837,6.542c-1.487,1.277-2.859,2.691-4.086,4.212         c-1.242,1.503-2.289,3.177-3.067,4.93c2.374-3.026,5.381-5.315,8.522-7.304c3.162-1.955,6.543-3.572,9.96-4.786         c0.855-0.296,1.714-0.555,2.549-0.763c0.807-0.202,1.723-0.354,2.189-0.305c0.092,0.003,0.151,0.052-0.053-0.002         c-0.066-0.023-0.196-0.059-0.257-0.119c-0.024,0.007-0.057-0.031-0.052-0.019c0.031,0.046,0.216,0.352,0.354,0.667         c0.301,0.654,0.577,1.484,0.816,2.326c0.961,3.405,1.615,7.169,2.159,10.785c0.23,1.527,1.654,2.578,3.181,2.349         c0.438-0.066,0.836-0.23,1.177-0.466l0.095-0.067c2.402-1.681,4.867-3.376,7.329-5.016c2.453-1.665,4.947-3.26,7.431-4.842         c2.495-1.561,5.012-3.072,7.539-4.429c1.264-0.673,2.539-1.287,3.771-1.801c0.618-0.258,1.216-0.459,1.772-0.619         c0.243-0.047,0.542-0.136,0.71-0.142c0.08-0.004,0.202-0.031,0.249-0.03c0.026,0.01,0.051,0.005,0.082-0.013l-0.264-0.07         c2.406,0.655,4.815,2.808,6.839,5.242c2.057,2.456,3.846,5.286,5.499,8.204c1.647,2.928,3.176,5.968,4.606,9.069         C684.311,3310.213,685.674,3313.365,686.973,3316.569z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.82,3279.91c-1.794-5.141-4.189-9.942-7.039-14.564c-0.73-1.148-1.477-2.295-2.323-3.413         c-0.857-1.135-1.694-2.222-3.05-3.386c-0.187-0.151-0.405-0.307-0.611-0.455c-0.258-0.165-0.527-0.321-0.882-0.485         c-1.011-0.417-2.017-0.355-2.705-0.196c-1.389,0.351-2.128,0.905-2.856,1.408c-1.375,1.037-2.353,2.14-3.3,3.247         c-3.625,4.472-6.079,9.366-8.056,14.452c-1.914,5.092-3.262,10.424-3.467,15.878c2.613-4.769,5.082-9.373,7.712-13.857         c2.623-4.448,5.349-8.901,8.393-12.687c0.744-0.929,1.568-1.796,2.283-2.393c0.326-0.289,0.718-0.487,0.623-0.46         c-0.047,0.005-0.36,0.059-0.751-0.114c-0.058-0.021-0.032-0.023-0.006-0.019l0.201,0.117         c0.716,0.496,1.639,1.413,2.494,2.296c0.859,0.912,1.735,1.861,2.592,2.836C672.538,3272.01,675.975,3276.075,679.82,3279.91         z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.574,3268.338c-0.676-2.844-1.515-5.611-2.395-8.359         c-0.895-2.742-1.843-5.458-2.856-8.144c-2.013-5.379-4.244-10.655-6.612-15.868c-0.673-1.481-2.389-2.125-3.844-1.464         c-0.011,0.005-0.036,0.016-0.046,0.022c-0.625,0.297-0.974,0.504-1.411,0.765c-0.429,0.244-0.803,0.512-1.2,0.772         c-0.763,0.539-1.506,1.097-2.186,1.704c-1.412,1.17-2.644,2.496-3.805,3.865c-2.307,2.752-4.121,5.827-5.561,9.013         l-1.007,2.416c-0.297,0.817-0.544,1.651-0.816,2.472c-0.567,1.636-0.873,3.343-1.248,5.011         c-0.328,1.681-0.487,3.392-0.681,5.074c-0.077,1.706-0.121,3.404-0.084,5.092c0.667-1.576,1.224-3.149,1.801-4.702         c0.68-1.525,1.239-3.067,1.912-4.555c0.72-1.469,1.304-2.978,2.106-4.377c0.375-0.71,0.723-1.431,1.115-2.125l1.215-2.049         c1.669-2.683,3.501-5.22,5.58-7.473c0.537-0.542,1.033-1.132,1.607-1.625c0.546-0.526,1.095-1.044,1.679-1.51         c0.562-0.498,1.173-0.914,1.758-1.344c0.296-0.199,0.594-0.424,0.887-0.592c0.271-0.176,0.644-0.381,0.767-0.447l-3.89-1.442         c2.479,5.161,5.094,10.258,7.927,15.254c1.41,2.501,2.885,4.971,4.414,7.416         C723.242,3263.575,724.826,3265.994,726.574,3268.338z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.188,3231.154c-0.628,2.527-0.681,4.908-0.561,7.244c0.143,2.331,0.512,4.604,1.075,6.827         c0.562,2.224,1.326,4.397,2.314,6.512c1.01,2.11,2.198,4.174,3.966,6.091c0.635-2.529,0.691-4.91,0.568-7.246         c-0.143-2.33-0.512-4.604-1.083-6.825c-0.569-2.222-1.333-4.395-2.322-6.51         C691.134,3235.138,689.948,3233.073,688.188,3231.154z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.708,3270.708c-0.198-1.218-0.471-2.4-0.753-3.578c-0.277-1.181-0.603-2.339-0.93-3.495         c-0.339-1.152-0.692-2.296-1.065-3.432c-0.381-1.132-0.755-2.267-1.171-3.382c-0.402-1.08-1.577-1.647-2.664-1.307         l-0.335,0.105c-3.527,1.111-6.669,2.561-9.777,4.275c-3.075,1.724-6.014,3.686-8.748,5.908         c-2.739,2.212-5.301,4.65-7.555,7.358c-2.297,2.66-4.249,5.631-5.803,8.795c2.968-1.957,5.651-4.025,8.437-5.941         c2.737-1.962,5.494-3.838,8.253-5.683c2.752-1.856,5.547-3.634,8.377-5.352c2.798-1.722,5.731-3.443,8.524-4.939         l-2.998-1.201c0.595,1.031,1.231,2.042,1.861,3.057c0.637,1.011,1.295,2.012,1.966,3.008c0.683,0.99,1.368,1.978,2.101,2.944         C640.159,3268.815,640.895,3269.779,641.708,3270.708z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.901,3296.192c-0.17-2.003-0.536-3.974-0.993-5.926c-0.47-1.948-1.059-3.875-1.789-5.772         c-0.711-1.905-1.61-3.767-2.734-5.588c-0.54-0.92-1.233-1.797-1.961-2.672c-0.415-0.424-0.833-0.852-1.266-1.266         c-0.51-0.392-1.05-0.771-1.59-1.139c-0.568-0.388-1.253-0.473-1.864-0.291l-0.297,0.09c-1.007,0.305-1.833,0.585-2.701,0.939         c-0.859,0.335-1.697,0.703-2.53,1.08c-1.651,0.785-3.264,1.641-4.821,2.594c-3.119,1.894-5.99,4.202-8.567,6.79         c-0.625,0.669-1.303,1.277-1.868,2.002l-1.733,2.118c-0.537,0.738-1.033,1.509-1.545,2.258         c-0.248,0.381-0.501,0.757-0.738,1.144l-0.649,1.201c-1.805,3.144-2.89,6.661-3.508,10.135         c2.129-2.881,4.033-5.679,6.379-8.117l0.822-0.943l0.895-0.881c0.593-0.587,1.162-1.188,1.763-1.756         c1.247-1.1,2.438-2.23,3.749-3.236c2.554-2.075,5.263-3.942,8.075-5.646c0.72-0.397,1.427-0.816,2.137-1.23         c0.727-0.379,1.443-0.788,2.179-1.147c0.728-0.376,1.46-0.745,2.202-1.079c0.724-0.331,1.515-0.682,2.148-0.939l-2.161-0.201         c0.271,0.177,0.551,0.331,0.844,0.495c0.289,0.245,0.593,0.475,0.9,0.71c0.593,0.566,1.191,1.159,1.768,1.847         c1.149,1.357,2.257,2.868,3.3,4.457C604.846,3289.397,606.826,3292.77,608.901,3296.192z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.47,3287.049c-0.304-1.535-0.769-2.94-1.259-4.32c-0.501-1.372-1.066-2.689-1.657-3.978         c-0.584-1.293-1.235-2.531-1.857-3.76c-0.641-1.209-1.301-2.415-1.866-3.524l-0.05-0.098c-0.728-1.431-2.478-2-3.908-1.272         c-0.19,0.097-0.376,0.222-0.535,0.351c-0.412,0.341-0.614,0.544-0.897,0.812c-0.258,0.251-0.51,0.504-0.736,0.77         c-0.465,0.525-0.909,1.047-1.306,1.604c-0.818,1.092-1.496,2.263-2.098,3.46c-0.583,1.21-1.068,2.461-1.428,3.756         c-0.35,1.3-0.6,2.632-0.634,4.036c0.586-0.405,1.097-0.839,1.602-1.268c0.53-0.414,0.991-0.86,1.477-1.282         c0.951-0.857,1.847-1.717,2.731-2.557l2.571-2.485c0.432-0.391,0.832-0.806,1.253-1.178l0.612-0.556         c0.179-0.161,0.44-0.385,0.519-0.441l-4.493-1.02c0.703,1.434,1.503,2.669,2.348,3.879c0.868,1.19,1.767,2.333,2.762,3.401         c0.985,1.074,2.027,2.099,3.157,3.054C576.916,3285.38,578.098,3286.291,579.47,3287.049z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.724,3292.395c-0.142-1.687-0.533-3.281-1.018-4.85c-0.506-1.565-1.13-3.08-2.003-4.588         c-0.454-0.752-0.938-1.507-1.718-2.292c-0.432-0.39-0.868-0.848-1.866-1.222c-0.131-0.045-0.264-0.086-0.398-0.123         c-0.139-0.037-0.341-0.062-0.513-0.079c-0.185-0.015-0.348-0.031-0.549-0.018c-0.21,0.018-0.423,0.05-0.632,0.097         l-0.309,0.081l-0.131,0.049l-0.248,0.099l-0.493,0.212c-1.029,0.524-1.734,1.05-2.435,1.58         c-0.698,0.54-1.317,1.109-1.939,1.681c-2.42,2.325-4.403,5.007-5.925,7.97c-1.485,2.95-2.518,6.307-2.259,9.679         c2.117-2.608,4.061-4.836,6.118-7.031c2.039-2.178,4.1-4.309,6.185-6.324c0.51-0.505,1.039-1.001,1.555-1.448         c0.493-0.478,1.051-0.886,1.372-1.149c0.013-0.01,0.025-0.024,0.037-0.041c-0.035-0.021-0.091-0.003-0.147,0.011         c-0.113,0.028-0.231,0.042-0.345,0.04c-0.105,0.001-0.17,0.007-0.257-0.004c-0.075-0.006-0.177-0.036-0.222-0.048         c-0.04-0.008-0.079-0.02-0.117-0.037c-0.255-0.124-0.05-0.108,0.119-0.002c0.395,0.249,0.928,0.693,1.433,1.173         C561.098,3287.799,563.202,3290.209,565.724,3292.395z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.213,3246.914c-0.616-1.876-1.379-3.683-2.202-5.462         c-0.831-1.775-1.742-3.512-2.744-5.208c-1-1.697-2.083-3.359-3.31-4.962c-0.612-0.806-1.261-1.596-1.975-2.363         c-0.712-0.771-1.472-1.532-2.399-2.24c-1.063-0.812-2.544-0.695-3.469,0.22l-0.092,0.091         c-0.428,0.423-0.718,0.734-1.047,1.096c-0.328,0.352-0.623,0.7-0.924,1.06c-0.582,0.721-1.161,1.44-1.694,2.182         c-1.086,1.477-2.063,3.009-2.98,4.571c-1.83,3.127-3.323,6.416-4.587,9.769l-0.877,2.539         c-0.29,0.846-0.502,1.718-0.756,2.573c-0.501,1.714-0.863,3.464-1.214,5.208c-0.348,1.745-0.549,3.521-0.759,5.281         c-0.146,1.777-0.227,3.557-0.225,5.338c0.821-1.601,1.506-3.217,2.223-4.812c0.767-1.58,1.395-3.188,2.144-4.748         c1.413-3.146,2.872-6.23,4.369-9.268c1.519-3.026,3.102-5.995,4.799-8.871c0.857-1.431,1.722-2.857,2.651-4.219         c0.446-0.698,0.927-1.36,1.403-2.02c0.247-0.316,0.475-0.665,0.719-0.969c0.229-0.305,0.51-0.652,0.68-0.861l-3.56,0.311         c1.297,0.825,2.656,2.061,3.977,3.309c1.314,1.279,2.62,2.631,3.919,4.01         C765.876,3241.244,768.465,3244.098,771.213,3246.914z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.668,3250.605c-0.044-1.478-0.309-2.892-0.651-4.281c-0.356-1.384-0.804-2.744-1.39-4.057         c-0.575-1.321-1.25-2.605-2.095-3.85c-0.859-1.235-1.83-2.446-3.179-3.544c-0.76-0.619-1.749-0.769-2.617-0.485l-0.077,0.026         c-1.07,0.359-1.937,0.671-2.852,1.096c-0.899,0.406-1.783,0.836-2.634,1.33c-1.716,0.958-3.333,2.101-4.824,3.399         c-1.492,1.295-2.836,2.784-3.945,4.43c-1.105,1.644-1.978,3.464-2.368,5.4c1.587-1.176,3.057-2.23,4.577-3.174         c1.505-0.953,3.029-1.802,4.56-2.616c1.527-0.818,3.089-1.557,4.649-2.289c0.787-0.35,1.569-0.711,2.358-1.044         c0.774-0.312,1.619-0.69,2.294-0.925l-2.693-0.459c0.802,0.573,1.671,1.388,2.526,2.258c0.876,0.862,1.727,1.834,2.621,2.8         l2.73,2.98C742.609,3248.602,743.581,3249.611,744.668,3250.605z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.412,3295.953c1.614-1.563,3.12-3.149,4.618-4.719c1.486-1.576,2.955-3.136,4.429-4.648         c1.453-1.529,2.938-2.998,4.433-4.342c1.495-1.324,3.036-2.589,4.5-3.358l-3.101-0.2c0.75,0.585,1.681,1.324,2.5,2.047         c0.833,0.74,1.676,1.48,2.485,2.258c1.633,1.542,3.178,3.176,4.678,4.865c1.511,1.687,2.889,3.486,4.229,5.366         c1.384,1.872,2.498,3.906,3.776,6.04c-0.016-1.213,0.004-2.486-0.229-3.697c-0.089-0.616-0.205-1.229-0.32-1.846         l-0.497-1.804c-0.734-2.39-1.759-4.715-3.064-6.858c-1.279-2.164-2.789-4.184-4.466-6.053         c-0.858-0.916-1.716-1.836-2.659-2.675c-0.949-0.865-1.848-1.645-3.007-2.474l-0.151-0.108         c-0.9-0.644-2.066-0.643-2.951-0.092l-1.659,1.037c-0.508,0.369-0.971,0.77-1.454,1.155c-0.91,0.796-1.779,1.616-2.531,2.493         c-1.572,1.715-2.889,3.56-4.091,5.451c-1.193,1.899-2.254,3.858-3.175,5.882         C708.795,3291.702,707.973,3293.771,707.412,3295.953z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.225,3291.352c-0.717-1.969-1.62-3.857-2.579-5.723c-0.994-1.843-2.05-3.667-3.233-5.424         c-1.183-1.757-2.48-3.456-3.93-5.068c-1.452-1.611-3.068-3.128-4.954-4.454c-0.924-0.649-2.158-0.528-2.939,0.23         l-0.153,0.149c-0.601,0.582-1.022,1.058-1.497,1.593c-0.461,0.522-0.902,1.05-1.334,1.583         c-0.867,1.063-1.664,2.17-2.445,3.282c-1.549,2.233-2.945,4.555-4.218,6.933c-2.557,4.753-4.605,9.745-6.224,14.845         c-1.626,5.101-2.799,10.323-3.54,15.589c-0.736,5.265-1.066,10.575-0.819,15.878c1.53-5.082,2.968-10.098,4.534-15.041         c1.555-4.943,3.214-9.812,5.073-14.579c1.841-4.773,3.91-9.431,6.204-13.95c1.158-2.253,2.379-4.469,3.681-6.623         c0.646-1.08,1.339-2.125,2.027-3.165c0.346-0.518,0.701-1.029,1.064-1.523c0.347-0.481,0.764-1.01,1.056-1.385l-3.091,0.38         c1.597,0.879,3.161,2.013,4.67,3.263c1.511,1.253,2.969,2.626,4.396,4.056c1.426,1.432,2.833,2.914,4.185,4.457         C768.538,3288.184,769.876,3289.757,771.225,3291.352z",
    style: {
      fill: "#90A05D"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "291.239,3388.495 413.679,3334.622 413.679,3438.269 291.239,3501.14      ",
    style: {
      fill: "#9B9B9B"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 112.645,
    style: {
      fill: "#C1C1C1"
    },
    width: 655.284,
    x: 291.239,
    y: 3388.495
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M384.656,3414.905c1.644,0,2.975,1.332,2.975,2.976v83.259h-5.951v-83.259         C381.681,3416.237,383.013,3414.905,384.656,3414.905z",
    style: {
      fill: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.015,3414.905c1.644,0,2.975,1.332,2.975,2.976v83.259h-5.951v-83.259         C494.04,3416.237,495.372,3414.905,497.015,3414.905z",
    style: {
      fill: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.374,3414.905c1.644,0,2.975,1.332,2.975,2.976v83.259h-5.951v-83.259         C606.399,3416.237,607.731,3414.905,609.374,3414.905z",
    style: {
      fill: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.734,3414.905c1.644,0,2.975,1.332,2.975,2.976v83.259h-5.951v-83.259         C718.759,3416.237,720.091,3414.905,721.734,3414.905z",
    style: {
      fill: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.093,3414.905c1.644,0,2.975,1.332,2.975,2.976v83.259h-5.951v-83.259         C831.118,3416.237,832.45,3414.905,834.093,3414.905z",
    style: {
      fill: "#ADADAD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    height: 35.852,
    style: {
      fill: "#ADADAD"
    },
    width: 655.284,
    x: 291.239,
    y: 3388.495
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M927.198,3381.551c0,0,3.897-17.021,15.214-20.659c11.317-3.637,24.654-2.829,27.484-6.063       c2.829-3.233-10.913-7.679-17.783-6.871c-6.871,0.808-30.313-0.404-38.8,5.254c0,0,17.784-22.229,25.463-27.484       c0,0-20.613-4.446-32.334,6.063c0,0,4.446-14.954,2.829-20.208c-1.617-5.254-7.275-4.85-9.7-2.425       c-2.425,2.425-7.275,11.721-13.742,14.954c-6.467,3.233-12.529,7.275-12.529,7.275s-19.4-28.292-25.463-27.484       c-6.063,0.808-3.638,27.08-4.85,32.334c-1.213,5.254-6.467,10.537-11.317,6.481s-11.317-13.756-17.379-13.352       c-6.063,0.404-11.721,14.175-16.167,13.352c-4.446-0.823-6.063-30.327-13.338-29.923c-7.275,0.404-6.467,25.059-7.679,27.888       c-1.212,2.829-6.467-14.954-13.338-14.146c-6.871,0.808-5.202,33.207-1.591,44.694v6.561l44.433,5.734L927.198,3381.551z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.521,3373.516c0,0,5.665-25.556,3.24-40.511c-2.425-14.954-8.083-25.093-11.317-29.117       c-3.233-4.025-13.338,10.526-18.592,25.48c-5.254,14.954-4.752,33.207-4.195,40.854       C864.657,3370.221,881.369,3380.076,895.521,3373.516z",
    style: {
      fill: "#9EAD6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.517,3374.396c0,0,3.985-17.915-0.805-34.907c-4.79-16.992-11.257-18.205-13.278-16.992       c-2.021,1.213-6.467,14.146-5.658,28.292c0.808,14.146,2.864,26.621,2.864,26.621S837.382,3375.774,842.517,3374.396z",
    style: {
      fill: "#9EAD6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.499,3375.769c0,0,7.365-9.218,9.386-22.151c2.021-12.933,4.446-21.017,6.063-25.867       c1.617-4.85,1.617-9.296-2.425-8.488c-4.042,0.808-16.975,8.926-27.079,20.226c-10.104,11.3-12.926,32.215-12.926,32.215       S794.305,3378.116,804.499,3375.769z",
    style: {
      fill: "#9EAD6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.581,3372.993c0,0,2.447-12.909,0-27.459c-2.447-14.55-8.913-23.38-8.913-23.38       s-9.7,12.909-12.934,25.42c0,0-7.275-41.278-12.529-43.686c-5.254-2.408-21.017,35.248-10.913,72.398       C698.292,3376.285,735.923,3379.839,743.581,3372.993z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.871,3376.601c0,0,13.338-30.259-6.062-61.38c0,0-30.718,19.687-30.718,60.163       C640.091,3375.384,668.383,3380.993,676.871,3376.601z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769,3371.233c0,0-11.295-49.141-19.378-56.011c0,0-11.782,26.949-9.326,57.933       C740.296,3373.154,762.107,3380.765,769,3371.233z",
    style: {
      fill: "#9EAD6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.742,3375.609c0,0-18.117-63.874-66.617-71.831c0,0-2.533,37.838,22.378,69.504       C607.502,3373.282,642.375,3382.645,651.742,3375.609z",
    style: {
      fill: "#9EAD6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.466,3319.167c0,0-19.004,21.356-16.171,49.122l25.073,1.809       C588.368,3370.098,595.633,3340.897,579.466,3319.167z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.596,3309.275c0,0,8.02-21.117,28.639-27.255c0,0-6.167,11.915-2.339,33.201v14.281h-26.299       V3309.275z",
    style: {
      fill: "#A8B876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.17,3362.509c0,0-6.467-49.309-30.717-64.667c0,0-16.571,27.484,0,67.901l30.717,1.347       V3362.509z",
    style: {
      fill: "#9EAD6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.515,3369.38c0,0-3.233-54.159-14.55-69.517c-1.617-4.046-38.396,1.482-57.796,67.227       C376.169,3367.09,427.902,3376.655,448.515,3369.38z",
    style: {
      fill: "#90A05D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.233,3371.296c0,0,7.691-37.483,2.436-50.012c-4.85-2.116-17.379,8.488-17.379,8.488       s-21.825-33.546-26.271-33.95c-4.446-0.404-6.871,30.313-6.871,30.313s-12.529-13.338-14.954-13.338s0,18.188,0,18.188       s-23.846-1.321-27.079,2.573c-3.233,3.894,29.909,30.973,48.096,36.632C380.21,3370.188,410.096,3374.425,422.233,3371.296z",
    style: {
      fill: "#9EAD6C"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M384.448,3370.728c-2.619-0.311-4.237-0.539-4.237-0.539        c-18.188-5.659-51.33-32.738-48.096-36.632c3.233-3.894,27.079-2.573,27.079-2.573s-2.425-18.188,0-18.188        c2.425,0,14.954,13.338,14.954,13.338s8.488,23.666,10.508,43.964L384.448,3370.728z",
    style: {
      fill: "#A8B876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.114,3333.557c3.234-3.894,27.079-2.573,27.079-2.573s15.763,32.334,21.017,39.205        C362.023,3364.53,328.88,3337.451,332.114,3333.557z",
    style: {
      fill: "#9EAD6C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M498.632,3324.504c0,0-3.233-27.066-12.125-33.533c-8.892-6.467-25.867,31.121-16.571,65.476       c2.829,9.296,5.658,19.585,5.658,19.585l33.731-1.434L498.632,3324.504z",
    style: {
      fill: "#A8B876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.484,3370.427c0,0-19.336-48.74-41.161-55.206c-4.85,3.946-18.009,25.686-3.144,54.877       C446.179,3370.098,482.74,3373.092,490.484,3370.427z",
    style: {
      fill: "#9EAD6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.453,3365.743c0,0-21.421-46.075-47.692-40.821c-3.233,3.638,4.411,26.78,17.564,45.177       C509.325,3370.098,533.795,3372.209,539.453,3365.743z",
    style: {
      fill: "#90A05D"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M934.328,3388.495c0,0-9.7-12.244-21.825-13.861c-12.125-1.617-18.592,0-28.292-3.233       c-9.7-3.233-28.292-0.808-39.609,2.425c-11.317,3.233-27.888,5.658-38.396,2.425c-10.508-3.233-38.396-6.467-50.521-4.446       c-12.125,2.021-30.313,1.213-42.438,2.829c-12.125,1.616-42.438,2.829-58.605,1.212c-16.167-1.617-33.95,1.617-45.267-2.021       c-11.317-3.638-37.973-9.336-51.31-9.336c-13.338,0-15.719,0.175-31.077,2.6c-15.358,2.425-35.63,4.311-48.564,2.29       c-12.934-2.021-40.417,2.021-51.734,2.021c-11.317,0-35.971-2.829-46.48-1.213c-10.508,1.617-43.246,18.307-43.246,18.307       H934.328z",
    style: {
      fill: "#996E5D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.858,3383.526c11.755-1.315,48.195-3.975,60.538-2.212       c12.343,1.763,35.852,0.588,48.783-1.763c12.931-2.351,28.8-4.114,39.545-1.271c10.745,2.844,17.466,6.56,24.272,5.245       c6.805-1.315,36.688-1.624,45.65,0c8.962,1.624,19.25,1.903,29.241,0c9.992-1.903,50.547-1.624,59.822,0       c9.276,1.624,24.226-1.624,37.468-5.734c13.241-4.11,40.243,3.522,51.411,5.873c11.167,2.351,36.44,0.588,50.737-3.659       c14.296-4.247,37.425,3.072,41.54,0c2.374-1.772-0.156-4.32-2.721-6.159c2.79,0.122,5.83,0.316,9.359,0.787       c12.125,1.616,21.825,13.861,21.825,13.861H336.964c0,0,32.738-16.69,43.246-18.307       C371.186,3388.45,405.103,3384.841,416.858,3383.526z",
    style: {
      fill: "#916553"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1560.93,3073.998c-0.304-13.875-2.423-97.143-11.25-197.185          c-8.059-91.34-19.657-192.403-23.312-223.664c-1.41-46.874-39.848-84.441-87.064-84.441c-48.109,0-87.108,39-87.108,87.108          c0,2.433,0.105,4.842,0.3,7.225l-0.3,0.034c0,0,19.235,177.442,100.697,412.956c0,29.845,24.194,54.039,54.039,54.039          s54.039-24.194,54.039-54.039C1560.971,3075.35,1560.954,3074.673,1560.93,3073.998z",
    style: {
      fill: "#F6AF9A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1409.432,2682.254c-11.287,3.963-20.788-41.718-20.788-41.718l-32.079,54.542         c4.903,32.283,14.473,87.412,31.335,158.098c8.609-43.421,25.066-125.879,28.425-138.757         c4.595-17.614,45.185-52.077,56.672-81.179C1472.997,2633.24,1435.608,2673.063,1409.432,2682.254z",
    style: {
      fill: "#D48770"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1414.781,2561.892c0,0-77.527,4.72-69.391,115.001        c8.136,110.281,69.403,307.103,83.188,350.756s33.922,116.314,85.887,110.617c24.394-4.165,51.199-27.14,51.965-63.901        c0.766-36.76-25.652-363.775-38.292-437.296C1515.498,2563.548,1447.862,2555.798,1414.781,2561.892z",
    style: {
      fill: "#934481"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1560.971,3076.031c0-29.845-24.194-54.039-54.039-54.039          c-26.66,0-48.808,19.306-53.233,44.699c0,0-12.333,46.237-17.139,113.184c-6.049,84.253,18.752,197.807,17.139,281.69          c0,14.699,11.917,26.616,26.616,26.616c14.7,0,26.616-11.917,26.616-26.616c0,0,39.795-291.165,51.421-368.883          C1560.051,3087.437,1560.971,3081.842,1560.971,3076.031z",
    style: {
      fill: "#F6AF9A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1502.865,3011.566c0,0-48.015,6.646-58.087,63.824         c-10.073,57.179-19.263,129.168-3.18,263.19c0,0,43.653,12.254,85.774,7.659c0,0,33.92-225.125,38.404-263.434         C1570.259,3044.497,1542.689,3009.269,1502.865,3011.566z",
    style: {
      fill: "#934481"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1440.358,3528.956c0,0-3.508-0.447-4.751,2.276c-1.243,2.723-1.48,9.871,0,10.552          c1.48,0.681,23.604,2.723,36.879,3.744c13.274,1.021,46.291,0.681,61.267,3.744c14.976,3.063,73.861,8.509,91.901,4.425          c3.236-1.021,3.051-8.298,1.185-9.595C1624.974,3542.805,1440.358,3528.956,1440.358,3528.956z",
    style: {
      fill: "#212851"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1626.84,3544.103c-1.866-1.298-186.482-15.147-186.482-15.147s-2.16-0.268-3.691,0.932          c1.229,3.855,10.874,8.17,23.31,8.577c15.572,0.511,46.461-0.51,62.289,2.298c15.827,2.809,48.12,9.7,76.456,8.424          c18.035-0.813,24.895-2.08,29.234-2.931C1627.733,3545.259,1627.35,3544.457,1626.84,3544.103z",
    style: {
      fill: "#171E3D"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1609.903,3515.335c-20.164-8.334-56.728-25.81-69.095-33.069          c-12.367-7.259-29.574-14.787-33.875-20.701c0-14.7-11.917-26.616-26.616-26.616c-14.7,0-26.616,11.916-26.616,26.616          c0,0-2.957,11.829-9.679,19.357c-6.721,7.528-12.636,29.843-7.259,42.748c5.377,12.905,25.272,13.98,44.629,12.905          c19.357-1.075,54.846,3.764,70.708,7.528c15.862,3.764,70.439,4.033,74.741,0          C1631.142,3540.069,1630.066,3523.67,1609.903,3515.335z",
    style: {
      fill: "#F6AF9A"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1451.924,3467.031c0,0,12.664,13.57,30.263,23.956          c21.188,12.504,68.415,27.311,68.415,27.311l-2.808,9.19c0,0-76.588-21.399-103.774-46.566          C1444.021,3480.922,1444.637,3472.692,1451.924,3467.031z",
    style: {
      fill: "#F0ECEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1563.488,3494.065c0,0-13.189,9.45-23.631,49.901c0,0,7.651,2.031,15.916,2.537          c0,0,5.807-22.843,11.678-27.949c0,0-1.599,23.883,0,29.398c0,0,8.36,2.112,20.676,1.358c0,0-4.604-23.839,4.591-41.466          C1592.718,3507.844,1579.691,3497.913,1563.488,3494.065z",
    style: {
      fill: "#F0ECEB"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1476.724,2504.99c-3.356-11.763-5.612-23.933-7.111-35.563        c0-0.001-13.495-41.607-103.828-41.607c-90.334,0-107.883,34.424-107.883,34.424c-0.331,24.512-4.316,50.435-13.906,74.201        c-18.551,45.974-31.456,79.849-28.23,119.37c3.226,39.521,118.193,62.361,171.232,46.377        c80.29-24.197,127.468-90.423,127.468-90.423S1490.071,2551.77,1476.724,2504.99z",
    style: {
      fill: "#F6AF9A"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1253.299,2481.348c0,0,167.11,10.722,219.698-5.105c0,0,27.57,79.647,34.718,97.007        s16.343,47.31,16.343,47.31s-60.251,58.561-86.29,76.338c-26.039,17.777-128.638,48.308-184.469,13.693        c-50.644-31.399-38.029-97.007-38.029-97.007s3.377-44.633,15.165-70.054        C1242.223,2518.108,1248.71,2507.919,1253.299,2481.348z",
    style: {
      fill: "#934481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440.576,2580.725c0,0,6.127,5.361,12.765,3.574c6.637-1.787,6.28-7.519,6.28-7.519        s6.229,4.966,14.908,2.668c8.679-2.297,7.148-8.424,7.148-8.424s6.382,7.403,13.785,4.595s6.382-9.19,6.382-9.19        s1.627,1.339,4.113,2.372c-1.421-3.69-3.206-8.493-5.207-13.977l-269.82-12.356c-0.165,0.354-0.327,0.701-0.495,1.062        c-2.022,4.361-3.797,9.288-5.35,14.458c0.976-0.537,1.566-1.004,1.566-1.004s-1.532,5.871,4.595,9.19        c6.127,3.319,13.53-1.277,13.53-1.277s1.276,7.511,6.892,9.5c5.616,1.988,13.019-3.628,13.019-3.628s1.147,6.568,8.998,8.645        c7.851,2.077,12.446-2.634,12.446-2.634s2.553,7.008,9.956,8.795c7.403,1.787,13.019-3.829,13.019-3.829        s5.105,8.935,14.296,8.935c9.19,0,10.276-4.851,10.276-4.851s3.509,7.914,11.168,7.658c7.658-0.255,9.955-6.382,9.955-6.382        s4.595,6.394,13.785,6.388c9.19-0.006,10.211-6.388,10.211-6.388s4.95,6.394,12.431,6.388        c7.481-0.006,9.523-8.175,9.523-8.175s5.105,7.148,11.743,6.127c6.637-1.021,7.403-7.914,7.403-7.914        s6.637,6.382,13.785,4.595C1440.832,2586.341,1440.576,2580.725,1440.576,2580.725z",
    style: {
      fill: "#8A3E78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.432,2682.254c-11.287,3.963-20.788-41.718-20.788-41.718l-41.813,52.009        c6.305,58.04,24.411,134.458,42.253,200.51c10.295-65.709,24.629-168.624,27.241-178.636        c4.595-17.614,45.185-52.077,56.672-81.179C1472.997,2633.24,1435.608,2673.063,1409.432,2682.254z",
    style: {
      fill: "#8A3E78"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1389.982,2655.816c0-48.108-39-87.108-87.108-87.108c-48.109,0-87.108,39-87.108,87.108         c0,0-7.461,90.334,4.335,229.868c11.796,139.534,14.216,190.347,14.216,190.347c0,29.845,24.194,54.039,54.039,54.039         c26.492,0,48.53-19.064,53.147-44.222c0,0,14.604-43.692,28.315-180c11.25-111.832,17.613-208.462,19.535-239.559         C1389.764,2662.855,1389.982,2659.361,1389.982,2655.816z",
    style: {
      fill: "#F6AF9A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1307.959,2556.093c0,0-77.775-7.862-92.689,57.49c-14.913,65.352-5.692,229.242-0.857,310.421        c0,0,8.444,158.785,15.064,178.697c6.619,19.912,34.7,38.292,59.718,35.229c25.017-3.063,45.44-10.211,59.736-58.204        c14.296-47.993,33.697-248.133,37.781-294.594C1390.797,2738.671,1429.599,2567.581,1307.959,2556.093z",
    style: {
      fill: "#934481"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1341.503,3085.848c0.584-3.184,0.892-6.464,0.892-9.817         c0-29.845-24.194-54.039-54.039-54.039c-20.611,0-38.525,11.54-47.638,28.51c0,0-34.631,59.203-54.593,128.768         c-19.962,69.565-68.083,261.42-68.083,261.42c-0.955,2.75-1.483,5.7-1.483,8.776c0,14.7,11.917,26.616,26.616,26.616         c11.621,0,21.496-7.45,25.125-17.832c0.005,0.002,150.874-289.181,171.788-366.565         C1340.664,3089.782,1341.138,3087.834,1341.503,3085.848C1341.503,3085.848,1341.503,3085.848,1341.503,3085.848z",
    style: {
      fill: "#F6AF9A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1308.086,3000.589c0,0-67.4-11.262-85.625,44.917        c-15.878,48.946-47.121,151.602-72.649,249.908c0,0,34.059,28.991,83.902,37.04c0,0,89.657-170.783,112.366-243.921        C1370.374,3010.29,1308.086,3000.589,1308.086,3000.589z",
    style: {
      fill: "#934481"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1076.5,3476.083c0,0-4.584,2.819-8.302,6.864c-2.406,2.617-1.907,6.332,0.163,9.223         c6.398,8.939,17.971,20.342,37.032,33.787c21.114,14.893,55.651,39.313,68.926,49.524         c13.275,10.211,31.33,18.545,36.25,19.912c6.127,1.702,13.146-1.237,17.231-9.602L1076.5,3476.083z",
    style: {
      fill: "#212851"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.441,3589.625c0.859-1.123,1.655-2.392,2.359-3.833L1076.5,3476.083         c0,0-1.324,0.817-3.12,2.193c0.272,2.701,1.907,7.888,9.037,15.516c10.977,11.743,64.586,51.056,77.605,59.991         C1171.812,3561.873,1210.001,3590.055,1225.441,3589.625z",
    style: {
      fill: "#171E3D"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1232.703,3565.879c-7.528-20.97-51.082-79.042-57.266-89.796         c-6.184-10.754-7.132-17.83-7.132-17.83c0.957-2.753,1.486-5.707,1.486-8.786c0-14.699-11.917-26.616-26.616-26.616         c-11.624,0-21.502,7.455-25.129,17.842c-0.005-0.002-4.714,4.742-11.704,7.43c-6.99,2.688-25.272,13.174-29.842,27.961         c-4.571,14.787,41.134,41.941,55.921,55.115c14.787,13.173,69.364,46.78,79.58,52.964         C1222.218,3590.345,1240.231,3586.85,1232.703,3565.879z",
    style: {
      fill: "#F6AF9A"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1150.59,3547.105c0,0,22.608-22.96,52.27-30.989c0,0,9.774,11.289,14.868,22.436         c0,0-18.64,15.379-25.919,36.621c0,0-13.151-7.094-18.001-11.689c0,0,11.743-14.234,17.104-17.839         c0,0-2.784-2.328-6.753-1.307c-3.969,1.021-18.442,13.418-18.442,13.418S1159.47,3554.803,1150.59,3547.105z",
    style: {
      fill: "#F0ECEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.22,3479.496c0,0-10.634,15.771-26.206,25.471l6.525,5.256         c0,0,17.894-11.326,26.318-24.855L1121.22,3479.496z",
    style: {
      fill: "#F0ECEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.412,3439.417c0,0-8.566,3.116-12.069,8.706c0,0,15.591,51.36,50.208,93.572l7.21-5.724         C1163.76,3535.97,1127.858,3482.304,1118.412,3439.417z",
    style: {
      fill: "#F0ECEB"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1555.284,2428.71c0.009-0.004-40.776-191.104-55.839-231.842          c-6.083-19.393-23.711-33.89-45.197-34.979c-27.583-1.397-51.075,19.83-52.472,47.413          c-0.29,5.732,0.399,11.287,1.917,16.504c0.358,1.229,0.762,2.44,1.21,3.629c7.741,23.133,51.163,151.57,86.686,229.253          c4.402,13.62,16.84,23.777,31.985,24.544c19.575,0.992,36.247-14.073,37.238-33.647          C1561.2,2441.925,1559.121,2434.715,1555.284,2428.71z",
    style: {
      fill: "#F6AF9A"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1453.827,2209.954c0,0-23.376-16.772-52.068-0.096c-0.219,5.535,0.465,10.9,1.934,15.948          c0.358,1.229,0.762,2.439,1.21,3.629c6.68,19.96,39.925,118.322,71.738,194.831c0.804-9.983,2.409-24.227,5.154-27.017          c4.312-4.383,18.37-19.518,24.679-33.058c6.309-13.54-14.466-67.646-27.426-94.374          C1466.089,2243.089,1453.827,2209.954,1453.827,2209.954z",
    style: {
      fill: "#EF9D8B"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1465.297,2247.139c0,0,16.89,20.045,53.674,21.132c0,0,32.83,64.011,37.096,70.623         c4.266,6.612-1.439,16.925-9.258,16.238c0,0-0.61,23.008-29.865,16.548c0,0-9.002,24.105-33.128,15.97         c0,0-13.813,20.76-34.707,6.665l-22.483-101.929L1465.297,2247.139z",
    style: {
      fill: "#F08875"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1544.167,2363.849c-7.581,3.673-19.349,4.907-22.736-2.251          c-2.452-5.183-28.031-72.138-28.031-72.138l23.544,82.221C1533.496,2375.335,1540.877,2369.556,1544.167,2363.849z",
    style: {
      fill: "#E87A66"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1546.809,2355.132c6.622,0.582,11.726-6.727,10.541-12.995          c-2.615,1.874-6.374,2.605-9.839-0.859c-5.028-5.026-31.904-53.078-31.904-53.078L1546.809,2355.132z",
    style: {
      fill: "#E87A66"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1471.057,2382.169c-2.514,6.93-14.271,11.915-22.108,11.426l0.159,0.72          c20.894,14.094,34.707-6.665,34.707-6.665l-21.338-93.448C1462.477,2294.202,1473.929,2374.254,1471.057,2382.169z",
    style: {
      fill: "#E87A66"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1792.296,2450.001c4.088-10.119-0.8-21.636-10.919-25.724         c-2.804-1.133-5.715-1.574-8.546-1.407c-63.747-9.575-247.226-9.966-247.226-9.966c-14.077-0.032-27.423,8.352-33.019,22.201         c-7.342,18.173,1.437,38.856,19.61,46.198c3.694,1.492,7.491,2.308,11.259,2.525c39.723,14.55,245.361-22.001,245.361-22.001         l0.016-0.152C1778.35,2464.253,1788.509,2459.373,1792.296,2450.001z",
    style: {
      fill: "#F6AF9A"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1833.455,2431.703c0,0,5.125,7.678,7.193,15.652s7.8,22.493,15.25,21.377          c5.225-1.558,3.73-10.512,3.73-10.512l-4.032-26.703L1833.455,2431.703z",
    style: {
      fill: "#BF7062"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1834.61,2430.361c0,0,9.95,9.959,12.109,13.881s12.301,22.234,17.862,26.574          c5.561,4.34,9.16,3.157,10.207,1.255c1.047-1.903-3.081-14.6-4.847-21.724c-1.765-7.124-11.155-21.549-11.155-21.549          L1834.61,2430.361z",
    style: {
      fill: "#C97B69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1828.406,2429.598c0,0,23.204,9.556,26.185,11.751c2.981,2.195,16.789,15.472,19.748,19.492          s14.91,14.225,20.655,10.462c1.598-1.429-0.112-5.702-3.173-10.548c-3.061-4.846-17.283-24.675-17.283-24.675          S1850.945,2419.773,1828.406,2429.598z",
    style: {
      fill: "#D48770"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1904.508,2451.751c-0.404-1.675-31.032-33.475-33.56-34.395s-35.855-7.454-43.007-7.114          c-5.982,0.284-48.812,9.168-62.672,12.069c-1.488,0.142-2.936,0.448-4.322,0.908c-7.021,2.329-12.442,8.521-13.404,16.351          c-1.331,10.832,6.37,20.692,17.203,22.024c0.4,0.049,0.798,0.082,1.196,0.107c10.31,0.495,23.35,5.145,33.265,10.426          c9.915,5.282,22.366,3.155,30.543,2.738c8.177-0.417,17.781-0.862,17.949-3.889c-3.847-10.021-24.753-8.528-27.456-9.672          c-2.704-1.145-10.901-10.482-9.258-13.937c1.643-3.455,11.75-14.605,18.39-15.739c6.64-1.133,29.798,0.533,34.054,2.275          c4.255,1.742,22.245,17.361,27.877,19.475C1896.938,2455.493,1904.911,2453.426,1904.508,2451.751z",
    style: {
      fill: "#F6AF9A"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1392.954,2146.831l-12.495-88.843c-2.082-17.636-15.511-32.55-33.905-35.704          c-22.391-3.839-43.655,11.2-47.495,33.591c-0.522,3.047-0.693,6.073-0.545,9.037c-0.001,0,0.189,96.482,0.189,96.482          c-0.014,0.673-0.011,1.344,0.004,2.013l0,0.099c0.538,22.665,17.02,42.525,40.208,46.5          c26.343,4.517,51.359-13.176,55.876-39.519C1396.198,2162.281,1395.449,2154.201,1392.954,2146.831z",
    style: {
      fill: "#F6AF9A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1380.459,2057.988c-2.082-17.637-15.511-32.55-33.905-35.704         c-22.391-3.839-43.655,11.2-47.495,33.591c-0.522,3.047-0.693,6.073-0.545,9.037c-0.001,0,0.009,5.011,0.009,5.011         c21.751,39.629,57.627,67.465,93.727,71.906L1380.459,2057.988L1380.459,2057.988z",
    style: {
      fill: "#E57E73"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1334.209,1875.937c0,0-79.587,5.993-74.259,100.196           c5.119,90.492,83.976,161.698,148.419,140.219c20.425-8.159,32.283-55.839,30.327-126.755           C1436.74,1918.681,1404.444,1870.795,1334.209,1875.937z",
    style: {
      fill: "#F6AF9A"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1386.083,2033.71c0,0-3.371-7.682-21.971-7.469c-15.12,0.173-26.514,2.351-26.469,11.771            C1336.522,2050.23,1393.873,2052.62,1386.083,2033.71z",
    style: {
      fill: "#EA9A88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1415.454,2035.715c-0.139,4.59,13.707,7.138,21.73,7.865            c0.571-5.981,1.003-12.276,1.292-18.859C1428.017,2024.604,1415.024,2026.541,1415.454,2035.715z",
    style: {
      fill: "#EA9A88"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1421.146,2061.933c0.935-0.043,1.559,0.939,1.133,1.772            c-1.974,3.858-7.709,12.433-19.985,13.257c-15.628,1.049-23.768-7.208-26.66-11.014c-0.594-0.782-0.076-1.908,0.905-1.953            L1421.146,2061.933z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.846,2082.979c-4.792-0.32-8.444,1.063-8.645,1.14            c-0.981,0.381-1.469,1.484-1.089,2.466c0.38,0.98,1.482,1.467,2.462,1.09c0.096-0.036,5.343-1.97,10.97-0.142            c0.999,0.325,2.077-0.222,2.402-1.224c0.325-1.001-0.223-2.076-1.224-2.402            C1404.03,2083.358,1402.38,2083.081,1400.846,2082.979z",
    style: {
      fill: "#EA9A88"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1399.713,2049.919c3.014,0.117,8.488,0.081,11.704-1.44           c4.359-2.061,2.942-5.908,1.301-10.362l-0.206-0.56c-9.877-26.898-7.989-35.097-7.97-35.207           c0.207-1.276-0.652-2.488-1.926-2.705c-1.279-0.215-2.483,0.627-2.709,1.9c-0.087,0.49-2.229,9.261,8.19,37.634           l0.207,0.564c0.638,1.732,1.357,3.685,1.326,4.361c-0.046,0.03-0.117,0.072-0.223,0.122           c-2.415,1.142-8.249,1.147-11.355,0.883c-1.284-0.107-2.432,0.849-2.543,2.143c-0.111,1.294,0.848,2.433,2.142,2.543           C1397.899,2049.818,1398.654,2049.878,1399.713,2049.919z",
    style: {
      fill: "#E57E73"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1386.525,1979.74c0,0,3.474-0.095,3.422,2.212c-0.052,2.308-0.789,7.386-2.291,7.952            s-19.336-0.725-26.252-0.855c-6.917-0.13-18.013,1.187-18.521,0.369c-0.507-0.818,3.959-4.923,11.888-6.744            C1361.51,1981.126,1377.428,1978.773,1386.525,1979.74z",
    style: {
      fill: "#824141"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1444.05,1988.419c0,0,3.329,0.267,3.619-1.802c0.371-2.653-10.406-7.224-29.388-6.852            c-5.562,0.384-5.233,6.965-3.943,10.036C1415.528,1992.636,1423.827,1987.582,1444.05,1988.419z",
    style: {
      fill: "#824141"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1358.668,2013.981c-0.38,0-0.761-0.141-1.057-0.426c-0.606-0.584-0.625-1.548-0.041-2.155            c4.854-5.044,9.905-7.48,15.042-7.242c7.304,0.341,11.916,6.027,12.109,6.269c0.525,0.658,0.416,1.617-0.242,2.141            c-0.656,0.525-1.614,0.417-2.139-0.239c-0.039-0.048-3.986-4.867-9.9-5.128c-4.205-0.172-8.465,1.939-12.674,6.312            C1359.467,2013.824,1359.068,2013.981,1358.668,2013.981z",
    style: {
      fill: "#121D3F"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1412.914,2011.461c-0.329,0-0.661-0.106-0.94-0.325c-0.662-0.519-0.778-1.477-0.259-2.14            c3.288-4.193,7.012-6.405,11.068-6.577c6.458-0.265,11.177,4.751,11.375,4.965c0.573,0.616,0.539,1.581-0.078,2.154            c-0.616,0.573-1.577,0.539-2.152-0.075c-0.039-0.042-4.053-4.22-9.038-3.998c-3.117,0.139-6.071,1.959-8.778,5.411            C1413.813,2011.26,1413.366,2011.461,1412.914,2011.461z",
    style: {
      fill: "#121D3F"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1442.01,2100.638c-6.469-16.65,2.03-84.347,3.423-100.426s4.995-84.616-32.314-114.565           c-37.308-29.949-73.581-15.483-73.581-15.483c-129.308-10.517-101.546,133.33-100.659,149.799           c0.886,16.469-0.953,24.702-5.876,38.754c-4.923,14.053-2.692,25.823-2.168,36.366           c0.523,10.542-10.488,20.384-7.373,24.874c3.115,4.491,12.067,6.66,20.763,3.56c8.696-3.099,12.116-4.987,26.356-2.453           c14.24,2.534,28.056,6.978,28.041-0.602c-0.015-7.579-0.091-46.389-0.108-55.552c-0.017-9.163,12.072-21.899,12.236-36.743           c0.164-14.844,2.165-26.592,10.21-37.978c8.045-11.386,12.402-26.29,19.239-34.442c6.837-8.152,14.04-13.91,14.04-13.91           c2.739,6.686-1.812,10.568-7.786,22.753c-5.974,12.185-3.883,22.645-3.883,22.645c2.33-13.587,10.511-12.184,19.907-29.999           c15.271-34.678,1.735-47.1,1.735-47.1c9.238-0.229,23.09,6.549,30.199,20.977c3.633,7.374,10.251,15.744,14.291,22.394           s18.173,8.814,16.764,4.947c-1.409-3.868,0.65-14.134,0.65-14.134c1.641,7.275,6.416,19.749,8.911,24.839           c0.66,1.347,2.986,7.938,2.986,7.938c0.337,4.08,0.567,8.247,0.684,12.5c0.092,3.331,0.153,6.61,0.185,9.836           c0.177,4.984-0.11,10.408-0.23,16.151c-0.147,7.037-0.215,14.553-0.976,22.324c-2.603,33.11-9.228,57.428-18.919,70.003           c-3.15,4.087-6.623,6.938-10.387,8.441c-6.24,2.08-12.616,3.285-19.046,3.692c-0.08,0.007-0.135,0.012-0.135,0.012           l1.609,11.44c0,0,22.226,2.245,27.098-2.463c4.872-4.708,14.408,1.021,24.868-1.071           C1453.223,2125.871,1448.479,2117.287,1442.01,2100.638z",
    style: {
      fill: "#8C4949"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1242.885,2107.882c-1.332-0.223-1.928-1.966-0.919-2.923            c5.714-5.653,4.827-21.523,0.092-30.551c-8.103-22.551,22.259-28.542,7.437-67.917c-4.618-13.634,3.15-22.113,9-31.279            c1.872-2.954,1.326-5.984,0.423-11.004c-9.159-42.808,16.071-79.562,57.419-81.342c2.197-0.053,2.384,3.345,0.126,3.443            c-42.398,2.417-62.235,38.968-54.152,77.29c0.978,5.439,1.685,9.37-0.905,13.458c-5.457,8.569-12.758,16.466-8.657,28.296            c14.868,41.347-13.967,46.77-7.642,67.456C1250.169,2082.819,1252.214,2103.154,1242.885,2107.882z",
    style: {
      fill: "#824141"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.172,2105.967c-7.145-15.484-3.812-33.712,1.388-40.898            c6.145-8.45,2.217-19.146-5.57-32.608c-8.765-15.152,7.648-34.453,13.041-40.796c3.399-3.997,2.127-8.902,0.517-15.113            c-7.388-19.877,5.587-24.244,17.584-36.592c3.831-4.515,3.608-9.37,3.349-14.991            c-5.053-25.317,25.344-32.341,35.703-34.484c2.158-0.411,2.883,2.943,0.664,3.381            c-51.608,12.8-22.826,25.236-37.088,48.324c-6.027,7.761-19.948,13.559-18.855,23.887            c0.681,9.43,7.524,19.662,0.752,27.82c-5.004,5.884-20.231,23.791-12.684,36.837c23.366,38.142-8.142,30.878,3.172,73.155            C1275.434,2105.048,1274.343,2106.198,1273.172,2105.967z",
    style: {
      fill: "#824141"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.948,1947.092c-2.332-0.933-2.041-4.663-3.007-6.655            c-1.737-6.056-3.38-11.775-7.57-15.052c-3.628-2.838-3.806-5.524-3.995-8.368c1.389-16.305-22.587-21.395-34.327-22.345            c-2.211-0.156-1.913-3.687,0.322-3.432c7.245,0.496,38.803,4.825,37.442,25.55c0.177,2.657,0.266,3.991,2.68,5.88            c5.072,3.967,6.863,10.208,8.76,16.816C1414.459,1941.727,1418.029,1946.898,1413.948,1947.092z",
    style: {
      fill: "#824141"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.538,1870.164c14.28,7.831,22.186,24.408,24.673,39.974            C1357.12,1896.195,1350.518,1881.571,1339.538,1870.164z",
    style: {
      fill: "#824141"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.982,1913.073c-24.158-10.358-21.105-36.435-64.519-31.841            c-2.203,0.204-2.502-3.313-0.254-3.439c1.24-0.092,30.485-2.13,39.979,8.75c16.226,18.594,22.84,22.862,25.538,23.156            C1430.169,1909.993,1429.36,1913.786,1426.982,1913.073z",
    style: {
      fill: "#824141"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1286.485,1999.192c0,0-12.52,3.339-9.117,23.4c3.269,19.27,18.883,39.295,32.178,33.145            c4.181-2.239,4.953-19.761,2.832-34.912C1310.257,2005.673,1301.413,1996.404,1286.485,1999.192z",
    style: {
      fill: "#F6AF9A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1304.656,2041.823c0.852-27.028-13.831-31.969-14.456-32.166           c-0.756-0.242-1.552,0.179-1.794,0.931c-0.242,0.752,0.173,1.559,0.923,1.806c0.422,0.139,8.245,2.883,11.291,15.823           c-4.776-3.889-11.18-3.554-11.527-3.532c-0.79,0.049-1.39,0.729-1.342,1.52c0.047,0.791,0.73,1.395,1.518,1.347           c0.369-0.021,8.982-0.438,12.277,6.386c0.232,2.346,0.33,4.929,0.239,7.795c-0.023,0.725,0.496,1.341,1.191,1.46           c0.065,0.011,0.132,0.018,0.199,0.02C1303.968,2043.238,1304.631,2042.616,1304.656,2041.823z",
    style: {
      fill: "#E57E73"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1468.944,2403.544c0,0,20.914-14.285,21.25-36.881          c0.337-22.595-26.315-102.281-35.114-135.838c-8.799-33.557,11.171-48.849,11.947-66.394c0,0-9.404-6.171-51.134-15.869          c-1.699-0.395-7.342-1.599-9.068-2.067c-18.655-5.054-40.492-7.966-65.068-6.208c0,0-57.724,7.611-91.75,25.655          s-52.461,37.66-57.761,50.614c-5.3,12.953,4.644,39.954,20.77,73.075c16.126,33.12,32.46,61.406,39.888,98.124          c3.588,17.736,5.367,39.526,3.9,62.384c0,0,16.445,54.132,108.274,58.784s102.803-40.899,102.803-40.899          C1465.179,2433.22,1468.944,2403.544,1468.944,2403.544z",
    style: {
      fill: "#F6AF9A"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1224.9,2313.551c11.789,23.728,22.419,46.58,28.007,74.204          c0.174,0.862,0.341,1.742,0.507,2.624c7.895-46.717,25.181-126.262,25.181-126.262          C1261.418,2272.435,1241.51,2293.282,1224.9,2313.551z",
    style: {
      fill: "#EF9D8B"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1208.67,2521.528c0,0-6.312,9.169-0.775,15.297c5.537,6.128,13.196,0.668,13.196,0.668         s-1.827,5.786,4.124,9.411c5.951,3.624,13.577-0.59,13.577-0.59s0.895,7.566,6.403,9.836         c5.509,2.27,13.186-2.965,13.186-2.965s0.813,6.617,8.549,9.089c7.735,2.472,12.563-2,12.563-2s2.195,7.128,9.498,9.288         c7.303,2.159,13.197-3.166,13.197-3.166s4.647,9.182,13.825,9.647c9.178,0.465,10.508-4.324,10.508-4.324         s3.104,8.081,10.766,8.214c7.662,0.132,10.266-5.87,10.266-5.87s4.266,6.618,13.444,7.077         c9.179,0.459,10.521-5.863,10.521-5.863s4.62,6.636,12.092,7.009s9.925-7.683,9.925-7.683s4.737,7.397,11.418,6.713         c6.68-0.684,7.794-7.529,7.794-7.529s6.306,6.71,13.535,5.287s7.258-7.045,7.258-7.045s5.848,5.664,12.567,4.215         s6.653-7.191,6.653-7.191s5.969,5.275,14.754,3.419s7.565-8.052,7.565-8.052s5.999,7.717,13.535,5.287         s6.839-8.855,6.839-8.855s8.307,7.584,16.514,1.99c2.098-1.047-3.353-12.314-3.353-12.314L1208.67,2521.528z",
    style: {
      fill: "#F08875"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1208.67,2521.528c142.698,77.265,299.943,28.997,299.943,28.997            c-8.975-22.437-34.208-144.362-34.208-144.362c6.208-4.821,24.876-26.857,20.934-52.617            c-3.943-25.761-30.042-92.007-30.042-92.007c-8.976,4.146-15.538-4.621-15.538-4.621            c-13.011-45.902-44.057-110.722-44.057-110.722l-6.225-1.537c0,0,51.512,103.119,37.928,113.933            c-13.584,10.814-31.835,36.388-31.835,36.388c-41.539-19.863-74.569-24.908-74.569-24.908            c-22.311-87.696-63.449-111.896-63.449-111.896s-1.747-2.919-8.304,3.505c0,0,48.727,22.023,63.713,109.688            c0,0-39.18,25.962-48.162,67.677c-16.601,5.828-34.635,7.512-34.635,7.512s12.07,54.485-2.716,105.88            C1226.747,2489.634,1208.67,2521.528,1208.67,2521.528z",
    style: {
      fill: "#EFDFDA"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1449.96,2561.892c-3.141-11.544-15.005-9.056-15.005-9.056l11.019-82.263            c0,0-7.514-15.011-50.74-17.201c-43.226-2.19-56.726,12.065-56.726,12.065l1.137,78.696c0,0-29.644-13.662-47.241-24.249            s-26.49-45.178-26.49-45.178s-25.876,25.844-42.02,54.569C1307.806,2569.375,1394.605,2568.67,1449.96,2561.892z",
    style: {
      fill: "#EBCEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.67,2521.528c43.631,23.625,88.622,35.512,130.062,40.632            c-74.373-17.823-79.45-82.424-68.655-129.89c8.362-36.77,0.814-74.345-3.434-90.694            c-13.849,3.8-26.479,4.981-26.479,4.981s12.07,54.485-2.716,105.88C1226.747,2489.634,1208.67,2521.528,1208.67,2521.528z            ",
    style: {
      fill: "#EBCEC5"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1474.456,2406.387c-9.63,2.574-25.478,6.894-32.101-2.061              c7.035-0.629,13.04,1.377,19.872,1.699c4.04,0.244,8.078,0.193,12.137-0.087              C1474.617,2405.913,1474.71,2406.309,1474.456,2406.387z",
    style: {
      fill: "#EBCEC5"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1298.857,2392.49c31.698,21.074,71.847,26.049,107.941,14.061              c0.236-0.09,0.432,0.291,0.191,0.419c-4.1,2.487-8.44,4.699-13.027,6.264              C1362.614,2424.498,1322.764,2412.156,1298.857,2392.49z",
    style: {
      fill: "#EBCEC5"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1407.611,2301.787c0,0,23.163-33.392,32.655-39.131c2.84-2.242-0.635-13.029-0.635-13.03           c0.255,4.353-0.39,7.503-2.226,8.965c-13.584,10.814-31.835,36.388-31.835,36.388           c-41.539-19.863-74.569-24.908-74.569-24.908l1.323,4.157C1332.324,2274.229,1393.821,2291.434,1407.611,2301.787z",
    style: {
      fill: "#F08875"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1468.525,2269.897c-1.985-5.202-3.228-8.358-3.228-8.358           c-8.976,4.146-15.538-4.621-15.538-4.621S1452.306,2267.089,1468.525,2269.897z",
    style: {
      fill: "#F08875"
    }
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1278.594,2264.116c1.506-4.356,2.432-8.995,2.677-13.83        c1.397-27.583-19.83-51.075-47.412-52.472c-22.889-1.159-42.961,13.262-49.927,33.966l-105.28,220.006        c-2.154,4.285-3.484,9.073-3.742,14.172c-0.992,19.575,14.073,36.247,33.648,37.239c16.492,0.835,30.923-9.727,35.652-24.782        c0.001,0,104.852-148.448,131.694-207.968C1276.938,2268.415,1277.839,2266.301,1278.594,2264.116L1278.594,2264.116z",
    style: {
      fill: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1287.703,2307.87c0,0-70.848,57.331-131.185-18.803l-59.134,56.337          c-2.545,2.424-3.544,6.082-2.499,9.438c1.837,5.896,7.16,14.161,22.509,15.983c0,0,1.079,22.675,23.377,21.504          c0,0,9.816,30.531,36.808,21.337c0,0,12.73,19.096,32.26,14.5c3.316-0.78,5.887-3.402,6.743-6.699l19.261-74.25          c0,0,26.443,7.805,47.169-7.755L1287.703,2307.87z",
    style: {
      fill: "#F08875"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.01,2339.461c0,0,11.81-11.663,18.544-24.763c6.734-13.1,11.868-28.795,21.407-43.33          c0,0-30.856,20.45-44.08,54.211L1283.01,2339.461z",
    style: {
      fill: "#F08875"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1189.63,2412.268c-1.159-9.944,19.441-66.408,19.441-66.408s-30.953,66.083-31.493,67.806          c0,0,12.73,19.096,32.26,14.5c0.288-0.068,0.568-0.154,0.844-0.249C1199.968,2424.65,1190.859,2422.813,1189.63,2412.268z",
    style: {
      fill: "#E87A66"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1169.065,2415.359c-7.249-0.237-19.607-9.626-16.704-19.716           c3.156-10.97,26.988-62.365,26.988-62.365l-38.578,59.051C1140.77,2392.329,1148.492,2416.336,1169.065,2415.359z",
    style: {
      fill: "#E87A66"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1118.037,2358.119c-4.364,3.783-14.632,4.334-22.01-0.371          c2.604,5.417,8.417,11.54,21.366,13.077l40.413-49.059C1157.807,2321.766,1124.351,2352.645,1118.037,2358.119z",
    style: {
      fill: "#E87A66"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1331.567,2561.281c-0.003-0.002-51.109-30.285-91.748-58.203         c-47.159-32.398-90.05-54.957-110.843-64.791c-2.623-1.626-5.399-2.876-8.257-3.751c-13.208-4.036-28.123-0.13-37.564,11.097         c-12.614,15.001-10.68,37.388,4.321,50.002c2.946,2.478,6.18,4.385,9.566,5.752c-0.002,0.006,217.737,95.653,217.737,95.653         c0.661,0.335,1.335,0.632,2.02,0.888c7.63,2.827,16.502,0.757,22.019-5.803c7.024-8.353,5.947-20.818-2.406-27.842         C1334.913,2563.021,1333.277,2562.025,1331.567,2561.281z",
    style: {
      fill: "#F6AF9A"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1403.77,2558.208c0,0-3.89-1.413-6.689,0.976c-2.799,2.389-2.589,13.104-4.191,19.396          c-1.603,6.292-5.128,15.184-8.12,20.308l9.632,4.405l13.78-38.199L1403.77,2558.208z",
    style: {
      fill: "#E57E73"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1415.296,2559.558c0,0-4.234-8.228-8.385-7.051c-4.151,1.177-3.639,13.726-4.617,18.963          c-0.979,5.237-10.859,26.698-15.37,30.809l14.191,1.922l22.213-31.114L1415.296,2559.558z",
    style: {
      fill: "#EB907C"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1430.97,2578.723c0,0-3.069-23.921-4.612-25.219c-1.543-1.298-8.4-0.418-10.606,4.781           c-2.206,5.199-1.329,14.426-1.449,18.014c0,0-8.579,11.227-9.828,14.393l-13.84,13.126           C1390.635,2603.819,1412.198,2619.844,1430.97,2578.723z",
    style: {
      fill: "#EF9D8B"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1349.069,2465.972l5.937,133.823c-0.13,2.569,14.245,5.384,32.108,6.289          c17.863,0.905,32.449-0.444,32.579-3.012l19.43-132.538L1349.069,2465.972z",
    style: {
      fill: "#B35E5E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1349.307,2471.35c3.159,2.402,21.756,5.062,44.318,6.205          c22.562,1.143,41.333,0.375,44.718-1.695l0.781-5.326l-90.056-4.562L1349.307,2471.35z",
    style: {
      fill: "#B35E5E"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1394.097,
    cy: 2468.253,
    rx: 4.657,
    ry: 45.086,
    style: {
      fill: "#A35656"
    },
    transform: "matrix(0.0506 -0.9987 0.9987 0.0506 -1141.5261 3735.6902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.99,2468.604c7.716,1.784,22.207,3.456,38.871,4.301           c16.664,0.844,31.25,0.645,39.107-0.35c-7.716-1.784-22.207-3.456-38.871-4.301           C1377.433,2467.409,1362.847,2467.608,1354.99,2468.604z",
    style: {
      fill: "#8B4949"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1440.952,2563.406c-10.017,0.007-16.941,24.219-16.941,24.219          c-4.089,2.357-12.76,12.981-12.76,12.981s-2.718,1.666-12.371,0.926c-9.652-0.74-28.435-9.421-28.154-14.454          c0.281-5.033,9.53-12.272,12.686-13.833c3.157-1.561,8.604-1.459,20.578-0.347c11.974,1.112,17.8-2.683,17.295-5.216          c-0.505-2.532-29.248-12.213-33.535-12.129c-4.286,0.084-24.571,1.862-32.419,4.09c-15.226,4.321-26.983-0.281-26.983-0.281          s-14.825,1.437-19.779,7.327c-7.024,8.353-5.947,20.818,2.406,27.842c2.921,2.456,6.345,3.918,9.863,4.428          c0.003,0.001,17.411,4.807,24.159,8.374c6.748,3.567,28.431,16.004,37.151,17.541c8.719,1.536,41.296-9.007,43.373-11.476          s12.507-25.839,15.692-33.699C1444.4,2571.838,1444.775,2562.933,1440.952,2563.406z",
    style: {
      fill: "#F6AF9A"
    }
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1810.473,3274.377c0,193.963-31.357,297.267-47.247,337.167         c12.066-0.87,24.944-3.857,33.305-13.968c38.352-46.378,50.762-170.921,50.762-308.88c0-143.981-4.655-260.011-51.48-297.175         c-7.645-6.067-18.161-7.401-29.152-7.635C1777.292,3005.748,1810.473,3088.844,1810.473,3274.377z",
    style: {
      fill: "#212851"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795.813,2991.521c-7.645-6.067-18.161-7.401-29.152-7.635         c7.271,1.109,13.959,3.425,19.263,7.635c46.825,37.163,51.48,153.194,51.48,297.175c0,137.959-12.411,262.502-50.763,308.88         c-1.776,2.148-6.736,6.759-13.553,12.689c8.838-1.738,17.342-5.313,23.442-12.689         c38.352-46.378,50.763-170.921,50.763-308.88C1847.293,3144.715,1842.639,3028.685,1795.813,2991.521z",
    style: {
      fill: "#313A6E"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1762.402,2991.067c-5.244,202.532-5.286,408.068,0,610.6           C1767.688,3399.136,1767.646,3193.599,1762.402,2991.067z",
    style: {
      fill: "#8FAAC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1687.739,3325.516c46.58-18.465,91.198-41.818,132.854-69.67           C1773.996,3274.275,1729.415,3297.699,1687.739,3325.516z",
    style: {
      fill: "#8FAAC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1711.263,3038.115c26.094,152.849,57.76,306.972,94.168,457.699           C1779.379,3342.957,1747.63,3188.851,1711.263,3038.115z",
    style: {
      fill: "#8FAAC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1694.677,3203.106c37.087,55.469,78.534,108.005,123.939,156.902           C1781.561,3304.515,1740.051,3252.03,1694.677,3203.106z",
    style: {
      fill: "#8FAAC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1806.968,3068.71c-36.881,156.384-69.146,316.193-95.705,474.658           C1748.186,3386.993,1780.368,3227.167,1806.968,3068.71z",
    style: {
      fill: "#8FAAC2"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1773.312,3288.696c0,28.316-5.796,59.321-5.796,59.321s-8.396,0-9.546,0           c-8.473,0-15.342-26.559-15.342-59.321s6.869-59.321,15.342-59.321c0.7,0,9.546,0,9.546,0           S1773.312,3258.641,1773.312,3288.696z",
    style: {
      fill: "#212851"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1767.516,
    cy: 3288.696,
    rx: 15.342,
    ry: 59.321,
    style: {
      fill: "#313A6E"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1717.911,3283.249c0-160.599,28.143-285.018,78.536-291.196          c-11.543-9.396-27.009-8.145-45.295-8.145c-53.097,0-82.845,126.291-82.845,304.789          c0,178.498,29.748,323.199,82.845,323.199c17.547,0,32.666,4.902,45.379-14.319          C1746.084,3590.652,1717.911,3443.94,1717.911,3283.249z",
    style: {
      fill: "#313A6E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1717.911,3283.249c0-160.599,28.143-285.018,78.536-291.196          c-4.3-3.5-9.146-5.521-14.477-6.681c-46.903,16.724-80.869,144.608-80.869,297.878c0,160.622,38.193,315.23,88.608,322.279          c2.346-2.032,4.621-4.624,6.822-7.951C1746.084,3590.652,1717.911,3443.94,1717.911,3283.249z",
    style: {
      fill: "#394380"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2215.387,3274.377c0,193.963,31.357,297.267,47.248,337.167         c-12.066-0.87-24.944-3.857-33.305-13.968c-38.352-46.378-50.762-170.921-50.762-308.88         c0-143.981,4.655-260.011,51.48-297.175c7.645-6.067,18.161-7.401,29.152-7.635         C2248.568,3005.748,2215.387,3088.844,2215.387,3274.377z",
    style: {
      fill: "#212851"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2230.047,2991.521c7.645-6.067,18.161-7.401,29.152-7.635         c-7.271,1.109-13.959,3.425-19.263,7.635c-46.825,37.163-51.48,153.194-51.48,297.175         c0,137.959,12.411,262.502,50.762,308.88c1.776,2.148,6.737,6.759,13.553,12.689c-8.838-1.738-17.343-5.313-23.442-12.689         c-38.352-46.378-50.762-170.921-50.762-308.88C2178.567,3144.715,2183.221,3028.685,2230.047,2991.521z",
    style: {
      fill: "#313A6E"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2263.458,2991.067c5.244,202.532,5.286,408.068,0,610.6           C2258.171,3399.136,2258.214,3193.599,2263.458,2991.067z",
    style: {
      fill: "#8FAAC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2338.121,3325.516c-46.58-18.465-91.198-41.818-132.854-69.67           C2251.864,3274.275,2296.445,3297.699,2338.121,3325.516z",
    style: {
      fill: "#8FAAC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2314.597,3038.115c-26.094,152.849-57.76,306.972-94.167,457.699           C2246.481,3342.957,2278.23,3188.851,2314.597,3038.115z",
    style: {
      fill: "#8FAAC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2331.183,3203.106c-37.087,55.469-78.534,108.005-123.939,156.902           C2244.299,3304.515,2285.809,3252.03,2331.183,3203.106z",
    style: {
      fill: "#8FAAC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2218.892,3068.71c36.881,156.384,69.146,316.193,95.705,474.658           C2277.674,3386.993,2245.492,3227.167,2218.892,3068.71z",
    style: {
      fill: "#8FAAC2"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2252.548,3288.696c0,28.316,5.796,59.321,5.796,59.321s8.396,0,9.546,0           c8.473,0,15.342-26.559,15.342-59.321s-6.869-59.321-15.342-59.321c-0.7,0-9.546,0-9.546,0           S2252.548,3258.641,2252.548,3288.696z",
    style: {
      fill: "#212851"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2258.344,
    cy: 3288.696,
    rx: 15.342,
    ry: 59.321,
    style: {
      fill: "#313A6E"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2307.949,3283.249c0-160.599-28.143-285.018-78.535-291.196          c11.543-9.396,27.009-8.145,45.295-8.145c53.097,0,82.845,126.291,82.845,304.789c0,178.498-29.748,323.199-82.845,323.199          c-17.547,0-32.666,4.902-45.379-14.319C2279.776,3590.652,2307.949,3443.94,2307.949,3283.249z",
    style: {
      fill: "#313A6E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2307.949,3283.249c0-160.599-28.143-285.018-78.535-291.196          c4.3-3.5,9.145-5.521,14.477-6.681c46.903,16.724,80.869,144.608,80.869,297.878c0,160.622-38.194,315.23-88.608,322.279          c-2.346-2.032-4.621-4.624-6.822-7.951C2279.776,3590.652,2307.949,3443.94,2307.949,3283.249z",
    style: {
      fill: "#394380"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 416.647,
    style: {
      fill: "#5468A8"
    },
    width: 22.964,
    x: 1860.533,
    y: 3179.703
  }), /*#__PURE__*/React.createElement("rect", {
    height: 416.647,
    style: {
      fill: "#5468A8"
    },
    width: 22.964,
    x: 2144.67,
    y: 3179.703
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "2241.69,3669.948 1785.818,3669.948 1841.03,3584.813 2186.478,3584.813        ",
    style: {
      fill: "#465A99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785.818,3669.948v14.503h455.872v-14.503         C2241.69,3669.948,1784.005,3669.948,1785.818,3669.948z",
    style: {
      fill: "#5468A8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1832.729,2829.444l-155.717,130.06c-1.343,1.122-2.12,2.782-2.12,4.532v7.265          c0,3.261,2.644,5.905,5.905,5.905h51.481c1.405,0,2.763-0.501,3.832-1.412l90.195-76.919          c1.389-1.185,2.152-2.945,2.067-4.769l-0.691-14.774c-0.035-0.742,0.071-1.484,0.311-2.187l14.11-41.257          C1844.035,2830.235,1837.314,2825.615,1832.729,2829.444z",
    style: {
      fill: "#6A7DBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1826.305,2898.875c1.389-1.185,2.152-2.945,2.067-4.769l-0.496-10.607l-91.973,76.422          c-2.616,2.174-5.911,3.364-9.312,3.364h-51.646c-0.032,0.248-0.053,0.498-0.053,0.751v7.265          c0,3.261,2.644,5.905,5.905,5.905h51.481c1.405,0,2.763-0.5,3.832-1.412L1826.305,2898.875z",
    style: {
      fill: "#465A99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2188.012,2829.444l155.717,130.06c1.344,1.122,2.12,2.782,2.12,4.532v7.265          c0,3.261-2.644,5.905-5.905,5.905h-51.481c-1.405,0-2.763-0.501-3.832-1.412l-90.195-76.919          c-1.389-1.185-2.152-2.945-2.067-4.769l0.691-14.774c0.035-0.742-0.071-1.484-0.311-2.187l-14.11-41.257          C2176.706,2830.235,2183.427,2825.615,2188.012,2829.444z",
    style: {
      fill: "#6A7DBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2194.436,2898.875c-1.389-1.185-2.152-2.945-2.067-4.769l0.496-10.607l91.973,76.422          c2.616,2.174,5.911,3.364,9.312,3.364h51.646c0.032,0.248,0.053,0.498,0.053,0.751v7.265c0,3.261-2.644,5.905-5.905,5.905          h-51.481c-1.405,0-2.763-0.5-3.832-1.412L2194.436,2898.875z",
    style: {
      fill: "#465A99"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1878.937,2562.314h-40.544v-99.558c0-9.375,7.6-16.976,16.976-16.976h6.593         c9.375,0,16.976,7.6,16.976,16.976V2562.314z",
    style: {
      fill: "#8AA6BF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2187.467,2562.314h-40.544v-99.558c0-9.375,7.6-16.976,16.976-16.976h6.593         c9.375,0,16.976,7.6,16.976,16.976V2562.314z",
    style: {
      fill: "#8AA6BF"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2258.666,3157.948l-56.366-162.176l14.256-449.882c0.327-10.586-7.649-19.59-18.197-20.549          c-32.411-2.946-103.857-8.361-191.198-8.361c-85.481,0-149.881,5.187-179.85,8.169          c-10.47,1.042-18.338,10.015-18.014,20.531l14.263,450.091l-56.366,162.176v56.366c0,9.284,7.526,16.811,16.811,16.811          h457.85c9.284,0,16.811-7.526,16.811-16.811V3157.948C2258.665,3157.948,2258.666,3157.948,2258.666,3157.948z",
    style: {
      fill: "#5468A8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1823.56,2995.772 2202.3,2995.772 2258.666,3157.948 1767.194,3157.948         ",
    style: {
      fill: "#465A99"
    }
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2167.721,2859.054l-148.512-4.527l-148.126,4.527c0,0-32.142,27.215-30.272,90.23        c0.685,23.081,50.018,8.084,71.769,28.833c31.588,30.132,69.776,50.507,106.551,50.507c0.026,0,0.052-0.001,0.078-0.001        c0.026,0,0.052,0.001,0.078,0.001c36.774,0,74.963-20.375,106.551-50.507c21.751-20.748,77.05,18.574,75.267-33.628        C2198.663,2872.994,2167.721,2859.054,2167.721,2859.054z",
    style: {
      fill: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1832.663,2945.289c0,0,3.995-26.256,7.42-43.95s16.553-47.946,16.553-47.946h338.476        c0,0,13.128,48.517,16.553,82.193c0.571,19.978-9.133,33.106-22.831,38.813c-13.699,5.708-46.804-1.712-54.795,3.996        c-7.991,5.708-56.508,53.083-111.303,53.083c-54.795,0-94.75-33.677-109.591-46.804        C1898.303,2971.545,1836.088,2972.687,1832.663,2945.289z",
    style: {
      fill: "#9E5959"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1834.946,2994.757c-2.672-57.531,9.171-80.415,55.345-91.141          c65.091-15.12,103.916,21.837,110.468,68.785c0.362,2.591,0.596,5.169,0.723,7.733          c2.74,29.464-28.025,166.665-28.025,166.665s-6.226,63.109-54.495,67.901c-42.158,4.186-54.289-11.528-60.423-37.291          C1858.19,3175.947,1836.563,3029.575,1834.946,2994.757z",
    style: {
      fill: "#E29888"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1836.658,2918.462c0,0-18.551,19.978-12.272,90.755           c6.279,70.777,13.984,184.078,19.692,190.928c0,0,5.73,16.586,59.932,21.405c59.932,5.327,84.762-17.694,88.186-34.247           c3.425-16.553,19.978-146.406,23.973-189.215c3.995-42.809-27.112-99.031-95.036-104.168           C1853.211,2888.781,1836.658,2918.462,1836.658,2918.462z",
    style: {
      fill: "#9E5959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2011.521,3021.83c-2.411-8.099-6.038-15.804-10.62-22.887           c3.483,7.79,6.48,15.811,8.387,24.125c-11.511-17.319-26.001-34.517-45.774-42.39           c15.229,8.703,27.059,22.101,37.478,35.984C2005.604,3022.477,2017.662,3044.325,2011.521,3021.83z",
    style: {
      fill: "#8C4E4E"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1975.798,3134.093c-3.069-30.984-29.519-54.879-61.178-54.235           c-31.659,0.644-57.115,25.596-58.921,56.679c0,0-16.251,61.751-7.437,165.835c8.814,104.084,38.682,241.935,38.682,241.935           c0.306,15.05,12.755,27.002,27.805,26.696c15.05-0.306,27.002-12.755,26.696-27.805c0,0,29.721-118.652,38.645-244.142           C1987.521,3194.582,1975.798,3134.093,1975.798,3134.093z",
    style: {
      fill: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1947.733,3582.709c-3.343-20.841-6.003-38.805-6.003-38.805            c0.176-15.052-11.884-27.396-26.936-27.572c-15.052-0.176-27.397,11.884-27.572,26.936c0,0-3.896,26.495-11.31,47.211            c-7.415,20.716-26.158,51.646-24.875,64.573c1.284,12.927,14.017,22.681,69.449,18.923            c20.765-1.408,45.103-3.246,45.245-15.438S1951.076,3603.55,1947.733,3582.709z",
    style: {
      fill: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1968.787,3655.02c0,0-0.51,12.432-1.732,15.285c-1.223,2.853-34.24,6.114-61.55,6.114             c-27.31,0-51.053-7.337-56.149-11.006c-2.395-2.293,0.51-18.037,0.51-18.037L1968.787,3655.02z",
    style: {
      fill: "#E1DAEA"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1945.553,3566.976c0,0,5.808,17.426,7.948,25.374              c2.14,7.948,15.285,39.131,15.285,62.67c0,0-21.094,7.643-65.116,7.643c-44.022,0-53.805-15.285-53.805-15.285              s2.244-15.172,10.547-31.947c7.49-15.133,13.91-34.698,22.47-48.455              C1882.883,3566.976,1916.816,3550.162,1945.553,3566.976z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1928.059,3569.123c-0.884,23.528,10.956,29.082,12.224,47.627               C1929.894,3605.226,1923.628,3583.871,1928.059,3569.123z",
    style: {
      fill: "#E1DAEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1895.299,3569.108c2.981,16.664-1.921,35.577-12.697,47.643               c-0.587-10.846,7.395-19.304,10.135-29.19C1894.43,3581.981,1893.595,3573.482,1895.299,3569.108z",
    style: {
      fill: "#E1DAEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1946.165,3636.066c-24.519-0.198-48.877-0.531-73.37,0               C1896.454,3628.966,1922.458,3629.35,1946.165,3636.066z",
    style: {
      fill: "#E1DAEA"
    }
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1901.902,3077.841c0,0-53.295,3.465-57.168,72.759           c-4.411,78.942,0.611,151.021,6.726,234.173c6.114,83.153,18.43,133.431,22.098,143.825c0,0,19.116,3.287,37.83,3.287           c16.595,0,41.502-3.287,41.502-3.287s22.688-98.58,29.414-167.67c6.726-69.09,11.923-191.986,9.477-226.225           C1989.335,3100.463,1948.37,3069.892,1901.902,3077.841z",
    style: {
      fill: "#9E5959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1865.483,3181.309c28.694-19.762,69.582-19.003,98.46,0           C1932.457,3168.803,1896.811,3167.973,1865.483,3181.309z",
    style: {
      fill: "#A86262"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2209.605,2994.757c2.672-57.531-9.171-80.415-55.345-91.141          c-65.091-15.12-103.916,21.837-110.468,68.785c-0.361,2.591-0.596,5.169-0.723,7.733          c-2.74,29.464,28.025,166.665,28.025,166.665s6.227,63.109,54.495,67.901c42.158,4.186,54.289-11.528,60.423-37.291          C2186.361,3175.947,2207.988,3029.575,2209.605,2994.757z",
    style: {
      fill: "#E29888"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2207.893,2918.462c0,0,15.758,19.121,9.479,89.899           c-6.279,70.777-10.56,165.242-16.268,172.092c0,0-6.362,36.279-60.565,41.097c-59.932,5.327-85.842-9.989-89.266-26.542           c-3.425-16.553-18.897-154.112-22.893-196.921c-3.995-42.809,27.112-99.031,95.036-104.168           C2191.34,2888.781,2207.893,2918.462,2207.893,2918.462z",
    style: {
      fill: "#9E5959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2065.523,2989.306c-12.187,9.147-22.069,21.05-30.342,33.762           c1.908-8.314,4.904-16.334,8.388-24.125c-5.453,9.646-12.841,21.612-11.893,32.643c0.698,0.434,1.614,0.174,1.999-0.546           c12.456-19.343,27.115-38.573,47.281-50.362C2075.439,2982.738,2070.274,2985.772,2065.523,2989.306z",
    style: {
      fill: "#8C4E4E"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2068.565,3134.093c3.069-30.984,29.519-54.879,61.178-54.235           c31.659,0.644,57.115,25.596,58.921,56.679c0,0,16.251,61.751,7.437,165.835c-8.814,104.084-38.682,241.935-38.682,241.935           c-0.306,15.05-12.755,27.002-27.805,26.696c-15.05-0.306-27.002-12.755-26.696-27.805c0,0-29.721-118.652-38.645-244.142           C2056.843,3194.582,2068.565,3134.093,2068.565,3134.093z",
    style: {
      fill: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2096.631,3582.709c3.343-20.841,6.003-38.805,6.003-38.805            c-0.176-15.052,11.884-27.396,26.936-27.572c15.052-0.176,27.396,11.884,27.572,26.936c0,0,3.896,26.495,11.31,47.211            c7.415,20.716,26.498,51.909,25.215,64.836c-1.284,12.927-14.357,22.417-69.789,18.659            c-20.765-1.408-45.103-3.246-45.245-15.438C2078.491,3646.343,2093.287,3603.55,2096.631,3582.709z",
    style: {
      fill: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2075.576,3655.02c0,0,0.51,12.432,1.732,15.285c1.223,2.853,34.24,6.114,61.55,6.114             s51.053-7.337,56.149-11.006c2.395-2.293-0.51-18.037-0.51-18.037L2075.576,3655.02z",
    style: {
      fill: "#E1DAEA"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2098.81,3566.976c0,0-5.809,17.426-7.948,25.374s-15.285,39.131-15.285,62.67              c0,0,21.094,7.643,65.116,7.643s53.805-15.285,53.805-15.285s-2.244-15.172-10.547-31.947              c-7.49-15.133-13.91-34.698-22.469-48.455C2161.481,3566.976,2127.547,3550.162,2098.81,3566.976z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2116.779,3569.108c2.981,16.664-1.921,35.577-12.697,47.643               c-0.587-10.846,7.394-19.304,10.135-29.19C2115.909,3581.981,2115.074,3573.482,2116.779,3569.108z",
    style: {
      fill: "#E1DAEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2149.538,3569.123c-0.884,23.528,10.956,29.081,12.224,47.627               C2151.374,3605.226,2145.107,3583.871,2149.538,3569.123z",
    style: {
      fill: "#E1DAEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2098.199,3636.066c23.707-6.716,49.711-7.101,73.37,0               C2147.074,3635.535,2122.719,3635.868,2098.199,3636.066z",
    style: {
      fill: "#E1DAEA"
    }
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2142.461,3077.841c0,0,53.295,3.465,57.167,72.759           c4.411,78.942-0.611,151.021-6.726,234.173s-18.429,133.431-22.098,143.825c0,0-19.107,4.566-37.821,4.566           c-16.595,0-41.511-4.566-41.511-4.566s-22.688-98.58-29.414-167.67c-6.726-69.09-11.923-191.986-9.477-226.225           C2055.028,3100.463,2095.993,3069.892,2142.461,3077.841z",
    style: {
      fill: "#9E5959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2082.096,3181.309c28.694-19.762,69.582-19.003,98.46,0           C2149.07,3168.803,2113.424,3167.974,2082.096,3181.309z",
    style: {
      fill: "#A86262"
    }
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1903.094,2583.507c10.966-30.042,0.305-64.701-29.737-75.666            c-30.042-10.966-60.481,10.832-71.447,40.874c-0.438,1.2-0.829,2.405-1.183,3.613l-81.759,234.754            c-7.074,19.382,2.903,40.829,22.284,47.903s37.338-3.244,52.375-25.499            C1793.627,2809.486,1901.378,2588.209,1903.094,2583.507z",
    style: {
      fill: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1838.476,2717.28l-84.017-32.106l-22.624,64.961l62.129,23.498            c0,0-3.82-17.339-10.579-26.743c0,0,16.799,10.349,34.309,13.14C1824.003,2747.056,1831.116,2732.427,1838.476,2717.28z",
    style: {
      fill: "#E29888"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1838.497,2506.131c0,0-21.816,3.459-37.798,33.901            c-15.229,29.007-43.587,123.315-61.041,170.658c12.676,14.48,38.049,35.025,85.249,46.152            c26.314-53.253,63.965-129.257,76.25-150.979C1927.413,2559.438,1914.435,2483.982,1838.497,2506.131z",
    style: {
      fill: "#FFD9A3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1897.265,2612.964c-28.698-20.126-65.448-30.192-65.448-30.192            s-4.219,40.079-3.164,67.501c1.055,27.422,0,48.516-4.219,67.501c-4.219,18.985-34.805,12.656-47.462,1.055            c-10.665-9.776-8.6-28.539-25.987-40.513c-4.073,12.028-7.91,23.104-11.327,32.373            c12.676,14.481,38.049,35.025,85.249,46.152C1848.862,2708.363,1882.209,2641.036,1897.265,2612.964z",
    style: {
      fill: "#FFC48B"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1794.714,2769.102c0,0-41.695-56.292-63.11-85.278c-21.416-28.986-48.972-68.983-61.29-82           c-10.147-10.723-44.427-0.118-36.413,22.62c8.015,22.738,48.497,109.753,59.782,138.238           c11.285,28.485,22.657,60.543,50.534,72.711C1767.97,2845.763,1810.95,2802.199,1794.714,2769.102z",
    style: {
      fill: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1652.642,2668.298c10.343,22.164,48.906-4.207,43.299-23.733            c-0.09-0.31-20.243-45.782-20.541-60.949c-0.313-15.964,3.694-22.593-8.055-39.825            c-9.995-14.659-16.632-24.57-23.443-25.268c-7.21-0.739-3.702,10.099,1.663,18.186c5.811,8.759,11.996,31.69,1.28,28.24            c-8.531-2.747-34.738-15.937-42.118-21.925c-12.036-9.765-37.368-52.032-50.089-36.71c0,0-8.463-3.839-10.599,6.568            c0,0-11.627,0.576-5.271,15.823c0,0-7.756,3.994-3.471,12.934c2.905,6.059,16.889,27.839,26.618,40.599            s57.67,32.201,72.387,47.486C1638.995,2634.598,1650.278,2663.233,1652.642,2668.298z",
    style: {
      fill: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1652.142,2562.845c-3.612,10.321-9.432,17.924-8.771,29.435             C1636.967,2581.618,1647.871,2571.241,1652.142,2562.845z",
    style: {
      fill: "#EA9A88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1538.769,2528.705c5.341,0.546,8.181,5.778,11.128,9.589             c9.213,11.773,17.406,24.664,27.428,35.585c-13.438-7.284-19.526-23.061-28.482-34.85             C1546.463,2534.844,1543.005,2529.95,1538.769,2528.705z",
    style: {
      fill: "#E08C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.04,2512.883c10.555,3.869,16.11,14.531,22.922,22.746             c6.954,8.125,12.218,18.799,19.498,25.845c-5.167-2.059-8.787-6.798-11.914-11.238             C1564.691,2537.891,1557.574,2520.725,1544.04,2512.883z",
    style: {
      fill: "#E08C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1554.639,2506.314c18.875,8.149,26.918,29.721,40.662,43.526             C1577.845,2540.009,1572.563,2515.077,1554.639,2506.314z",
    style: {
      fill: "#E08C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1583.887,2579.521c22.444-1.109,51.417,1.885,65.462,21.546             C1632.655,2584.155,1606.367,2582.143,1583.887,2579.521z",
    style: {
      fill: "#EA9A88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.766,2549.633c-4.611,2.253-7.158,6.959-9.562,11.272             c-4.693,2.521-6.974,8.061-9.211,12.671c-2.279,0.894-3.062,3.642-3.661,5.782c1.11-2.048,2.547-4.201,4.774-4.786             c2.707-3.888,5.225-9.299,9.439-11.572c3.16-3.549,4.621-9.381,9.011-12.024c1.685-1.965,3.044-4.458,5.423-5.792             C1600.48,2545.875,1598.456,2547.703,1596.766,2549.633z",
    style: {
      fill: "#EA9A88"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2126.215,2588.548c-11.55-31.643-0.321-68.148,31.322-79.697           c31.643-11.55,63.703,11.408,75.253,43.051c0.461,1.264,0.873,2.533,1.247,3.806l86.115,247.26           c7.451,20.414-3.057,43.004-23.472,50.455c-20.414,7.451-39.328-3.417-55.166-26.858           C2241.514,2826.565,2128.023,2593.5,2126.215,2588.548z",
    style: {
      fill: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2230.786,2804.526l49.98-27.441c-14.997-4.285-48.747,10.703-56.398,14.25           C2226.698,2796.126,2228.85,2800.549,2230.786,2804.526z",
    style: {
      fill: "#E29888"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2297.035,2716.076c-21.98-64.498-53.685-152.03-62.539-172.049           c-13.128-29.681-42.809-38.813-42.809-38.813c-79.91-11.416-83.335,54.795-62.786,102.171           c11.457,26.415,46.771,97.884,73.647,152.394C2217.024,2755.943,2256.967,2743.653,2297.035,2716.076z",
    style: {
      fill: "#FFD9A3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2206.54,2758.679c1.618-28.014,4.496-78.109,5.696-100.496           c1.712-31.964-4.376-84.286-4.376-84.286l-73.822,23.212l1.931,25.877c15.311,32.919,43.938,90.871,66.579,136.791           C2203.717,2759.468,2205.052,2759.103,2206.54,2758.679z",
    style: {
      fill: "#FFC48B"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1866.231,2854.534h303.612c-1.2-16.871-1.393-40.498,0.439-62.786           c5.137-62.501,12.272-126.144,12.272-126.144s-29.528-2.134-163.112-2.134c-0.078,0-0.155,0.001-0.233,0.001           c-0.078,0-0.155-0.001-0.233-0.001c-133.585,0-162.91,2.134-162.91,2.134s6.851,93.81,7.706,131.281           C1864.354,2822.442,1865.629,2842.333,1866.231,2854.534z",
    style: {
      fill: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.631,2484.186c-29.683,14.178-86.802,20.088-95.435,24.105           c-8.632,4.018-39.804,42.185,16.785,185.311c26.815,70.81,103.502,59.621,136.911,54.576           c12.315-1.859,24.813-1.839,37.127,0.03c83.151,12.621,109.306-2.362,133.806-54.606           c56.589-143.126,25.417-181.293,16.785-185.311s-66.239-8.858-95.435-24.105c-37.181-19.418-75.293-16.293-75.293-16.293           S1978.132,2467.707,1943.631,2484.186z",
    style: {
      fill: "#F6AF9A"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1974.422,2463.729c0.681-8.806,1.669-23.833,1.86-38.896            c0.298-23.418,7.435-33.128,7.435-33.128c6.226-14.146,20.353-24.029,36.796-24.029c16.443,0,30.57,9.883,36.788,24.029            c0.008,0,7.145,9.71,7.442,33.128c0.191,15.063,1.179,30.09,1.86,38.896c0.432,2.554,0.661,5.178,0.661,7.855            c0,25.82-20.931,46.751-46.751,46.751s-46.751-20.931-46.751-46.751            C1973.762,2468.907,1973.99,2466.283,1974.422,2463.729z",
    style: {
      fill: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2057.302,2391.705c-6.218-14.146-20.346-24.029-36.788-24.029            c-16.443,0-30.57,9.883-36.796,24.029c0,0-7.137,9.71-7.435,33.128c-0.191,15.063-1.179,30.09-1.86,38.896            c-0.432,2.554-0.661,5.178-0.661,7.855c0,0.555,0.023,1.104,0.042,1.655c53.514-0.958,77.28-47.936,77.28-47.936            l13.116-10.024C2062.477,2398.746,2057.308,2391.705,2057.302,2391.705z",
    style: {
      fill: "#EA9A88"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2023.882,2208.645c0,0-71.293-7.454-93.028,53.476s-32.997,175.888,11.641,193.231             c44.95,17.464,93.747-10.094,124.451-44.995c32.313-36.729,49.978-87.42,41.406-129.353             C2100.846,2244.29,2079.884,2214.785,2023.882,2208.645z",
    style: {
      fill: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1966.388,2368.387c0,0,4.864-7.203,23.782-3.529               c15.379,2.987,26.588,7.325,24.791,16.918C2013.832,2394.439,1954.932,2386.215,1966.388,2368.387z",
    style: {
      fill: "#EDA48E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1913.017,2349.835c-0.581,7.568-0.905,15.084-0.934,22.424               c9.804,0.738,21.034,0.674,22.862-4.642C1937.644,2358.042,1925.062,2352.923,1913.017,2349.835z",
    style: {
      fill: "#EDA48E"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1987.596,
    cy: 2345.628,
    rx: 8.737,
    ry: 7.106,
    style: {
      fill: "#121D3F"
    },
    transform: "matrix(0.1622 -0.9868 0.9868 0.1622 -649.4005 3926.3735)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1935.847,
    cy: 2335.14,
    rx: 8.737,
    ry: 7.106,
    style: {
      fill: "#121D3F"
    },
    transform: "matrix(0.1622 -0.9868 0.9868 0.1622 -682.3982 3866.5364)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1950.608,2382.165c-4.471-0.719-10.617-2.398-12.343-6.262              c-0.652-1.46-0.966-3.799,1.243-6.655c8.683-11.231,15.343-30.289,15.409-30.479c0.456-1.319,1.897-2.019,3.217-1.562              c1.319,0.457,2.019,1.897,1.562,3.216c-0.281,0.813-6.992,20.025-16.187,31.918c-0.192,0.249-0.806,1.093-0.625,1.499              c0.776,1.741,6.996,3.374,12.098,3.75c1.392,0.107,2.439,1.314,2.337,2.707c-0.102,1.392-1.313,2.439-2.705,2.338              C1953.73,2382.57,1952.287,2382.435,1950.608,2382.165z",
    style: {
      fill: "#E08C79"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1935.261,2413.523c-0.527-0.206-0.95-0.653-1.102-1.241               c-0.249-0.97,0.329-1.959,1.299-2.212c0.328-0.085,8.105-2.033,15.017,3.5c0.785,0.628,0.911,1.773,0.283,2.557               c-0.628,0.784-1.773,0.912-2.557,0.283c-5.45-4.362-11.573-2.883-11.831-2.818               C1935.988,2413.688,1935.603,2413.656,1935.261,2413.523z",
    style: {
      fill: "#EDA48E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1925.84,2390.211c17.071,3.731,39.112,8.648,46.553,10.31               c1.141,0.255,1.487,1.711,0.583,2.451c-4.138,3.388-14.666,9.716-31.286,4.473               c-10.332-3.259-15.4-11.152-17.406-15.248C1923.766,2391.143,1924.693,2389.96,1925.84,2390.211z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1974.244,2319.486c0,0-2.707,3.093,0.659,5.824s21.904,5.354,30.424,7.32               c8.52,1.967,8.506-3.163-1.247-6.714C1995.605,2322.831,1975.271,2316.686,1974.244,2319.486z",
    style: {
      fill: "#B54C4C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1951.107,2315.761c0,0,1.22,3.925-2.963,5.057s-22.194-3.984-30.78-5.64               s-6.494-6.339,3.861-5.632C1930.223,2310.159,1951.302,2312.785,1951.107,2315.761z",
    style: {
      fill: "#B54C4C"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2015.216,2275.863c0,0,0.078,10.106,7.876,17.992              c7.798,7.886,22.662,10.071,22.89,12.579c0.229,2.508-5.939,16.217-3.642,24.773c2.297,8.556,2.256,30.303,1.863,42.644              c-0.392,12.341,10.231,16.092,7.437,24.269c-2.794,8.177-4.419,14.393,0.354,18.678              c4.773,4.285,6.46,6.154,6.568,11.032s5.34,11.798,6.601,12.695c1.261,0.896,9.327-8.078,14.051-19.128              c4.724-11.05,9.296-23.771,14.842-27.647s8.903-11.43,9.403-18.893c0.5-7.462,1.213-14.438,6.607-19.986              c5.394-5.548,4.95-17.813,7.882-26.339c2.931-8.527,9.89-19.105,9.341-26.978c-0.549-7.872-5.716-9.087-2.816-21.656              c2.9-12.569-9.853-21.183-7.818-28.448s-10.202-21.32-18.653-23.416c-8.45-2.095-15.108-6.714-15.108-6.714              s-2.312-10.577-10.489-13.372c-8.177-2.795-14.742-4.556-23.224-10.694c-8.482-6.138-24.394-8.733-33.618-2.668              c-3.541,1.84-16.567-6.075-27.401-1.043c-10.835,5.033-13.143,12.997-16.897,14.35s-9.134-0.348-15.151,5.763              c-6.017,6.111-6.532,11.552-12.292,14.942c-5.759,3.39-11.245,6.082-14.815,13.149s-0.529,12.69-6.136,17.752              c-5.607,5.062-9.481,8.786-9.997,14.227c-0.516,5.441,9.683,8.22,14.834,7.413c0,0,13.268,3.174,22.476-4.914              c0,0,0.047,6.064,1.369,5.775c1.322-0.289,11.686-3.088,14.664-5.55c0,0-0.455,4.255,0.594,4.666              c1.049,0.41,7.72-2.22,7.72-2.22s-1.002,5.654,0.943,4.802c1.945-0.851,11.048-4.546,14.877-5.064              c3.83-0.518,8.267-3.619,13.358-3.24C2008.803,2275.773,2015.216,2275.863,2015.216,2275.863z",
    style: {
      fill: "#B54C4C"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2069.712,2278.736c-0.021-0.008-0.042-0.017-0.063-0.027               c-0.419-0.204-0.594-0.709-0.39-1.129c4.016-8.258,1.367-15.543-3.324-18.473c-5.609-3.502-4.478-9.845-4.427-10.113               c0.087-0.458,0.529-0.76,0.987-0.672c0.457,0.086,0.759,0.528,0.672,0.986c-0.044,0.238-0.945,5.49,3.662,8.367               c5.332,3.329,8.401,11.489,3.949,20.644C2070.584,2278.717,2070.118,2278.895,2069.712,2278.736z",
    style: {
      fill: "#9C4040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2014.909,2276.65c-0.26-0.102-0.464-0.33-0.522-0.624               c-0.09-0.458,0.208-0.901,0.665-0.991c0.068-0.014,4.618-0.965,8.375-4.781c1.203-1.221,2.03-2.969,2.83-4.66               c1.735-3.667,3.702-7.824,9.907-6.612c0.457,0.088,0.756,0.533,0.667,0.991c-0.089,0.458-0.533,0.756-0.991,0.667               c-4.917-0.96-6.302,1.969-8.057,5.677c-0.86,1.818-1.749,3.697-3.153,5.123c-4.147,4.211-9.046,5.213-9.253,5.253               C2015.215,2276.724,2015.053,2276.707,2014.909,2276.65z",
    style: {
      fill: "#9C4040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2059.867,2231.762c-0.123-0.048-0.236-0.126-0.329-0.232               c-0.306-0.352-0.269-0.885,0.083-1.191c13.595-11.816,23.056-9.929,23.452-9.843c0.455,0.098,0.745,0.549,0.646,1.005               c-0.099,0.455-0.547,0.743-1.002,0.646c-0.108-0.022-9.111-1.725-21.988,9.467               C2060.484,2231.826,2060.151,2231.873,2059.867,2231.762z",
    style: {
      fill: "#9C4040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2108.018,2319.912c-0.188-0.073-0.35-0.213-0.447-0.407               c-2.559-5.098,0.05-13.262,2.608-19.805c2.765-7.072,1.812-14.358-2.617-19.99c-4.723-6.008-3.97-17.293-3.936-17.771               c0.034-0.465,0.438-0.815,0.903-0.782c0.465,0.034,0.815,0.438,0.782,0.903c-0.008,0.11-0.739,11.114,3.579,16.605               c4.808,6.115,5.851,14.006,2.862,21.65c-2.431,6.217-4.932,13.93-2.672,18.433c0.209,0.417,0.041,0.924-0.376,1.134               C2108.481,2319.993,2108.233,2319.997,2108.018,2319.912z",
    style: {
      fill: "#9C4040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2045.675,2307.221c-0.201-0.079-0.372-0.234-0.466-0.448               c-0.187-0.427,0.008-0.925,0.435-1.113c3.069-1.345,10.854-5.665,10.028-9.443c-0.769-3.518-3.215-4.241-8.573-5.827               c-1.78-0.527-3.799-1.124-6.141-1.942c-2.592-0.906-4.418-2.515-5.424-4.785c-2.284-5.152,0.5-11.848,0.62-12.131               c0.182-0.429,0.678-0.63,1.107-0.448c0.429,0.182,0.63,0.677,0.449,1.107c-0.026,0.063-2.618,6.315-0.63,10.793               c0.81,1.824,2.302,3.125,4.434,3.87c2.304,0.804,4.301,1.395,6.063,1.917c5.464,1.617,8.761,2.593,9.744,7.086               c1.267,5.798-9.741,10.8-11.001,11.352C2046.108,2307.302,2045.876,2307.3,2045.675,2307.221z",
    style: {
      fill: "#9C4040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2064.178,2338.236c-0.032-0.013-0.065-0.028-0.096-0.045               c-0.41-0.222-0.562-0.735-0.339-1.145c1.179-2.173,0.666-7.656-3.248-14.56c-4.078-7.193,3.517-15.322,3.843-15.665               c0.322-0.338,0.855-0.352,1.194-0.031c0.338,0.321,0.352,0.856,0.031,1.194c-0.094,0.1-7.051,7.576-3.598,13.668               c3.683,6.498,4.995,13.007,3.263,16.198C2065.021,2338.23,2064.569,2338.388,2064.178,2338.236z",
    style: {
      fill: "#9C4040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2071.257,2397.428c-0.26-0.102-0.464-0.33-0.522-0.624               c-1.039-5.29,2.417-14.709,7.251-19.76c4.037-4.219,7.484-12.217,3.913-20.873c-2.492-6.042,3.991-14.201,4.269-14.546               c0.292-0.363,0.823-0.421,1.187-0.128c0.363,0.292,0.421,0.824,0.129,1.187c-0.062,0.077-6.135,7.725-4.023,12.843               c3.881,9.407,0.134,18.1-4.254,22.685c-4.861,5.079-7.654,13.99-6.814,18.267c0.09,0.458-0.208,0.902-0.666,0.991               C2071.563,2397.502,2071.401,2397.485,2071.257,2397.428z",
    style: {
      fill: "#9C4040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2088.066,2326.62c-0.028-0.011-0.055-0.023-0.082-0.037               c-0.414-0.214-0.576-0.724-0.362-1.138c6.379-12.322,6.458-24.177,3.708-30.459c-2.616-5.975-2.64-6.118-2.641-15.219               c0-0.693,0-1.439-0.002-2.245c-0.017-10.879-8.435-22.531-8.52-22.647c-0.275-0.376-0.193-0.905,0.184-1.18               c0.377-0.275,0.905-0.193,1.18,0.183c0.361,0.493,8.828,12.206,8.846,23.641c0.001,0.807,0.001,1.554,0.001,2.247               c0.001,8.834,0.001,8.834,2.5,14.542c2.911,6.65,2.879,19.097-3.755,31.913               C2088.922,2326.608,2088.463,2326.775,2088.066,2326.62z",
    style: {
      fill: "#9C4040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1991.654,2261.914c-0.035-0.014-0.069-0.03-0.102-0.048               c-0.408-0.226-0.556-0.74-0.33-1.148c2.948-5.328,5.986-6.297,13.918-7.705c7.452-1.323,8.968-3.291,14.61-10.612               l0.049-0.063c6.012-7.802,18.742-4.151,19.281-3.991c0.45,0.134,0.702,0.602,0.571,1.049               c-0.132,0.447-0.601,0.703-1.049,0.571c-0.121-0.035-12.162-3.48-17.465,3.402l-0.049,0.063               c-5.653,7.335-7.557,9.806-15.653,11.244c-7.921,1.407-10.246,2.361-12.735,6.86               C1992.492,2261.91,1992.042,2262.066,1991.654,2261.914z",
    style: {
      fill: "#9C4040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1949.878,2277.013c-0.097-0.038-0.189-0.095-0.27-0.171               c-0.34-0.319-0.358-0.854-0.039-1.194c0.028-0.029,2.79-2.978,5.65-6.227c3.124-3.552,6.175-5.687,12.524-6.093               c0.465-0.03,0.867,0.323,0.897,0.789s-0.323,0.867-0.789,0.897c-5.794,0.371-8.464,2.227-11.364,5.523               c-2.878,3.271-5.658,6.238-5.685,6.267C1950.558,2277.064,1950.19,2277.135,1949.878,2277.013z",
    style: {
      fill: "#9C4040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1965.911,2277.237c-0.308-0.12-0.528-0.416-0.536-0.767               c-0.043-1.96,0.913-5.761,4.839-6.119c4.495-0.41,7.557-3.202,9.334-5.472c0.287-0.367,0.817-0.432,1.186-0.144               c0.367,0.288,0.432,0.818,0.145,1.186c-2.843,3.631-6.478,5.745-10.511,6.113c-3.333,0.304-3.307,4.235-3.304,4.402               c0.008,0.465-0.363,0.85-0.828,0.859C1966.121,2277.297,1966.011,2277.276,1965.911,2277.237z",
    style: {
      fill: "#9C4040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920.472,2278.008c-0.267-0.104-0.474-0.343-0.526-0.646               c-0.087-0.514-0.492-5.146,11.926-9.392c8.893-3.041,8.487-6.347,7.872-11.352c-0.172-1.401-0.35-2.849-0.347-4.433               c0.015-7.946,7.76-8.558,7.838-8.563c0.465-0.031,0.868,0.321,0.899,0.786c0.031,0.465-0.32,0.867-0.784,0.899               c-0.258,0.019-6.252,0.529-6.264,6.881c-0.003,1.479,0.169,2.874,0.334,4.224c0.637,5.189,1.187,9.672-9.002,13.156               c-10.927,3.736-10.813,7.476-10.807,7.512c0.078,0.46-0.232,0.896-0.692,0.973               C1920.763,2278.08,1920.609,2278.062,1920.472,2278.008z",
    style: {
      fill: "#9C4040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1965.54,2247.268c-0.424-0.166-0.641-0.639-0.487-1.07               c0.045-0.126,4.627-12.576,16.024-12.737c5.941-0.084,8.151-1.174,10.101-2.135c1.54-0.759,2.994-1.476,5.819-1.332               c5.505,0.281,11.556-3.101,14.004-6.396c1.542-2.076,5.416-3.759,9.419-4.094c5.348-0.447,10.45,1.378,14.367,5.138               c0.336,0.323,0.347,0.858,0.024,1.194s-0.858,0.347-1.194,0.024c-4.805-4.614-10.243-4.909-13.056-4.674               c-3.965,0.331-7.129,1.97-8.204,3.418c-2.768,3.724-9.302,7.389-15.446,7.075c-2.386-0.122-3.477,0.416-4.986,1.16               c-2.006,0.989-4.502,2.22-10.825,2.31c-10.215,0.144-14.417,11.502-14.458,11.617c-0.158,0.439-0.641,0.667-1.08,0.51               C1965.555,2247.274,1965.548,2247.271,1965.54,2247.268z",
    style: {
      fill: "#9C4040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1967.389,2225.019c-0.391-0.153-0.616-0.576-0.51-0.994               c1.377-5.427,6.207-8.157,13.253-7.49c3.713,0.352,4.51-0.635,6.258-2.796c0.555-0.687,1.185-1.466,2.005-2.316               c3.62-3.752,10.06-3.347,10.332-3.328c0.464,0.033,0.816,0.436,0.784,0.902c-0.032,0.465-0.436,0.816-0.901,0.783               c-0.1-0.007-5.941-0.353-8.999,2.816c-0.769,0.797-1.374,1.545-1.907,2.205c-1.808,2.237-3.115,3.854-7.731,3.416               c-3.602-0.341-9.88,0.013-11.456,6.224c-0.115,0.452-0.574,0.726-1.026,0.611               C1967.455,2225.042,1967.421,2225.031,1967.389,2225.019z",
    style: {
      fill: "#9C4040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2031.505,2207.883c-1.285-0.502-2.405-1.354-3.273-2.785               c-3.815-6.29-14.102-4.323-14.205-4.302c-0.458,0.091-0.902-0.206-0.993-0.663c-0.091-0.458,0.206-0.902,0.663-0.993               c0.47-0.094,11.558-2.207,15.979,5.083c1.67,2.754,4.646,2.714,8.414,2.663c4.531-0.061,10.17-0.137,14.973,5.183               c0.313,0.346,0.285,0.88-0.061,1.193c-0.346,0.313-0.88,0.285-1.193-0.061c-4.291-4.753-9.288-4.685-13.696-4.625               C2035.734,2208.606,2033.434,2208.637,2031.505,2207.883z",
    style: {
      fill: "#9C4040"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2013.153,2342.632l39.787,1.319l-1.863,5.451l-38.631,3.97               C2012.446,2353.372,2014.755,2345.407,2013.153,2342.632z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1973.48,2365.177c-4.503-1.761-7.408-6.217-7.138-11.086                c0.244-4.409,1.016-11.177,3.31-18.381c0.9-2.828,3.579-4.607,6.514-4.327c6.399,0.612,19.343,2.394,34.134,7.447                c3.133,1.072,5.04,4.233,4.521,7.516c-0.72,4.557-1.857,11.008-3.181,15.855c-1.036,3.796-4.227,6.542-8.128,6.996                c-5.825,0.678-15.643,0.574-29.331-3.771C1973.944,2365.35,1973.71,2365.267,1973.48,2365.177z M1975.952,2333.632                c-1.867-0.178-3.572,0.958-4.147,2.763c-2.221,6.978-2.97,13.542-3.207,17.82c-0.226,4.089,2.358,7.813,6.267,9.056                c13.306,4.224,22.781,4.333,28.386,3.681c2.98-0.347,5.417-2.446,6.21-5.347c1.297-4.749,2.417-11.112,3.129-15.613                c0.347-2.196-0.927-4.311-3.02-5.025C1994.997,2335.99,1982.252,2334.235,1975.952,2333.632L1975.952,2333.632z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1913.277,2350.479c-1.805-0.706-3.703-1.488-5.702-2.354                c-2.149-0.932-3.491-3.05-3.419-5.396c0.122-3.95,0.849-11.965,4.356-21.268c1.047-2.777,3.815-4.414,6.731-3.98                c6.357,0.946,19.187,3.405,33.694,9.217c3.081,1.236,4.817,4.491,4.128,7.74c-0.958,4.516-2.431,10.901-4.006,15.673                c-1.233,3.735-4.562,6.31-8.48,6.56C1936.713,2356.917,1928.291,2356.35,1913.277,2350.479z M1914.911,2319.715                c-1.855-0.276-3.617,0.77-4.285,2.543c-3.391,8.997-4.094,16.731-4.212,20.541c-0.044,1.415,0.765,2.692,2.06,3.253                c13.287,5.763,24.937,8.811,31.961,8.364c2.993-0.191,5.536-2.159,6.479-5.014c1.543-4.674,2.995-10.972,3.941-15.433                c0.461-2.173-0.699-4.349-2.759-5.175C1933.795,2323.056,1921.171,2320.646,1914.911,2319.715L1914.911,2319.715z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1949.653,2329.581c-0.363-0.142-0.642-0.467-0.706-0.88                c-0.095-0.616,0.327-1.193,0.944-1.289c13.049-2.016,24.008,3.965,24.467,4.22c0.545,0.303,0.742,0.991,0.439,1.536                c-0.303,0.545-0.988,0.742-1.535,0.439c-0.106-0.059-10.764-5.857-23.026-3.963                C1950.032,2329.676,1949.832,2329.651,1949.653,2329.581z",
    style: {
      fill: "#FFFFFF"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2034.597,2366.467c0,0,6.65-32.463,22.38-26.312c15.731,6.152,6.009,28.95-1.83,42.812               C2047.309,2396.829,2028.828,2395.648,2034.597,2366.467z",
    style: {
      fill: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2044.399,2372.319c-0.459-0.18-0.763-0.648-0.712-1.163                c1.277-12.906,10.375-17.327,10.761-17.509c0.564-0.265,1.238-0.023,1.503,0.541c0.265,0.563,0.024,1.235-0.538,1.501                c-0.34,0.162-8.332,4.106-9.478,15.688c-0.062,0.621-0.614,1.074-1.235,1.013                C2044.594,2372.381,2044.493,2372.356,2044.399,2372.319z",
    style: {
      fill: "#E08C79"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2045.779,2366.478c-0.066-0.026-0.129-0.057-0.191-0.096                c-0.528-0.332-0.688-1.029-0.356-1.557c4.804-7.645,10.508-4.329,10.565-4.293c0.534,0.322,0.706,1.016,0.384,1.551                c-0.321,0.531-1.007,0.706-1.543,0.389c-0.402-0.232-3.968-2.056-7.493,3.556                C2046.852,2366.492,2046.274,2366.671,2045.779,2366.478z",
    style: {
      fill: "#E08C79"
    }
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2197.205,2828.088c-4.704-43.166-13.65-98.285-11.796-116.821          c2.283-22.831,19.787-97.224,22.451-137.369s-10.274-61.264-12.748-63.548c-2.473-2.283-6.849-5.327-17.885-6.849          c-11.035-1.522-61.264-11.606-80.861-19.978c-4.648-1.986-12.407-4.452-13.962-4.941c-0.174-0.055-0.354-0.021-0.497,0.092          c-2.593,2.066-27.763,21.368-63.358,21.368c-35.713,0-60.145-19.044-62.517-20.963c-0.121-0.098-0.279-0.127-0.428-0.079          c-2.728,0.88-28.233,9.085-43.03,13.084c-21.119,5.708-67.353,9.133-74.202,15.982          c-22.261,41.096-0.571,117.011,4.566,138.13c5.137,21.119,9.133,34.818,6.849,53.083          c-2.283,18.265,0.317,119.261-3.108,137.526c0,0-5.137,38.813-14.84,63.928s-13.128,70.777-9.133,81.622          c0,0,35.911-36.53,79.91-36.53c40.062,0,85.589,30.251,119.865,30.251c36.522,0,87.857-30.251,127.856-30.251          c33.466,0,61.42,29.69,68.439,37.81c0.614,0.71,1.775,0.306,1.814-0.632c0.288-7.013,2.756-20.189,0.524-41.174          C2219.182,2923.659,2199.551,2849.62,2197.205,2828.088z",
    style: {
      fill: "#FFD9A3"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1922.726,2597.408c0,0,2.908,92.321,2.908,134.483c0,0,93.774,23.989,194.091,0v-134.483            c0,0-38.527,3.635-93.774,3.635C1970.704,2601.043,1922.726,2597.408,1922.726,2597.408z",
    style: {
      fill: "#FFCB94"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2050.667,
    cy: 2638.843,
    r: 16.719,
    style: {
      fill: "#EDD9B1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1925.634,2731.891c0,0,93.775,23.989,194.091,0v-53.219l-17.446-11.478l-31.258,29.078            l-26.17-7.996l-8.723-9.45l-17.446,19.627l-35.62-43.616l-57.676,50.298            C1925.54,2715.121,1925.634,2724.315,1925.634,2731.891z",
    style: {
      fill: "#FFBF86"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2018.222,2518.48c-10.222,0-19.137-1.273-26.521-2.995           c-23.26-5.424-36.488-16.106-37.039-16.559c-1.014-0.831-1.162-2.325-0.331-3.34c0.831-1.013,2.324-1.161,3.338-0.333           c0.128,0.105,13.091,10.529,35.356,15.667c20.528,4.737,53.427,5.821,93.587-15.917c1.153-0.621,2.592-0.196,3.217,0.958           c0.624,1.153,0.196,2.593-0.957,3.217C2061.65,2513.911,2037.59,2518.48,2018.222,2518.48z",
    style: {
      fill: "#EDC79A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1860.937,2843.112c21.991,28.027,58.033,4.865,85.051,19.627            C1918.083,2852.644,1879.777,2874.857,1860.937,2843.112z",
    style: {
      fill: "#FFC48B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.487,2883.093c31.622-15.422,68.744-12.758,101.843-3.729            c17.63,4.459,33.562,13.545,50.814,18.994C1955.147,2882.724,1902.429,2863.347,1851.487,2883.093z",
    style: {
      fill: "#FFC48B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1962.708,2893.27c21.41,3.346,43.054,5.018,64.697,3.635            C2006.303,2902.67,1983.119,2900.896,1962.708,2893.27z",
    style: {
      fill: "#FFC48B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1865.298,2910.716c22.039-8.849,49.525-11.354,70.513,1.454            C1913.23,2903.635,1888.514,2906.218,1865.298,2910.716z",
    style: {
      fill: "#FFC48B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1956.165,2917.986c23.599,7.085,48.078,15.191,72.693,17.447            C2003.683,2937.526,1978.413,2929.209,1956.165,2917.986z",
    style: {
      fill: "#FFC48B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1849.306,2813.307c4.116,5.552,10.466,7.846,15.993,11.631            C1858.438,2825.625,1849.271,2821.01,1849.306,2813.307z",
    style: {
      fill: "#FFC48B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2087.013,2838.75c28.212-7.196,57.72-14.248,84.324-26.169            C2146.301,2828.578,2116.303,2835.774,2087.013,2838.75z",
    style: {
      fill: "#FFC48B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2070.294,2893.27c36.762-10.152,67.13-35.558,107.586-24.716            C2134.157,2862.692,2109.693,2887.301,2070.294,2893.27z",
    style: {
      fill: "#FFC48B"
    }
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2167.299,2861.693c20.226-20.861,33.668-33.329,59.054-54.733        c24.486-20.645,43.526-35.822,71.057-30.247c27.531,5.575,35.687,63.481,3.481,81.979c0,0-80.659,49.692-111.987,54.373        C2159.818,2917.411,2149.111,2880.451,2167.299,2861.693z",
    style: {
      fill: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2238.228,2882.659c0.703-5.977-2.813-13.36-2.813-13.36s3.516-5.977,3.516-13.359        c0-7.383-6.328-16.524-6.328-16.524s2.461-5.273,1.055-14.063c-1.406-8.789-13.008-6.68-14.414-8.086        c-0.822-0.822,0.038-3.202,0.894-5.041c-21.497,18.311-34.33,30.377-52.839,49.466c-18.188,18.759-7.482,55.719,21.605,51.372        c16.896-2.525,48.139-18.141,73.341-31.995C2252.115,2883.606,2237.772,2886.537,2238.228,2882.659z",
    style: {
      fill: "#EA9A88"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2121.071,2785.366l13.953,133.226c0.024,2.572,14.543,4.52,32.428,4.352          c17.885-0.168,32.365-2.389,32.34-4.961l11.446-133.465L2121.071,2785.366z",
    style: {
      fill: "#9E5959"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2121.632,2790.72c3.297,2.208,22.021,3.748,44.611,3.536           c22.589-0.212,41.281-2.104,44.536-4.374l0.46-5.363l-90.167,0.848L2121.632,2790.72z",
    style: {
      fill: "#B35E5E"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2211.238,2784.518c0.024,2.572-20.141,4.846-45.04,5.081s-45.103-1.661-45.127-4.232            c-0.024-2.572,20.141-4.846,45.04-5.081C2191.01,2780.052,2211.214,2781.947,2211.238,2784.518z",
    style: {
      fill: "#A35656"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2127.139,2787.638c7.809,1.318,22.375,2.118,39.059,1.961s31.232-1.231,39.015-2.695            c-7.809-1.318-22.375-2.118-39.059-1.961C2149.47,2785.099,2134.923,2786.173,2127.139,2787.638z",
    style: {
      fill: "#8B4949"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2229.081,2842.329c0,0,3.146-15.944-2.026-19.569c-5.172-3.625-42.156-3.137-46.772-2.932          c-4.616,0.205-34.649,9.635-39.915,12.568s2.018,10.703,2.018,10.703s-12.96,3.274-13.507,8.31          c-0.547,5.035,13.978,10.943,13.978,10.943s-4.608,9.071-3.582,14.807c1.026,5.737,16.602,9.284,16.602,9.284          s-1.077,10.456,4.13,14.85c5.206,4.394,37.308,6.822,39.65,7.488c2.343,0.667,33.645,7.281,30.229-13.679          c0,0,8.335-11.935-0.009-26.211C2229.876,2868.891,2240.451,2855.315,2229.081,2842.329z",
    style: {
      fill: "#F6AF9A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2142.385,2843.1c22.256-4.087,48.345-11.581,69.243-2.46           c-11.517,1.83-23.029-0.171-34.514-0.144C2166.136,2840.858,2152.126,2843.769,2142.385,2843.1z",
    style: {
      fill: "#E08C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2142.829,2862.12c22.452-3.732,48.769-9.41,69.725-0.706           c-11.603,1.79-23.21,0.102-34.769-0.692c-9.913,0.369-24.862,1.349-34.902,1.864           C2142.615,2862.607,2142.531,2862.164,2142.829,2862.12z",
    style: {
      fill: "#E08C79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2155.857,2886.21c18.593-2.471,41.147-7.261,57.851,1.363           c-10.892,1.907-21.607-0.723-32.415-1.276c-2.322,0.089-8.472,0.207-10.867,0.253c-4.838,0.039-9.677,0.146-14.531,0.127           C2155.626,2886.686,2155.565,2886.249,2155.857,2886.21z",
    style: {
      fill: "#E08C79"
    }
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2657.087,2500.48c0,0-71.154-24.101-110.174,30.987s-91.812,456.764-91.812,499.227           c0,42.463,81.483,67.711,115.913,6.886c34.429-60.825,145.751-352.328,153.785-395.939           C2732.832,2598.03,2726.528,2531.466,2657.087,2500.48z",
    style: {
      fill: "#DE9681"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2715.381,2555.252l-174.718,34.645c0,0,46.987,82.696,50.643,91.894          c2.733,6.876,14.54,179.872,20.327,266.779c45.916-109.87,107.278-274.968,113.166-306.929          C2729.393,2616.701,2729.291,2584.258,2715.381,2555.252z",
    style: {
      fill: "#D38475"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2636.998,2487.846c0,0-88.28-12.274-113.279,82.129          c-24.999,94.403-73.2,399.104-74.348,462.225c-1.147,63.121,73.362,49.754,101.376,33.473          c47.393-27.544,91.24-177.503,114.001-228c22.76-50.497,65.223-165.835,68.093-223.792S2692.646,2492.642,2636.998,2487.846          z",
    style: {
      fill: "#F08875"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2732.841,2613.881c0.028-0.556,0.043-1.114,0.062-1.671l-73.797-56.958l-118.443,34.645          c0,0,37.367,77.924,50.504,104.32c10.008,20.11,17.721,195.426,20.827,277.787c21.913-50.452,40.427-106.98,52.754-134.331          C2687.509,2787.176,2729.971,2671.837,2732.841,2613.881z",
    style: {
      fill: "#E87A66"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2455.101,3030.694c0,0,60.825,417.744,66.563,441.845           c5.738,24.101,56.235,39.02,61.973-8.033s11.477-130.832,14.919-181.329s-4.549-200.784-21.784-256.472           C2559.537,2971.016,2456.248,2957.244,2455.101,3030.694z",
    style: {
      fill: "#DE9681"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2519.53,3461.035c0,0,3.282,24.825-21.966,34.232            c-25.248,9.406-115.912,16.292-123.946,40.393c-8.033,24.101,49.649,27.543,73.026,28.691            c23.377,1.148,50.558-6.886,80.578-4.591c30.02,2.295,66.02,3.443,72.121-14.919s-17.8-54.878-13.883-96.453            S2520.838,3410.511,2519.53,3461.035z",
    style: {
      fill: "#DE9681"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2372.985,3538.302c0,0-1.789,15.504,0,18.947c1.789,3.443,19.004,15.493,64.336,16.641            c45.332,1.148,64.842-6.002,99.845-3.001c35.003,3.001,59.509,0.706,62.176-3.311s1.002-29.276,1.002-29.276H2372.985z",
    style: {
      fill: "#8AA6BF"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2372.19,3541.172c0,0-2.58-14.336,14.635-22.369s105.648-25.479,117.634-32.817             c11.985-7.338,22.953-1.856,28.117,11.75c0,5,28.609,3.497,56.194-9.523c0,0,17.479,41.699,12.088,61.581             c-1.515,6.366-24.619,12.518-55.643,11.04C2514.191,3559.356,2393.706,3581.33,2372.19,3541.172z",
    style: {
      fill: "#CEDDEA"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2439.042,3519.376c0,0,67.935-7.016,95.587-19.77c-1.328-0.446-2.054-1.076-2.054-1.871              c-5.165-13.607-16.132-19.089-28.118-11.75c-8.232,5.04-52.524,14.848-85.038,23.099              C2424.64,3512.535,2432.872,3517.562,2439.042,3519.376z",
    style: {
      fill: "#D6EAFF"
    }
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2449.6,3025.88c0,0-0.611,35.202,8.57,103.296c9.181,68.094,35.768,274.67,36.533,282.322          s-8.18,26.97,5.165,33.856c0,0-10.138,10.903-8.607,21.805c1.53,10.903-17.873,18.431-16.07,28.108          c0,0,41.618,17.558,65.473,14.713c23.855-2.845,42.112-14.757,51.729-12.244c0,0,11.826-10.111,5.748-30.577          c0,0,1.988-7.188,5.224-31.425c3.235-24.237,5.243-340.106-18.221-409.854          C2560.693,2953.203,2448.681,2944.006,2449.6,3025.88z",
    style: {
      fill: "#F08875"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2499.92,3445.217c11.322,3.332,22.871,2.34,34.313,0.005           C2526.24,3453.378,2508.734,3449.778,2499.92,3445.217z",
    style: {
      fill: "#DB705C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2598.227,3467.275c-8.187,6.124-18.396,13.892-29.033,12.29           C2578.576,3475.281,2589.766,3471.96,2598.227,3467.275z",
    style: {
      fill: "#DB705C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2490.082,3473.268c9.292,7.067,20.876,9.107,31.934,11.798           c0.556,0.312,2.451,0.309,2.262,0.966C2512.179,3488.32,2497.632,3481.422,2490.082,3473.268z",
    style: {
      fill: "#DB705C"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M2554.78,3506.748c-0.075,0-0.152-0.006-0.229-0.018c-0.793-0.125-1.334-0.869-1.208-1.662       c19.25-121.926,8.271-261.012,0.253-362.568c-5.003-63.37-8.617-109.156-2.913-126.255       c14.462-43.35,106.1-371.52,107.024-374.83c0.216-0.773,1.014-1.228,1.79-1.009c0.773,0.216,1.225,1.017,1.008,1.79       c-0.924,3.31-92.581,331.549-107.065,374.967c-5.518,16.54-1.735,64.45,3.053,125.106       c8.029,101.701,19.024,240.984-0.281,363.25C2556.1,3506.237,2555.482,3506.748,2554.78,3506.748z",
    style: {
      fill: "#DB705C"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2507.741,2411.728c0,0,7.651,57.382,11.477,91.812         c3.825,34.43,12.241,121.555,97.167,164.066c84.926,42.511,163.731-8.751,178.054-32.336         c21.929-36.11,21.426-85.762,7.654-135.493c-13.772-49.732-40.228-98.08-39.902-181.816         C2762.519,2234.225,2485.059,2260.156,2507.741,2411.728z",
    style: {
      fill: "#DE9681"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2616.385,2667.606c14.516,7.266,28.854,11.792,42.721,14.185v-78.023l-54.256-34.787        c0,0-9.532,45.63-12.614,83.981C2599.51,2658.255,2607.53,2663.174,2616.385,2667.606z",
    style: {
      fill: "#D38475"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2514.213,2500.237c0,0,222.459-32.092,275.917-47.88c0,0,85.592,200.367-59.011,229.434       c-144.604,29.066-194.27-74.188-207.4-119.554C2515.975,2529.423,2514.213,2500.237,2514.213,2500.237z",
    style: {
      fill: "#F08875"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2681.801,2489.003c0,0-84.926,6.886-78.04,113.617          c6.886,106.731,71.154,446.436,89.517,483.16c18.362,36.725,103.288,29.839,112.469-50.497          c9.181-80.335,10.63-326.279,0-425.654C2794.439,2503.923,2747.217,2482.117,2681.801,2489.003z",
    style: {
      fill: "#DE9681"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2678.901,2477.396c0,0-89.536,5.367-80.058,124.292         c9.478,118.925,39.317,269.267,51.367,328.945c12.051,59.678,29.839,138.292,40.742,164.688         c9.9,23.969,51.644,39.594,88.369,4.591c36.725-35.003,32.708-82.057,36.725-126.815s4.334-241.626,0-321.916         C2811.711,2570.89,2798.257,2463.135,2678.901,2477.396z",
    style: {
      fill: "#F08875"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2689.708,3076.642c0,0,103.415,391.306,114.891,415.406           c11.477,24.101,51.644,29.839,55.087-16.067c3.443-45.906-6.386-196.274-8.034-247.892           c-3.443-107.879-25.589-168.495-45.084-200.647C2782.794,2988.231,2673.515,2972.248,2689.708,3076.642z",
    style: {
      fill: "#DE9681"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2797.082,3469.636c0,0,5.34,32.744-22.836,40.776            c-28.177,8.032-99.331,29.838-108.512,44.757s17.371,26.396,42.541,28.691c25.17,2.295,80.258-6.886,118.13-9.181            c37.873-2.295,48.663-9.565,51.614-19.726c5.164-17.789-18.774-50.272-18.332-78.972            C2860.413,3428.928,2795.302,3418.532,2797.082,3469.636z",
    style: {
      fill: "#DE9681"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2663.892,3560.661c0,0-2.372,14.376,0.581,17.245s16.596,11.604,41.972,13.772            c22.415,1.915,92.386-5.723,117.06-7.452c24.674-1.729,49.343-4.59,52.291-7.216c6.813-6.069,2.945-27.217,2.945-27.217            L2663.892,3560.661z",
    style: {
      fill: "#8AA6BF"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2663.892,3560.661c0,0-6.229-10.872,24.187-24.644             c30.416-13.772,80.9-26.354,88.883-30.668c11.094-5.994,12.842-9.905,26.523-6.121             c11.987,3.315,13.879,15.233,13.879,15.233s33.547-5.047,46.527-13.838c4.372-2.479,14.562,29.324,15.349,47.293             c0.882,7.347,0.573,12.745,0.573,12.745s-2.859,9.027-32.157,11.806c-29.299,2.779-53.941,5.252-76.066,7.55             C2749.464,3582.315,2682.738,3596.207,2663.892,3560.661z",
    style: {
      fill: "#CEDDEA"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2803.485,3499.229c-13.682-3.784-15.429,0.126-26.523,6.121              c-6.31,3.409-39.175,11.987-67.695,22.233c6.543,4.39,13.232,9.657,17.542,11.623              c6.312,2.879,90.555-24.744,90.555-24.744S2815.471,3502.544,2803.485,3499.229z",
    style: {
      fill: "#D6EAFF"
    }
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2679.307,3058.221c0,0,85.668,343.33,87.963,354.806          c2.295,11.476-5.941,21.423,6.976,38.255c0,0-6.796,14.537,0,23.718c3.299,4.457-4.32,12.83-7.55,20.266          c-3.423,7.883-2.573,14.713-2.573,14.713s20.744,0.98,45.993,15.517c25.248,14.537,46.064-6.704,62.435-8.325          c6.198-7.192,5.052-23.044,0-37.581c0,0,9.032-8.144,6.198-43.857c-2.834-35.713-3.456-335.31-65.063-427.571          C2762.679,2931.78,2663.877,2970.003,2679.307,3058.221z",
    style: {
      fill: "#F08875"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2774.348,3451.179c9.668,7.979,22.158,10.32,33.123,15.837           C2796.144,3467.987,2781.471,3459.232,2774.348,3451.179z",
    style: {
      fill: "#DB705C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2775.948,3479.685c7.702,6.359,17.795,7.661,26.355,12.355           C2793.465,3493.819,2781.086,3486.128,2775.948,3479.685z",
    style: {
      fill: "#DB705C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2872.657,3479.69c-4.806,5.389-11.063,13.012-18.841,12.471           C2859.279,3487.21,2867.299,3483.703,2872.657,3479.69z",
    style: {
      fill: "#DB705C"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2846.164,3526.402c-0.779,0-1.423-0.616-1.451-1.401        c-11.734-324.124-42.33-413.815-58.767-462.002c-4.039-11.839-7.229-21.191-8.883-30.743        c-1.249-7.212-2.379-13.481-3.376-19.013c-7.967-44.181-8.991-49.858-11.824-206.148        c-3.15-173.742-26.747-266.275-26.985-267.189c-0.202-0.776,0.263-1.57,1.04-1.772c0.78-0.204,1.57,0.264,1.772,1.04        c0.238,0.917,23.922,93.738,27.078,267.868c2.829,156.057,3.848,161.708,11.778,205.686c0.998,5.536,2.13,11.811,3.38,19.032        c1.615,9.327,4.772,18.583,8.77,30.302c16.485,48.327,47.171,138.283,58.92,462.834c0.029,0.802-0.597,1.476-1.399,1.504        C2846.199,3526.401,2846.182,3526.402,2846.164,3526.402z",
    style: {
      fill: "#DB705C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2754.965,2661.707c-0.129,0-0.26-0.017-0.39-0.053c-37.11-10.323-61.432-29.949-75.302-44.596        c-15.055-15.899-21.232-29.174-21.488-29.731c-0.334-0.729-0.014-1.591,0.714-1.926c0.729-0.334,1.592-0.016,1.927,0.714        c0.061,0.133,6.284,13.476,21.045,29.039c13.607,14.346,37.472,33.573,73.882,43.701c0.773,0.215,1.225,1.016,1.01,1.79        C2756.186,2661.286,2755.602,2661.707,2754.965,2661.707z",
    style: {
      fill: "#DB705C"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2550.361,2087.605c0,0-55.659-34.776-94.321,37.398s-78.303,213.611-89.33,257.499          c-11.028,43.887,40.689,64.369,70.363,29.832c29.674-34.536,100.075-188.089,116.052-225.801          C2569.102,2148.82,2577.943,2107.131,2550.361,2087.605z",
    style: {
      fill: "#DE9681"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2422.858,2201.266c-9.422,25.218-18.345,51.803-26.267,76.95         c9.81,6.986,37.147,25.475,58,30.214l-1.175,20.571c0,0-28.212,9.992-41.142,2.939c-7.969-4.347-19.281-12.038-26.792-17.304         c-8.596,29.094-15.192,53.621-18.771,67.865c-3.565,14.188-0.567,25.924,6.118,34.152c0.066-1.129,0.066-1.841,0.066-1.841         s15.869-7.053,32.914-6.465c7.159,0.247,17.84,3.71,27.825,7.641c1.174-1.145,2.324-2.356,3.44-3.655         c22.594-26.297,68.797-121.587,96.611-182.21C2500.938,2215.097,2456.924,2205.848,2422.858,2201.266z",
    style: {
      fill: "#D38475"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2544.706,2063.979c0,0-56.628-7.673-92.742,60.987          c-32.813,62.385-63.914,133.042-63.914,133.042s55.369,50.655,126.358,57.545          C2514.408,2315.553,2619.332,2093.871,2544.706,2063.979z",
    style: {
      fill: "#EFDFDA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2456.383,2300.328c17.274,7.284,36.962,13.181,58.025,15.225         c0,0,19.033-40.216,35.121-88.698l-13.474-104.847l-58.466-1.378c0,0-10.695,34.502-14.293,69.364         C2460.511,2216.971,2457.571,2275.313,2456.383,2300.328z",
    style: {
      fill: "#EBCEC5"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2220.154,2493.423c0,0-13.004,5.951-16.931,9.165c-3.066,2.509-14.411,21.328-19.983,27.669         c-5.572,6.341-12.874,10.376-19.215,17.101s-9.992,11.721-14.027,15.948s-11.913,1.345-11.145-5.764         s6.725-22.289,10.568-26.901s13.354-18.625,10.856-27.08c-1.345-3.651-54.518-12.913-92.979-29.957         c0-2.882,7.377-13.097,16.024-14.634c8.647-1.537,12.874,0.769,12.874,0.769s14.027-6.341,24.403-2.882         c0,0,8.839-4.612,17.293-2.882c0,0,8.647-1.537,14.411,1.153c5.764,2.69,13.642,4.419,14.795,4.227         c1.153-0.192,30.856-17.958,40.271-21.033c9.415-3.074,22.369,5.853,28.133,18.151         C2241.268,2468.77,2245.06,2486.37,2220.154,2493.423z",
    style: {
      fill: "#DE9681"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2421.695,2424.944c0,0-180.185,69.265-234.778,75.031s-45.788-25.842-7.333-47.379          c35.713-20.002,70.205-40.518,99.002-55.218c46.868-23.925,85.389-50.299,113.916-51.939          C2421.028,2343.799,2459.627,2388.07,2421.695,2424.944z",
    style: {
      fill: "#DE9681"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2392.502,2345.439c-28.527,1.64-67.048,28.015-113.916,51.939         c-3.991,2.037-8.102,4.197-12.3,6.44c2.447,5.492,8.613,13.957,23.737,16.283c0,0,1.763,11.167,2.938,12.93         c1.176,1.763,47.02,8.816,75.82-2.939c4.114-4.114,4.114-15.281,4.114-15.281s15.869-7.053,32.914-6.465         c6.353,0.219,15.481,2.97,24.434,6.334C2452.645,2380.355,2418.419,2343.949,2392.502,2345.439z",
    style: {
      fill: "#D38475"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2694.406,2024.241c-47.031-8.201-95.437-1.351-138.659,18.922           c-27.5,12.899-46.475,25.784-60.281,47.232c-24.235,37.651-15.393,151.596-6.704,192.855           c8.689,41.259,14.852,102.151,19.589,124.308s111.833,19.153,155.362,6.624c43.529-12.53,95.334-34.969,99.297-77.864           c4.675-50.598,6.876-82.049,11.608-127.838C2792.224,2038.113,2707.206,2026.473,2694.406,2024.241z",
    style: {
      fill: "#DE9681"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2782.72,2129.536c-1.059-44.37-70.75-97.695-93.649-46.053c0,0-22.123,59.289-45.8,131.903          c-12.66,38.827-21.542,72.222-25.716,88.698c-1.724,6.803-6.918,12.184-13.656,14.146l-113.618,33.088          c7.943,23.434,15.579,44.584,18.071,56.239c0,0,3.801,27.139,7.493,55.277c52.65-10.265,179.254-33.381,193.107-45.892          C2750.75,2379.192,2783.778,2173.906,2782.72,2129.536z",
    style: {
      fill: "#EA9A88"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2566.986,1988.5c0,0,3.798,45.308-5.243,66.6c-9.041,21.292,26.038,32.537,48.409,31.241           s56.133-15.511,58.823-42.676c2.69-27.165-13.305-16.157-13.791-89.604           C2654.804,1896.607,2557.952,1932.324,2566.986,1988.5z",
    style: {
      fill: "#DE9681"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2617.159,1974.4c0.151-0.368,10.939-24.612,11.214-28.982          c0.49-7.775-0.107-14.609-1.594-20.575c-27.921,0.084-65.581,27.673-59.794,63.657c0,0,1.302,15.549,0.564,32.71          C2598.063,2012.385,2606.229,2001.129,2617.159,1974.4z",
    style: {
      fill: "#D38475"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2565.248,2038.957c0,0-15.266,22.304,10.657,21.753          c52.276-1.111,88.143-42.509,88.143-42.509s52.143-8.207,92.587,33.416s33.902,124.511,34.111,156.071          s34.529,284.401,41.394,364.406c0,0-41.712,16.82-122.004,23.663c-80.292,6.843-178.13-6.424-201.909-7.846          c0,0,0.525-43.673,0.441-58.733c-0.502-90.115-17.765-168.994-21.608-200.774c-8.244-68.18-22.238-153.714-9.429-212.149          C2494.689,2059.736,2565.248,2038.957,2565.248,2038.957z",
    style: {
      fill: "#EFDFDA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2736.529,2292.765c0,0,37.589-142.797,31.668-182.323         c-5.921-39.527-55.419-74.526-85.544-55.529c0,0-33.264,19.948-57.453,62.545c-24.189,42.597-57.264,115.094-57.264,115.094         l20.523,12.531l-21.524,80.69l-74.086,40.035c4.849,29.862,11.111,70.417,14.096,116.084         c41.119-14.254,139.593-49.42,157.615-65.347c22.897-20.236,55.807-128.56,55.807-128.56L2736.529,2292.765z",
    style: {
      fill: "#EBCEC5"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2591.512,1740.093c0,0-60.536-0.73-84.415,55.427            c-23.879,56.157-10.547,98.205-8.647,121.22c1.9,23.014,3.308,32.681,2.44,35.421c-0.868,2.739-2.576,10.035,1.628,11.608            l0.462,8.138c0,0-2.669,5.383,1.45,7.366c0,0,0.925,3.483,0.505,11.85c-0.42,8.367,4.354,23.745,21.088,24.585            c16.734,0.84,69.146-19.029,81.283-33.933s27.295-31.022,51.207-53.901c31.358-30.005,39.917-86.695,24.93-128.638            C2668.457,1757.292,2614.199,1737.936,2591.512,1740.093z",
    style: {
      fill: "#DE9681"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2495.444,1894.576c0,0-1.191,14.28-6.906,27.088c-5.716,12.808-8.468,17.121-5.342,19.528            c3.126,2.407,7.75,1.702,10.218,2.664c2.468,0.963,5.525,1.405,7.492,0.354            C2500.906,1944.21,2505.621,1922.057,2495.444,1894.576z",
    style: {
      fill: "#DE9681"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2508.114,1936.275c0,0-1.691-10.072,6.61-13.731c7.587-3.344,36.929-8.319,42.271,1.664           s-8.429,18.913-20.6,19.368S2509.416,1944.344,2508.114,1936.275z",
    style: {
      fill: "#D38475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2503.433,1868.422c0,0-4.126,1.371-4.55,4.524c-0.423,3.152-0.362,8.845,1.889,9.147           c2.252,0.302,13.724-3.2,21.5-3.073c6.472,0.106,14.718,1.291,18.801,1.147c0.942-0.033,1.472-1.105,0.912-1.864           c-1.517-2.057-4.892-5.505-11.024-6.643c-7.327-1.359-9.456-1.269-14.295-2.102           C2511.827,1868.724,2506.424,1867.998,2503.433,1868.422z",
    style: {
      fill: "#20355E"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2512.15,
    cy: 1900.453,
    rx: 5.383,
    ry: 8.692,
    style: {
      fill: "#121D3F"
    },
    transform: "matrix(0.9997 -0.0251 0.0251 0.9997 -46.8476 63.5669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2502.519,1963.768l0.462,8.138c15.865,0.077,26.195-9.38,26.195-9.38           C2523.154,1963.217,2502.519,1963.768,2502.519,1963.768z",
    style: {
      fill: "#FFFFFF"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2496.67,1828.309c0,0-15.337-14.687-18.606-29.574          c-3.662-16.677,7.346-39.855,18.358-48.717c11.011-8.863,29.897,3.901,41.822,1.549s46.302-21.924,88.606-10.326          c42.304,11.598,65.364,44.958,67.514,61.506c0,0,11.703,37.335,4.383,74.954c-7.319,37.619-32.794,81.034-35.592,93.851          c-2.798,12.817-5.055,16.365-6.308,16.302c-6.619-0.33-28.864-16.444-33.107-27.556s-24.238-30.6-27.786-47.604          c-2.786-13.35-27.106-37.277-36.059-54.378c-8.954-17.101-12.427-23.169-12.427-23.169S2519.734,1838.246,2496.67,1828.309z          ",
    style: {
      fill: "#20355E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2547.468,1835.146c11.292-0.758,22.152-4.853,31.961-10.335          c10.267-5.46,21.94-8.164,33.531-8.458c11.557-0.321,23.065,1.503,34.217,4.381c9.538,1.848,24.07,7.456,33.075,3.296          c-4.948,4.246-16.969,2.089-23.165,1.427c-14.54-2.598-29.156-6.047-44.023-5.459c-11.171,0.267-22.24,2.601-32.377,7.354          C2570.456,1832.44,2558.978,1835.9,2547.468,1835.146z",
    style: {
      fill: "#1C2E54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2561.683,1861.54c0,0,2.215,41.03,1.326,52.117c0,0,4.905,9.271,9.663-0.728          c2.922-6.141,7.167-28.052,9.148-37.727C2583.801,1865.528,2561.683,1861.54,2561.683,1861.54z",
    style: {
      fill: "#20355E"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2568.994,1899.285c0,0,6.237-32.628,28.667-27.692c22.43,4.935,3.704,53.199-4.554,60.048          C2584.848,1938.489,2563.164,1934.815,2568.994,1899.285z",
    style: {
      fill: "#DE9681"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2592.662,1901.272c0.144-0.743-0.342-1.462-1.086-1.607         c-2.958-0.573-5.728,0.619-7.791,1.991c1.503-4.436,3.867-8.417,7.353-8.371c0.757,0.01,1.38-0.596,1.389-1.353         c0.01-0.757-0.595-1.38-1.353-1.39c-10.14-0.135-12.137,19.833-12.217,20.682c-0.055,0.587,0.268,1.123,0.77,1.365         c0.143,0.069,0.3,0.113,0.466,0.129c0.754,0.071,1.423-0.483,1.494-1.236c0.124-1.311,0.393-3.162,0.83-5.183         c0.901-0.956,4.703-4.685,8.537-3.942C2591.798,1902.502,2592.517,1902.016,2592.662,1901.272z",
    style: {
      fill: "#C97565"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2744.499,2056.606c0,0-59.353-31.618-93.777,44.891         c-34.424,76.509-64.958,223.892-73.131,269.535c-8.173,45.642,43.82,62.343,71.715,24.943         c27.895-37.4,91.336-198.757,105.004-238.436C2767.979,2117.858,2774.073,2074.618,2744.499,2056.606z",
    style: {
      fill: "#DE9681"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2736.543,2043.613c0,0-45.798-15.014-83.428,39.055         c-37.63,54.069-59.823,146.867-59.823,146.867s60.383,40.848,129.103,44.923c0,0,58.241-127.438,50.217-183.5         C2764.748,2050.031,2736.543,2043.613,2736.543,2043.613z",
    style: {
      fill: "#EFDFDA"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2285.293,2289.403l13.954,133.226c0.024,2.572,14.542,4.52,32.428,4.352         c17.885-0.168,32.364-2.389,32.34-4.961l11.446-133.465L2285.293,2289.403z",
    style: {
      fill: "#9E5959"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2285.854,2294.757c3.297,2.208,22.021,3.748,44.611,3.536          c22.589-0.212,41.281-2.104,44.536-4.374l0.46-5.363l-90.167,0.848L2285.854,2294.757z",
    style: {
      fill: "#B35E5E"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2375.46,2288.555c0.024,2.572-20.141,4.846-45.04,5.081s-45.103-1.661-45.127-4.232           s20.141-4.846,45.04-5.081C2355.232,2284.089,2375.436,2285.984,2375.46,2288.555z",
    style: {
      fill: "#A35656"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2291.361,2291.675c7.809,1.318,22.375,2.118,39.059,1.961           c16.684-0.157,31.232-1.231,39.015-2.695c-7.809-1.318-22.375-2.118-39.059-1.961S2299.145,2290.21,2291.361,2291.675z",
    style: {
      fill: "#8B4949"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2618.334,2417.865c0,0-190.344-9.201-242.683-25.764           c-52.339-16.563-31.62-42.006,12.24-46.355c40.733-4.039,80.553-9.038,112.826-10.985           c52.526-3.17,98.383-11.925,125.182-2.012C2652.698,2342.662,2667.853,2399.252,2618.334,2417.865z",
    style: {
      fill: "#DE9681"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2441.144,2340.573c0,0-18.329,2.849-25.241,2.76            c-6.912-0.089-33.814-21.763-40.387-23.444c-6.573-1.68-31.702,0.442-39.92,2.57c-8.218,2.128-9.615,7.375-3.608,11.707            c6.007,4.332,21.745,4.641,31.157,4.709s11.233,3.229,9.928,5.446c-1.305,2.217-29.741,13.338-35.08,14.971            c-5.339,1.633-41.213-4.36-50.739-3.898c-9.525,0.462-15.523,7.777-7.073,12.354c0,0-10.017,1.466-11.301,6.183            c-1.284,4.717,7.488,9.084,7.488,9.084s-13.098,9.404,2.626,14.978c0,0-6.358,6.406,7.87,12.493            c14.228,6.086,43.341,12.578,51.296,14.276s38.599-19.765,41.93-22.381c3.331-2.616,42.326-3.43,55.26-4.273            c12.934-0.844,36.554-17.997,31.326-41.571C2461.449,2332.963,2453.566,2338.234,2441.144,2340.573z",
    style: {
      fill: "#DE9681"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2402.626,2350.828c3.249,12.573,2.606,32.121-9.69,38.683             C2400.248,2375.159,2403.267,2366.158,2402.626,2350.828z",
    style: {
      fill: "#D38475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2381.198,2401.682c1.4-2.144,3.212-4.517,5.601-5.535             c3.487-0.292,3.791,1.242,1.421,3.286c-2.19,0.919-4.594,1.397-6.775,2.51             C2381.286,2402.024,2381.106,2401.833,2381.198,2401.682z",
    style: {
      fill: "#D38475"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2280.181,2367.748c15.522,2.403,31.783,5.209,47.293,7.745             c9.309,1.362,18.331-1.711,27.628-3.277c-5.581,4.258-15.42,6.899-23.177,7.4c-4.916-0.059-9.63-1.963-14.427-2.871             C2305.802,2373.723,2290.621,2371.413,2280.181,2367.748z",
    style: {
      fill: "#D38475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2276.368,2383.015c9.673,1.9,41.358,8.457,50.552,9.764             c8.132,1.058,16.77-1.127,24.794-0.931c-7.793,3.184-16.774,5.533-25.37,4.593c-2.488-0.366-10.38-2.534-12.941-3.155             C2301.778,2389.966,2286.668,2387.11,2276.368,2383.015z",
    style: {
      fill: "#D38475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2278.994,2397.993c11.027,2.205,23.14,4.573,34.162,7.009             c11.154,2.355,22.225,5.703,33.721,3.164c-3.701,3.387-11.721,4.298-17.321,3.986             c-5.853-0.671-11.398-2.908-17.078-4.368C2302.025,2404.522,2288.176,2401.841,2278.994,2397.993z",
    style: {
      fill: "#D38475"
    }
  }))))), /*#__PURE__*/React.createElement("polygon", {
    points: "2373.927,2306.432 2315.219,2312.73 2323.184,2340.143 2370.846,2342.361        ",
    style: {
      fill: "#9E5959"
    }
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.abb074c73474ec5a3ba045b2df34ef93.svg";
export { ForwardRef as ReactComponent };